import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import React, { useState, useEffect, Component, useRef, useContext, useLayoutEffect } from 'react';
import { makeStyles as makeStyles$1, withStyles, Typography as Typography$1, useTheme as useTheme$1, Icon as Icon$1, CircularProgress, Dialog as Dialog$1, DialogTitle as DialogTitle$1, DialogContentText, DialogContent as DialogContent$1, DialogActions as DialogActions$1, Button as Button$1, TableFooter, TableRow, TablePagination, Collapse as Collapse$1, TableCell, Checkbox as Checkbox$2, IconButton as IconButton$1, TableBody, Input as Input$2, FormControl as FormControl$1, Select as Select$3, MenuItem as MenuItem$1, TableHead, TableSortLabel, Table } from '@material-ui/core';
import { connect, Provider } from 'react-redux';
import { makeStyles, useTheme, withStyles as withStyles$1, emphasize } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import moment from 'moment';
import i18n from 'i18next';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from '@material-ui/core/Icon';
import Collapse from '@material-ui/core/Collapse';
import { ExpandLess, ExpandMore, Visibility, VisibilityOff } from '@material-ui/icons';
import { withRouter, Link, Redirect } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Menu$1 from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import makeStyles$2 from '@material-ui/core/styles/makeStyles';
import { withSnackbar, useSnackbar } from 'notistack';
import { Helmet } from 'react-helmet';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import LinearProgress from '@material-ui/core/LinearProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import useMediaQuery$1 from '@material-ui/core/useMediaQuery';
import TextField$1 from '@material-ui/core/TextField/TextField';
import Dropzone$1 from 'react-dropzone';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox$1 from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select$1 from '@material-ui/core/Select';
import Autocomplete$1 from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import SliderMaterial from '@material-ui/core/Slider';
import Select$2 from 'react-select';
import NoSsr from '@material-ui/core/NoSsr';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import CancelIcon from '@material-ui/icons/Cancel';
import Button$1$1 from '@material-ui/core/Button/Button';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker, KeyboardTimePicker } from '@material-ui/pickers';
import FormHelperText from '@material-ui/core/FormHelperText';
import '@material-ui/core/DialogContentText';
import Icon$1$1 from '@material-ui/core/Icon/Icon';
import CircularProgress$1 from '@material-ui/core/CircularProgress';
import Input$1 from '@material-ui/core/Input';
import FilterList from '@material-ui/icons/FilterList';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Skeleton from '@material-ui/lab/Skeleton';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import IconButton$1$1 from '@material-ui/core/IconButton/IconButton';
import ReactDOM from 'react-dom';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function symbolObservablePonyfill(root) {
  var result;
  var Symbol = root.Symbol;

  if (typeof Symbol === 'function') {
    if (Symbol.observable) {
      result = Symbol.observable;
    } else {
      result = Symbol('observable');
      Symbol.observable = result;
    }
  } else {
    result = '@@observable';
  }

  return result;
}
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = symbolObservablePonyfill(root);
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */

var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */


function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[result] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[result] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */


function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(source, true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */


function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */


function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2$1({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */


function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

function toVal(mix) {
  var k,
      y,
      str = '';

  if (mix) {
    if (typeof mix === 'object') {
      if (!!mix.push) {
        for (k = 0; k < mix.length; k++) {
          if (mix[k] && (y = toVal(mix[k]))) {
            str && (str += ' ');
            str += y;
          }
        }
      } else {
        for (k in mix) {
          if (mix[k] && (y = toVal(k))) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else if (typeof mix !== 'boolean' && !mix.call) {
      str && (str += ' ');
      str += mix;
    }
  }

  return str;
}

function clsx() {
  var i = 0,
      x,
      str = '';

  while (i < arguments.length) {
    if (x = toVal(arguments[i++])) {
      str && (str += ' ');
      str += x;
    }
  }

  return str;
}

var CBReactKitStateClass =
/*#__PURE__*/
function () {
  function CBReactKitStateClass(REACT_KIT_SETTINGS, store) {
    _classCallCheck(this, CBReactKitStateClass);

    _defineProperty(this, "APP_NAME", "");

    _defineProperty(this, "STATE_KEY_LOCAL_STORAGE", "");

    _defineProperty(this, "BASE_URL", "");

    _defineProperty(this, "BEARER_KEY", "");

    if (CBReactKitStateClass.instance) {
      return CBReactKitStateClass.instance;
    }

    CBReactKitStateClass.instance = this;
    this.APP_NAME = REACT_KIT_SETTINGS.APP_NAME;
    this.STATE_KEY_LOCAL_STORAGE = REACT_KIT_SETTINGS.STATE_KEY_LOCAL_STORAGE;
    this.BASE_URL = REACT_KIT_SETTINGS.BASE_URL;
    this.BEARER_KEY = REACT_KIT_SETTINGS.BEARER_KEY;
    this.REDUX_STORE = store;
    this.ENVIRONMENTS = REACT_KIT_SETTINGS.ENVIRONMENTS;
    this.TRANSLATE = REACT_KIT_SETTINGS.TRANSLATE;
    console.debug('@cobrains/react-kit', this);
    return this;
  }

  _createClass(CBReactKitStateClass, [{
    key: "getAppName",
    value: function getAppName() {
      return this.APP_NAME;
    }
  }, {
    key: "getStateKeyLocalStorage",
    value: function getStateKeyLocalStorage() {
      return this.STATE_KEY_LOCAL_STORAGE;
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl() {
      return this.BASE_URL;
    }
  }, {
    key: "getBearerKey",
    value: function getBearerKey() {
      return this.BEARER_KEY;
    }
  }, {
    key: "getReduxStore",
    value: function getReduxStore() {
      return this.REDUX_STORE;
    }
  }, {
    key: "getEnvironments",
    value: function getEnvironments() {
      return this.ENVIRONMENTS;
    }
  }]);

  return CBReactKitStateClass;
}();

function CBReactKitState(SETTINGS, store) {
  return new CBReactKitStateClass(SETTINGS, store);
}

var translationEN = require("./locales/en/translation.json");

var translationIT = require("./locales/it/translation.json"); // not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init


var i18nReactKit = i18n.createInstance({
  lng: 'it',
  debug: false,
  resources: {
    en: {
      translation: translationEN
    },
    it: {
      translation: translationIT
    }
  },
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default

  },
  parseMissingKeyHandler: function parseMissingKeyHandler(key) {
    return "TRANSLATION_NOT_FOUND";
  }
}, function (err) {
  if (err) return console.log('something went wrong loading', err);
}); // The method we'll use instead of a regular string

function translateWithReactKit(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return i18nReactKit.t(name, params);
}

function getUsernameShort(name, surname) {
  var shortName;
  var initials;

  if (surname !== '' && surname !== null && surname !== undefined) {
    shortName = "".concat(name, " ").concat(surname);
    initials = shortName.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  } else {
    //
    shortName = name;
    initials = shortName.charAt(0).toUpperCase();
  }

  return initials;
}
/**
 * @description return the string of the browser active
 * @return {string} browser user agent data string
 */


function getBrowserUserAgent() {
  return navigator.userAgent;
}
/**
 * @description return the string of the device
 * @return {string} device string
 */


function getDeviceType() {
  if (navigator.userAgent.match(/Android/i)) {
    return 'Device Android';
  }

  if (navigator.userAgent.match(/webOS/i)) {
    return 'Web OS mobile';
  }

  if (navigator.userAgent.match(/iPhone/i)) {
    return 'iPhone';
  }

  if (navigator.userAgent.match(/iPad/i)) {
    return 'iPad';
  }

  if (navigator.userAgent.match(/iPod/i)) {
    return 'iPod';
  }

  if (navigator.userAgent.match(/BlackBerry/i)) {
    return 'Blackberry';
  }

  if (navigator.userAgent.match(/Windows Phone/i)) {
    return 'Windows Phone';
  }

  return 'Desktop';
}
/**
 * @description: function given operator and media ('xs','sm', ecc...) gives boolean
 * @legend: {
 * 0 : null
 * 25 : "xs"
 * 50 : "sm"
 * 75 : "md"
 * 100 : "lg"
 * }
 */


function getBreakpoints(operation, media) {
  var currentMedia = 0;

  if (window.innerWidth <= 425) {
    currentMedia = 25;
  }

  if (window.innerWidth <= 768 && window.innerWidth > 425) {
    currentMedia = 50;
  }

  if (window.innerWidth <= 1440 && window.innerWidth > 768) {
    currentMedia = 75;
  }

  if (window.innerWidth > 1440) {
    currentMedia = 100;
  }

  var userMedia = 0;

  switch (media) {
    case 'xs':
      userMedia = 25;
      break;

    case 'sm':
      userMedia = 50;
      break;

    case 'md':
      userMedia = 75;
      break;

    case 'lg':
      userMedia = 100;
      break;

    default:
      userMedia = 0;
  }

  if (operation === 'down') return currentMedia <= userMedia;
  if (operation === 'up') return currentMedia >= userMedia;
  if (operation === 'eq') return currentMedia === userMedia;
  return false;
}
/**
 * @description Convert hex to rgba
 * @param {hex} String color hex code
 * @param {opacity} Float opacity
 * @return {rgba} String rgba
 */


function hexToRgbA(hex, opacity) {
  var c;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');

    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    c = "0x".concat(c.join(''));
    return "rgba(".concat([c >> 16 & 255, c >> 8 & 255, c & 255].join(','), ",").concat(opacity, ")");
  }

  throw new Error('Bad Hex');
}
/**
 * @description return a random text
 * @return {string} random string
 */


function getRandomText(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789      ';
  var charactersLength = characters.length;

  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

function isEmpty(e) {
  switch (e) {
    case "":
    case 0:
    case "0":
    case null:
    case false:
    case typeof this === "undefined":
      return true;

    default:
      return false;
  }
}
/**
 * @description return if object is empty
 * @return {boolean} device string
 */


function isEmptyObject(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }

  return true;
}
/**
 * @description return a unique id
 * @return {string} unique id string
 */


function ID() {
  return "_".concat(Math.random().toString(36).substr(2, 9));
}
/**
 * return a operator string from a key
 * @param key
 * @returns {string|boolean}
 */

/*
  eq          -->      Implement the == operator.
  le          -->      Implement the <= operator.
  lt          -->      Implement the < operator.
  gt          -->      Implement the > operator.
  ge          -->      Implement the >= operator.
  ne          -->      Implement the != operator.
  contains    -->      Implement the contain operator.
  icontains   -->      Implement the contain operator without consider the upper and lower case.
  startswith  -->      Implement the startswith operator.
  istartswith -->      Implement the startswith operator without consider the upper and lower case.
  endswith    -->      Implement the endswith operator.
  iendswith   -->      Implement the endswith operator without consider the upper and lower case.
  in          -->      Select the object contained in a list(separated by '','')
  between     -->      Produce the between clause given the lower and upper range(separated by '','').
*/


function getFieldRefCondition(key, param1, param2) {
  if (param1 && param2) switch (key) {
    case 'eq':
      return param1 == param2;

    case 'le':
      return param1 <= param2;

    case 'lt':
      return param1 < param2;

    case 'gt':
      return param1 > param2;

    case 'ge':
      return param1 >= param2;

    case 'ne':
      return param1 != param2;

    case 'contains':
      return Array.isArray(param2) && param2.findIndex(function (item) {
        return item === param1;
      }) !== -1;
    // TODO: require implementation

    /* case 'icontains': return true;
    case 'icontains': return true;
    case 'startswith': return true;
    case 'istartswith': return true;
    case 'endswith': return true;
    case 'iendswith': return true;
    case 'in': return true;
    case 'between': return true; */

    default:
      return true;
  }
  return false;
}
/**
 * transform any type of string on camelCase (ex. first_name > firstName)
 * @param str
 * @returns {string}
 */


function camelcase(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}
/**
 * convert all properties of array of object in camelCase (ex. first_name > firstName)
 * @param arr
 * @returns {*}
 */


function arrayObjToCamelCase(arr) {
  var newK;
  arr.forEach(function (a) {
    Object.keys(a).forEach(function (k) {
      newK = k.replace(/(\_\w)/g, function (m) {
        return m[1].toUpperCase();
      });

      if (newK !== k) {
        a[newK] = a[k];
        delete a[k];
      }
    });
  });
  return arr;
}
/**
 * get dark/light of hex color
 * @param hex
 * @param lum
 * @returns {string}
 */


function colorLuminance(hex, lum) {
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');

  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  lum = lum || 0; // convert to decimal and change luminosity

  var rgb = "#";
  var c;
  var i;

  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += "00".concat(c).substr(c.length);
  }

  return rgb;
}
/**
 * @description Returned the date in ISO String DD-MM-YYYY
 * @param {date} Date date
 * @return {date iso} ISO String DD-MM-YYYY
 */


function getDateISO(date) {
  return moment(new Date(date)).format('YYYY-MM-DD');
}

function getDateTimeISO(date) {
  return moment(new Date(date)).format('YYYY-MM-DD HH:mm');
}
/**
 * @description Returned the date in ISO String DD-MM-YYYYThh:mm:ssZ
 * @param {time} Date date
 * @return {date iso} ISO String DD-MM-YYYYThh:mm:ssZ
 */


function getTimeISO(date) {
  return new Date(date).toISOString();
}
/**
 * Remove duplicates in array using a comp key
 * @param arr
 * @param comp
 * @returns {*}
 */


function getUnique(arr, comp) {
  var unique = arr.map(function (e) {
    return e[comp];
  }) // store the keys of the unique objects
  .map(function (e, i, final) {
    return final.indexOf(e) === i && i;
  }) // eliminate the dead keys & store unique objects
  .filter(function (e) {
    return arr[e];
  }).map(function (e) {
    return arr[e];
  });
  return unique;
}
/**
 * Find value in object splitting node with .
 * @param data
 * @param keyName
 * @returns {*}
 */


function findValueByKeyName(data, keyName) {
  var findValue = '';

  if (keyName && keyName.split('.').length > 0) {
    var split = keyName.split('.');

    for (var i = 0; i < split.length; i++) {
      if (data) {
        data = data[split[i]];
      }
    }

    findValue = data;
  } else {
    findValue = data[keyName];
  }

  return findValue;
}
/**
 *
 * @param value
 * @param keyName
 * @returns {string}
 */


function findValueByKeyNameArray(value, keyName) {
  if (Array.isArray(keyName)) {
    var tmpKey = _toConsumableArray(keyName);

    var combinedValue = [];
    tmpKey.map(function (item) {
      return combinedValue = [].concat(_toConsumableArray(combinedValue), [value[item]]);
    });
    combinedValue = combinedValue.join(' ');
    if (combinedValue === ' ') combinedValue = null;
    return combinedValue;
  }
}
/**
 * Return the actual hour standard format (hh:mm:ss)
 * @param
 * @returns {string}
 */


function getActualTime() {
  var d = new Date();
  var s = d.getSeconds();
  var m = d.getMinutes();
  var h = d.getHours();
  return "".concat(h, ":").concat(m, ":").concat(s);
}

function scorePassword(pass) {
  var score = 0;

  if (!pass) {
    return score;
  }

  var letters = {};

  for (var i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }

  var variations = {
    digitals: /\d/.test(pass),
    lowerCaseLetters: /[a-z]/.test(pass),
    upperCaseLetters: /[A-Z]/.test(pass),
    nonSpaceWords: /\W/.test(pass)
  };
  var variationCount = 0;

  for (var check in variations) {
    variationCount += variations[check] === true ? 1 : 0;
  }

  score += (variationCount - 1) * 10;
  return parseInt(score, 10);
}
/**
 * check password strength
 * @param pass
 * @returns {number}
 */


function checkStrength(pass) {
  var score = scorePassword(pass);

  if (score >= 80) {
    return 100;
  }

  if (score >= 60) {
    return 80;
  }

  if (score >= 40) {
    return 60;
  }

  if (score >= 20) {
    return 40;
  }

  if (score <= 10) {
    return 20;
  }

  return 0;
}

function sortValues(value) {
  if (value) {
    return value.sort(function (a, b) {
      var labelA = typeof a.label === 'string' ? a.label.toUpperCase() : a.label ? a.label.toString() : null;
      var labelB = typeof b.label === 'string' ? b.label.toUpperCase() : b.label ? b.label.toString() : null;

      if (labelA === null) {
        return 1;
      }

      if (labelB === null) {
        return -1;
      }

      if (labelA < labelB) {
        return -1;
      }

      if (labelA > labelB) {
        return 1;
      }

      if (labelA === labelB) {
        return 0;
      }

      return 0;
    });
  } else return [];
}

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      maxWidth: 360
    },
    nested: {
      paddingLeft: theme.spacing(4)
    },
    item: function item(props) {
      return {
        color: props.color
      };
    },
    boldText: {
      '& span': {
        fontWeight: 600
      }
    }
  };
});

function SidebarRoutes(props) {
  var classes = useStyles(props);
  var background = props.background,
      collapseLuminance = props.collapseLuminance;

  var _React$useState = React.useState(-1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleClick = function handleClick(i) {
    if (i === open) setOpen(-1);else {
      setOpen(i);
      props.setOpen();
    }
  };

  var ListIcon = function ListIcon(props) {
    return React.createElement(ListItemIcon, {
      style: {
        paddingLeft: 8
      }
    }, props.children);
  };

  var SidebarItem = function SidebarItem(props) {
    var item = props.item,
        _props$icon = props.icon,
        collapseStyle = props.collapseStyle;

    function setContainerColor() {
      if (props.location && props.location.pathname === item.path) return props.activeRouteBackground;
    }

    function setChildColor() {
      if (props.location && props.location.pathname === item.path) return props.activeRouteColor;
      return props.color;
    }

    return React.createElement(Link, {
      to: item.path,
      style: {
        textDecoration: 'none',
        color: 'inherit'
      }
    }, React.createElement(ListItem, {
      button: true,
      style: _objectSpread2({
        backgroundColor: setContainerColor()
      }, collapseStyle)
    }, React.createElement(ListIcon, null, typeof item.icon !== 'function' ? React.createElement(Icon, {
      className: classes.item,
      style: {
        color: setChildColor()
      }
    }, item.icon) : item.icon(setChildColor())), React.createElement(ListItemText, {
      className: classes.item,
      primary: item.name,
      style: {
        color: setChildColor()
      }
    })));
  };

  function setContainerColor(item, defaultColor) {
    if (props.location && props.location.pathname === item.path) {
      // TODO: active route
      return props.activeRouteBackground;
    }

    return defaultColor;
  }

  return React.createElement(List, {
    component: "nav",
    className: classes.root
  }, props.menu && props.menu.map(function (item, index) {
    return !item.collapse ? React.createElement(SidebarItem, _extends({
      key: "sidebar-item-".concat(index),
      item: item
    }, props)) : React.createElement(React.Fragment, {
      key: "sidebar-item-".concat(index)
    }, React.createElement(ListItem, {
      button: true,
      onClick: function onClick() {
        return handleClick(index);
      }
    }, React.createElement(ListIcon, null, typeof item.icon !== 'function' ? React.createElement(Icon, {
      className: classes.item
    }, item.icon) : item.icon(props.color)), React.createElement(ListItemText, {
      className: "".concat(classes.item, " ").concat(classes.boldText),
      primary: item.name
    }), open === index ? React.createElement(ExpandLess, {
      className: classes.item,
      style: {
        fontSize: 14,
        marginLeft: -22
      }
    }) : React.createElement(ExpandMore, {
      className: classes.item,
      style: {
        fontSize: 14,
        marginLeft: -22
      }
    })), React.createElement(Collapse, {
      in: open === index,
      timeout: "auto",
      unmountOnExit: true
    }, item.collapse.map(function (collapseItem, index) {
      return React.createElement(SidebarItem, _extends({
        key: "sidebar-collapse-item-".concat(index),
        item: collapseItem,
        collapseStyle: {
          backgroundColor: !props.activeRouteBackground ? colorLuminance(background, collapseLuminance) : setContainerColor(collapseItem)
        }
      }, props, {
        icon: true
      }));
    })));
  }));
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    environment: state.environment
  };
};

var AppBarSidebarRoutes = connect(mapStateToProps)(withRouter(SidebarRoutes));
/**
 * Logout user
 * @returns {Promise<unknown>}
 */

function logout() {
  var cbstate = CBReactKitState();
  var localStorageKey = cbstate.getStateKeyLocalStorage();
  return new Promise(function (resolve, reject) {
    try {
      console.log('CALL LOGOUT');
      var localState = JSON.parse(localStorage.getItem(localStorageKey));

      if (localState.auth) {
        localState.auth.user = {};
      }

      cbstate.REDUX_STORE.auth.user = {};
      localStorage.setItem(localStorageKey, JSON.stringify(localState));
      resolve('Logout success');
    } catch (e) {
      console.warn('LOGOUT', e);
      reject(e);
    }
  });
}
/**
 * Return the access token
 * @returns {string|*}
 */


function getAccessToken() {
  var cbstate = CBReactKitState();
  var localStorageKey = cbstate.getStateKeyLocalStorage();

  try {
    var localState = JSON.parse(localStorage.getItem(localStorageKey));
    if (localState && localState.auth && localState.auth.user && localState.auth.user.access_token) return localState.auth.user.access_token;
    return null;
  } catch (e) {
    console.warn('GET_TOKEN', e);
    return false;
  }
}
/**
 * Return the refresh token
 * @returns {string|*}
 */


function getRefreshToken() {
  var cbstate = CBReactKitState();
  var localStorageKey = cbstate.getStateKeyLocalStorage();

  try {
    var localState = JSON.parse(localStorage.getItem(localStorageKey));
    if (localState && localState.auth && localState.auth.user && localState.auth.user.refresh_token) return localState.auth.user.refresh_token;
    return null;
  } catch (e) {
    console.warn('GET_REFRESH_TOKEN', e);
    return false;
  }
}
/**
 * Set the user on Local Storage
 * @param data
 * @returns {boolean}
 */


function setRefreshedUser(data) {
  var cbstate = CBReactKitState();
  var localStorageKey = cbstate.getStateKeyLocalStorage();

  try {
    var localState = JSON.parse(localStorage.getItem(localStorageKey));
    localState.auth.user.access_token = data.access_token;
    cbstate.REDUX_STORE.auth.user.access_token = data.access_token;
    localStorage.setItem(localStorageKey, JSON.stringify(localState));
    console.debug('SET_REFRESHED_USER', localState);
    return true;
  } catch (e) {
    console.warn('SET_REFRESHED_USER', e);
    return false;
  }
}
/**
 * Return if user is logged
 * @param props
 * @returns {Promise<unknown>|boolean}
 */


function isAuthenticated(props) {
  var _props$verifyToken = props.verifyToken,
      verifyToken = _props$verifyToken === void 0 ? true : _props$verifyToken;
  var cbstate = CBReactKitState();
  var localStorageKey = cbstate.getStateKeyLocalStorage();
  var baseUrl = cbstate.getBaseUrl();
  var defaultHeaders = {
    'Content-Type': 'application/json'
  };
  var authenticationVerify = {
    'Authorization': "".concat(cbstate.getBearerKey(), " ").concat(getAccessToken())
  };
  var authenticationRefresh = {
    'Authorization': "".concat(cbstate.getBearerKey(), " ").concat(getRefreshToken())
  };

  var headersVerify = _objectSpread2({}, defaultHeaders, {}, authenticationVerify);

  var headersRefresh = _objectSpread2({}, defaultHeaders, {}, authenticationRefresh); // check if have to verify the token using props verifyToken


  if (verifyToken) {
    return new Promise(function (response, reject) {
      try {
        var localState = JSON.parse(localStorage.getItem(localStorageKey));
        var auth = localState.auth;
        var tokensExists = auth && auth.user && getAccessToken() && getRefreshToken();

        if (tokensExists) {
          // Verify Token Api Call
          axios({
            method: 'post',
            url: "".concat(baseUrl, "user/auth/verify/"),
            data: {},
            headers: headersVerify
          }).then(function (res) {
            if (process.env.NODE_ENV === 'development') console.debug('VERIFY_TOKEN', res.data);
            response(true);
          }, function (errorVerifyToken) {
            if (process.env.NODE_ENV === 'development') console.warn('VERIFY_TOKEN', errorVerifyToken); // Refresh Token Api Call

            axios({
              method: 'post',
              url: "".concat(baseUrl, "user/auth/refresh/"),
              data: {},
              headers: headersRefresh
            }).then(function (res) {
              if (process.env.NODE_ENV === 'development') console.debug('REFRESH_TOKEN', res.data);
              setRefreshedUser(res.data);
              response(true);
            }, function (errorRefreshToken) {
              if (process.env.NODE_ENV === 'development') console.warn('REFRESH_TOKEN', errorRefreshToken);
              logout();
              response(false);
            });
          });
        } else {
          logout().then(function () {
            return window.location.href = '/signin';
          });
          reject(false);
        }
      } catch (e) {
        console.warn('IS_AUTHENTICATED', e);
        reject(false);
      }
    });
  } // TODO: control if a token exist


  return true;
}

var drawerWidth = 300;
var useStyles$1 = makeStyles$1(function (theme) {
  var _buttonIcon;

  return {
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      boxShadow: 'unset',
      maxHeight: '58px',
      borderBottom: "2px solid ".concat(theme.palette.primary.main),
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarShift: {
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    buttonIcon: (_buttonIcon = {
      // width: theme.spacing(7) + 1,
      margin: '0px 24px',
      padding: 4,
      color: theme.palette.primary.main,
      width: '22px !important',
      height: '22px !important'
    }, _defineProperty(_buttonIcon, theme.breakpoints.up('sm'), {
      width: theme.spacing(9) + 1
    }), _defineProperty(_buttonIcon, "transition", theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })), _buttonIcon),
    iconButtonSpacing: {
      padding: 4,
      margin: 4
    },
    hide: {
      display: 'none'
    }
  };
});

function AppToolbar(props) {
  var open = props.open,
      sidebar = props.sidebar;
  var onDrawerOpen = props.onDrawerOpen;
  var _props$hasAvatar = props.hasAvatar,
      hasAvatar = _props$hasAvatar === void 0 ? true : _props$hasAvatar,
      _props$avatarBackgrou = props.avatarBackground,
      avatarBackground = _props$avatarBackgrou === void 0 ? '#fff' : _props$avatarBackgrou,
      _props$avatarColor = props.avatarColor,
      avatarColor = _props$avatarColor === void 0 ? '#000' : _props$avatarColor;
  var classes = useStyles$1();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      logoutRedirect = _useState4[0],
      setLogoutRedirect = _useState4[1];

  var isMenuOpen = Boolean(anchorEl);
  var _props$padding = props.padding,
      padding = _props$padding === void 0 ? 12 : _props$padding;

  var AppBarMenu = function AppBarMenu() {
    return props.menu();
  };

  function handleMenuClose() {
    setAnchorEl(null);
  }

  var UserMenu = function UserMenu() {
    return React.createElement(Menu$1, {
      anchorEl: anchorEl,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      id: "appbar-profile-menu",
      keepMounted: true,
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      open: isMenuOpen,
      onClose: handleMenuClose,
      style: {
        textAlign: 'center'
      }
    }, React.createElement("div", {
      style: {
        minWidth: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }
    }, React.createElement(Avatar, {
      style: {
        background: avatarBackground,
        color: avatarColor,
        fontSize: 28,
        width: 60,
        height: 60,
        marginBottom: 8,
        marginTop: 12
      }
    }, props.user && props.user.first_name && props.user.last_name ? getUsernameShort(props.user.first_name, props.user.last_name) : getUsernameShort(props.user.username)), props.user.first_name && props.user.first_name ? React.createElement(Typography, {
      style: {
        fontWeight: 600
      }
    }, props.user.first_name, ' ', props.user.last_name) : React.createElement(Typography, {
      style: {
        fontWeight: 600
      }
    }, props.user.username), React.createElement(Typography, {
      style: {
        color: '#606060',
        fontSize: 11
      }
    }, props.user.email), React.createElement(Button, {
      variant: "outlined",
      style: {
        marginTop: 12
      },
      onClick: function onClick() {
        logout().then(function () {
          return setLogoutRedirect(true);
        });
      }
    }, "Logout")));
  };

  return React.createElement(AppBar, {
    position: "fixed",
    className: clsx(classes.appBar, _defineProperty({}, classes.appBarShift, open)),
    style: _objectSpread2({
      color: props.color ? props.color : null,
      background: props.background ? props.background : null
    }, props.style)
  }, React.createElement(Toolbar, {
    disableGutters: true
  }, sidebar && React.createElement(IconButton, {
    className: classes.buttonIcon,
    color: "inherit",
    "aria-label": "open drawer",
    onClick: function onClick() {
      return onDrawerOpen();
    }
  }, React.createElement(MenuIcon, null)), React.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      flexDirection: props.swap ? 'row-reverse' : 'row',
      paddingLeft: padding
    }
  }, props.title && React.createElement(Typography, {
    variant: "h6",
    noWrap: true,
    style: {
      marginLeft: 8,
      fontWeight: 600
    }
  }, props.title), React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }), props.logo && React.createElement(Link, {
    to: "/"
  }, React.createElement("img", {
    src: props.logo,
    alt: "logo",
    style: {
      width: 120
    }
  })), props.menu && React.createElement(AppBarMenu, null)), hasAvatar && React.createElement("div", {
    style: {
      display: 'flex',
      paddingRight: padding
    }
  }, React.createElement(IconButton, {
    edge: "end",
    "aria-label": "account of current user",
    "aria-controls": "appbar-profile-menu",
    "aria-haspopup": "true",
    className: classes.iconButtonSpacing,
    onClick: function onClick(e) {
      return setAnchorEl(e.currentTarget);
    },
    color: "inherit"
  }, React.createElement(Avatar, {
    style: {
      background: avatarBackground,
      color: avatarColor
    }
  }, props.user && props.user.first_name && props.user.last_name ? getUsernameShort(props.user.first_name, props.user.last_name) : getUsernameShort(props.user.username))))), props.user ? React.createElement(UserMenu, null) : null, logoutRedirect && React.createElement(Redirect, {
    to: "/logout"
  }));
}

var mapStateToProps$1 = function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
};

var AppToolbar$1 = compose(connect(mapStateToProps$1))(AppToolbar);
var drawerWidth$1 = 240;
var useStyles$2 = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex'
    },
    drawer: function drawer(props) {
      return {
        width: drawerWidth$1,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        position: 'absolute',
        background: props.sidebarProps.background
      };
    },
    drawerOpen: function drawerOpen(props) {
      return {
        width: drawerWidth$1,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        }),
        background: props.sidebarProps.background
      };
    },
    drawerClose: function drawerClose(props) {
      return {
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: theme.spacing(9) + 1,
        background: props.sidebarProps.background
      };
    },
    drawerCloseMobile: function drawerCloseMobile(props) {
      return {
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: 0,
        background: props.sidebarProps.background
      };
    },
    toolbar: _objectSpread2({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1)
    }, theme.mixins.toolbar, {
      minHeight: "56px!important"
    }),
    content: {
      paddingLeft: getBreakpoints('down', 'sm') ? 0 : theme.spacing(9) + 1,
      flexGrow: 1,
      maxWidth: '100%'
    }
  };
});

function AppBarSidebar(props) {
  var _clsx, _clsx2;

  var classes = useStyles$2(props);
  var theme = useTheme();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      _setOpen = _React$useState2[1];

  var appbarProps = props.appbarProps,
      sidebarProps = props.sidebarProps;
  var appbarIsActive = !isEmptyObject(appbarProps);
  var sidebarIsActive = !isEmptyObject(sidebarProps);
  var _sidebarProps$openOnH = sidebarProps.openOnHover,
      openOnHover = _sidebarProps$openOnH === void 0 ? true : _sidebarProps$openOnH;
  return React.createElement("div", {
    className: classes.root,
    style: props.style
  }, React.createElement(CssBaseline, null), appbarIsActive && React.createElement(AppToolbar$1, _extends({
    open: open,
    sidebar: sidebarIsActive ? _objectSpread2({}, sidebarProps) : null
  }, appbarProps, {
    onDrawerOpen: function onDrawerOpen() {
      return _setOpen(!open);
    }
  })), sidebarIsActive && React.createElement(Drawer, {
    variant: "permanent",
    className: clsx(classes.drawer, (_clsx = {}, _defineProperty(_clsx, classes.drawerOpen, open), _defineProperty(_clsx, getBreakpoints('down', 'sm') ? classes.drawerCloseMobile : classes.drawerClose, !open), _clsx)),
    classes: {
      paper: clsx((_clsx2 = {}, _defineProperty(_clsx2, classes.drawerOpen, open), _defineProperty(_clsx2, getBreakpoints('down', 'sm') ? classes.drawerCloseMobile : classes.drawerClose, !open), _clsx2))
    },
    PaperProps: openOnHover && {
      onMouseOver: function onMouseOver() {
        return _setOpen(true);
      },
      onMouseLeave: function onMouseLeave() {
        return _setOpen(false);
      }
    },
    open: open
  }, React.createElement("div", {
    className: classes.toolbar
  }, React.createElement(IconButton, {
    onClick: function onClick() {
      return _setOpen(false);
    }
  }, theme.direction === 'rtl' ? React.createElement(ChevronRightIcon, null) : React.createElement(ChevronLeftIcon, null))), React.createElement(AppBarSidebarRoutes, _extends({
    setOpen: function setOpen() {
      return _setOpen(true);
    },
    menu: sidebarProps.menu,
    background: sidebarProps.background
  }, sidebarProps, {
    color: sidebarProps.color
  }))), React.createElement("main", {
    className: classes.content,
    style: !sidebarIsActive ? {
      paddingLeft: 0
    } : null,
    onClick: function onClick() {
      return _setOpen(false);
    }
  }, React.createElement("div", {
    className: classes.toolbar
  }), props.children));
}

var mapStateToProps$2 = function mapStateToProps(state) {
  return {
    environment: state.environment
  };
};

var AppBarSidebar$1 = connect(mapStateToProps$2)(AppBarSidebar);

function AppBarSidebarLayout(props) {
  var envSettings = props.environment.settings;
  return React.createElement(React.Fragment, null, React.createElement(AppBarSidebar$1, {
    appbarProps: _objectSpread2({}, envSettings.appbar),
    sidebarProps: _objectSpread2({}, envSettings.sidebar)
  }, props.children));
}

var mapStateToProps$3 = function mapStateToProps(state) {
  return {
    environment: state.environment
  };
};

var AppBarSidebarLayout$1 = compose(withStyles({
  withTheme: true
}), connect(mapStateToProps$3))(AppBarSidebarLayout);

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.suspense_list") : 60120,
      r = b ? Symbol.for("react.memo") : 60115,
      t = b ? Symbol.for("react.lazy") : 60116,
      v = b ? Symbol.for("react.fundamental") : 60117,
      w = b ? Symbol.for("react.responder") : 60118,
      x = b ? Symbol.for("react.scope") : 60119;

  function y(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case d:
          return u;
      }
    }
  }

  function z(a) {
    return y(a) === m;
  }

  exports.typeOf = y;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = t;
  exports.Memo = r;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === v || a.$$typeof === w || a.$$typeof === x);
  };

  exports.isAsyncMode = function (a) {
    return z(a) || y(a) === l;
  };

  exports.isConcurrentMode = z;

  exports.isContextConsumer = function (a) {
    return y(a) === k;
  };

  exports.isContextProvider = function (a) {
    return y(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return y(a) === n;
  };

  exports.isFragment = function (a) {
    return y(a) === e;
  };

  exports.isLazy = function (a) {
    return y(a) === t;
  };

  exports.isMemo = function (a) {
    return y(a) === r;
  };

  exports.isPortal = function (a) {
    return y(a) === d;
  };

  exports.isProfiler = function (a) {
    return y(a) === g;
  };

  exports.isStrictMode = function (a) {
    return y(a) === f;
  };

  exports.isSuspense = function (a) {
    return y(a) === p;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      Object.defineProperty(exports, '__esModule', {
        value: true
      }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE);
      }
      /**
       * Forked from fbjs/warning:
       * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
       *
       * Only change is we use console.warn instead of console.error,
       * and do nothing when 'console' is not supported.
       * This really simplifies the code.
       * ---
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var lowPriorityWarningWithoutStack = function lowPriorityWarningWithoutStack() {};

      {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.warn(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        lowPriorityWarningWithoutStack = function lowPriorityWarningWithoutStack(condition, format) {
          if (format === undefined) {
            throw new Error('`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(void 0, [format].concat(args));
          }
        };
      }
      var lowPriorityWarningWithoutStack$1 = lowPriorityWarningWithoutStack;

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            lowPriorityWarningWithoutStack$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.typeOf = typeOf;
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isValidElementType = isValidElementType;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
    })();
  }
});
unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
var reactIs_1 = reactIs.isValidElementType;
var reactIs_2 = reactIs.isContextConsumer;
var reactIs_3 = reactIs.ForwardRef;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function printWarning$1() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
var useStyles$3 = makeStyles$2(function (theme) {
  return {
    root: {}
  };
});

function DefaultLayout(props) {
  var classes = useStyles$3(props);
  return React.createElement("div", _extends({
    className: classes.root
  }, props), props.children);
}

DefaultLayout.propTypes = {
  /** can receive general <div> props */
  props: propTypes.object
};
var useStyles$4 = makeStyles$2(function (theme) {
  return {
    root: {
      padding: theme.page.padding
    },
    subtitle: {
      margin: '12px 0',
      color: theme.palette.gray.dark
    }
  };
});

function TitleSubtitleLayout(props) {
  var classes = useStyles$4(props);
  var title = props.title,
      subtitle = props.subtitle;
  return React.createElement("div", {
    className: classes.root
  }, title && React.createElement(Typography$1, {
    variant: "h5",
    style: !subtitle ? {
      marginBottom: 24
    } : null
  }, title), subtitle && React.createElement(Typography$1, {
    variant: "subtitle2",
    className: classes.subtitle
  }, subtitle), props.children);
}

TitleSubtitleLayout.propTypes = {
  /** can receive general <div> props */
  props: propTypes.object,

  /** Title of layout */
  title: propTypes.string,

  /** Subtitle of layout */
  subtitle: propTypes.string
};
var ADD_MESSAGE = 'ADD_MESSAGE';

function addMessage(message) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null; // eslint-disable-next-line no-param-reassign

  message = {
    id: ID(),
    label: message,
    variant: variant
  };
  return {
    type: ADD_MESSAGE,
    payload: {
      message: message
    }
  };
}

var REMOVE_MESSAGE = 'REMOVE_MESSAGE';

function removeMessage(id) {
  return {
    type: REMOVE_MESSAGE,
    payload: {
      id: id
    }
  };
}

function MessagesProvider(props) {
  var cbstate = CBReactKitState();

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  useEffect(function () {
    setInterval(function () {
      var reduxStore = cbstate.REDUX_STORE;

      if (reduxStore.messages.length > 0) {
        reduxStore.messages.map(function (message, index) {
          enqueueSnackbar(message.label, {
            variant: message.variant,
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right'
            }
          });
          props.onRemoveMessage(message.id);
        });
      }
    }, 1000);
  });
  return React.createElement(React.Fragment, null, props.children);
}

var mapStateToProps$4 = function mapStateToProps(state) {
  return {
    messages: state.messages
  };
};

var mapActionsToProps = {
  onRemoveMessage: removeMessage
};
MessagesProvider.propTypes = {
  /** messages from redux state */
  messages: propTypes.array.isRequired
};
var MessagesProvider$1 = compose(withSnackbar, connect(mapStateToProps$4, mapActionsToProps))(MessagesProvider);

function SeoProvider(props) {
  var cbstate = CBReactKitState();
  var title = props.seo && props.seo.title ? "".concat(cbstate.APP_NAME, " - ").concat(props.seo.title) : cbstate.APP_NAME;
  var path = props.seo && props.seo.path;
  var description = props.seo && props.seo.description;
  return React.createElement(React.Fragment, null, React.createElement(Helmet, null, React.createElement("meta", {
    charSet: "utf-8"
  }), title && React.createElement("title", null, title), path && React.createElement("link", {
    rel: "canonical",
    href: path
  }), description && React.createElement("meta", {
    name: "description",
    content: description
  })));
}

var mapStateToProps$5 = function mapStateToProps(state) {
  return {
    environment: state.environment
  };
};

SeoProvider.propTypes = {
  /** environment object to get routes */
  environment: propTypes.object.isRequired
};
var SeoProvider$1 = compose(connect(mapStateToProps$5))(SeoProvider);

function initLayout(activeRoute) {
  if (activeRoute && activeRoute.layout) {
    return activeRoute.layout;
  }

  return null;
}

function PageProvider(props) {
  var routes = props.environment.routes;
  var activeRoute = routes.filter(function (route) {
    return route.path === props.match.path;
  })[0];
  var seoEnvSettings = activeRoute && activeRoute.seo;
  var LayoutPageEnv = initLayout(activeRoute);
  var Component = activeRoute && activeRoute.component;
  return React.createElement("div", null, React.createElement(SeoProvider$1, {
    seo: seoEnvSettings
  }), LayoutPageEnv ? React.createElement(LayoutPageEnv, null, React.createElement(Component, props), props.children) : React.createElement(DefaultLayout, null, React.createElement(Component, props), props.children));
}

var mapStateToProps$6 = function mapStateToProps(state) {
  return {
    environment: state.environment
  };
};

PageProvider.propTypes = {
  /** environment object to get routes */
  environment: propTypes.object.isRequired
};
var PageProvider$1 = compose(connect(mapStateToProps$6))(PageProvider);
var SET_ENVIRONMENT_WITH_USER_TYPE = 'SET_ENVIRONMENT_WITH_USER_TYPE';

function setEnvironmentWithUserType(userType) {
  var cbstate = CBReactKitState();
  var Environments = cbstate.getEnvironments();
  var env = Environments.notAuthenticated;

  if (userType) {
    var envName = Object.keys(Environments).filter(function (item) {
      return Environments[item].type === userType;
    })[0];

    if (envName) {
      env = Environments[envName];
    } else {
      if (process.env.NODE_ENV === 'development') alert("ENV_TYPE_NOT_FOUND: environment-action.js cannot be find the env type ".concat(userType, " \n           - Define it in the Environment.js"));
      console.error('ENV_TYPE_NOT_FOUND', "environment-action.js cannot be find the env type ".concat(userType, " - Define it in the Environment.js"));
    }
  }

  return {
    type: SET_ENVIRONMENT_WITH_USER_TYPE,
    payload: {
      environment: env
    }
  };
}

function UserProvider(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLogged = _useState2[0],
      setIsLogged = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isPending = _useState4[0],
      setIsPending = _useState4[1];

  useEffect(function () {
    init();
  }, []);

  function init() {
    return _init.apply(this, arguments);
  }

  function _init() {
    _init = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var isAuth, setStatusIsLogged;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setStatusIsLogged = function _ref(status) {
                if (!status) props.onSetEnvWithUserType();
                setIsLogged(status);
                setIsPending(false);
              };

              setIsPending(true);

              if (isEmptyObject(props.auth && props.auth.user)) {
                _context.next = 9;
                break;
              }

              _context.next = 5;
              return isAuthenticated({
                verifyToken: props.verifyToken
              });

            case 5:
              isAuth = _context.sent;

              if (isAuth) {
                setStatusIsLogged(true);
                props.onSetEnvWithUserType(props.auth.user.type);
              } else {
                setStatusIsLogged(false);
              }

              _context.next = 10;
              break;

            case 9:
              setStatusIsLogged(false);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _init.apply(this, arguments);
  }

  return !isPending && props.children(_objectSpread2({}, props, {
    isLogged: isLogged,
    isPending: isPending
  }));
}

var mapStateToProps$7 = function mapStateToProps(state) {
  return {
    auth: state.auth
  };
};

var mapActionsToProps$1 = {
  onSetEnvWithUserType: setEnvironmentWithUserType
};
UserProvider.propTypes = {
  /** auth to get the status of the user */
  auth: propTypes.object.isRequired
};
UserProvider.defaultProps = {
  verifyToken: true
};
var UserProvider$1 = connect(mapStateToProps$7, mapActionsToProps$1)(UserProvider);
var useStyles$5 = makeStyles$2(function (theme) {
  return {
    root: {}
  };
});

function ActualTime(props) {
  var classes = useStyles$5(props);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1];

  useEffect(function () {
    setInterval(function () {
      setTime(getActualTime());
    }, 1000);
  }, []);
  return React.createElement(Typography$1, null, time);
}

var useStyles$6 = makeStyles$2(function (theme) {
  return {
    root: {
      zIndex: 99999,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      overflow: 'hidden',
      overflowY: 'hidden',
      overflowX: 'hidden'
    }
  };
});

function FullScreenContainer(props) {
  var classes = useStyles$6(props);
  var background = props.background,
      style = props.style;
  return React.createElement("div", _extends({
    className: classes.root
  }, props, {
    style: _objectSpread2({
      background: background
    }, style)
  }), props.children);
}

FullScreenContainer.propTypes = {
  /** Define the background color */
  background: propTypes.object,

  /** Define custom style */
  style: propTypes.object
};
FullScreenContainer.defaultProps = {};

function ChangePasswordLayout(props) {
  var theme = useTheme$1();
  var fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  var onCancel = props.onCancel,
      onSubmit = props.onSubmit;
  var _props$open = props.open,
      open = _props$open === void 0 ? true : _props$open,
      _props$title = props.title,
      title = _props$title === void 0 ? 'Title' : _props$title;
  var _props$cancelProps = props.cancelProps,
      cancelProps = _props$cancelProps === void 0 ? {
    label: 'Cancel'
  } : _props$cancelProps,
      _props$submitProps = props.submitProps,
      submitProps = _props$submitProps === void 0 ? {
    label: 'Confirm'
  } : _props$submitProps;
  return !props.open ? React.createElement("div", null, React.createElement(Typography$1, {
    style: {
      padding: '24px 0px',
      fontSize: '1.25rem',
      color: 'rgba(0, 0, 0, 0.87)'
    }
  }, title), props.children, React.createElement("div", {
    style: {
      flex: '0 0 auto',
      display: 'flex',
      padding: '12px 0px',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, React.createElement(Button, _extends({
    onClick: function onClick() {
      return onSubmit();
    },
    color: "primary",
    id: "submit-button",
    autoFocus: true
  }, submitProps), submitProps && submitProps.label))) : React.createElement(Dialog, {
    fullScreen: fullScreen,
    open: open,
    onClose: function onClose() {
      return onCancel;
    },
    "aria-labelledby": "responsive-dialog-title"
  }, React.createElement(DialogTitle, {
    id: "responsive-dialog-title"
  }, title), React.createElement(DialogContent, {
    style: {
      display: 'flex',
      flexDirection: 'column',
      padding: '24px 16px'
    }
  }, props.children), React.createElement(DialogActions, null, React.createElement(Button, _extends({
    onClick: function onClick() {
      return onCancel();
    },
    color: "primary"
  }, cancelProps), cancelProps && cancelProps.label), React.createElement(Button, _extends({
    onClick: function onClick() {
      return onSubmit(props.value);
    },
    color: "primary",
    id: "submit-button",
    autoFocus: true
  }, submitProps), submitProps && submitProps.label)));
}

ChangePasswordLayout.propTypes = {
  open: propTypes.bool,
  title: propTypes.string,
  onCancel: propTypes.func,
  onSubmit: propTypes.func
};
ChangePasswordLayout.defaultProps = {};
var initialReactKitState = {
  environment: null,
  api: null,
  auth: {
    user: null
  },
  config: {
    privacy: {
      content: false
    }
  },
  messages: []
};
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';

function loginSuccess(user) {
  return {
    type: LOGIN_SUCCESS,
    user: user
  };
}

function authReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialReactKitState.auth;
  var payload = arguments.length > 1 ? arguments[1] : undefined;

  switch (payload.type) {
    case LOGIN_SUCCESS:
      return _objectSpread2({}, state, {
        pending: false,
        user: payload.user
      });

    default:
      return state;
  }
}

function apiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialReactKitState.api;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    default:
      return state;
  }
}

function environmentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialReactKitState.environment;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case SET_ENVIRONMENT_WITH_USER_TYPE:
      return payload.environment;

    default:
      return state;
  }
}

function messagesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialReactKitState.messages;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  var newState = state;

  switch (type) {
    case ADD_MESSAGE:
      newState.push(payload.message);
      return newState;

    case REMOVE_MESSAGE:
      newState.splice(payload.id, 1);
      return newState;

    default:
      return state;
  }
}

function configReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialReactKitState.config;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    default:
      return state;
  }
}
/**
 * Override of translate i18n function
 * Return the translation checking first [external project] then if from i18n
 * the return is "TRANSLATION_NOT_FOUND" check in the @cobrains/react-kit
 * @param
 * @returns {string}
 */


function translate(key) {
  var cbstate = CBReactKitState(); // External translator istance i18n

  var extTranslator = cbstate.TRANSLATE; // Search translation on external project

  if (extTranslator(key) !== 'TRANSLATION_NOT_FOUND') {
    return extTranslator(key); // Search translation on @cobrains/react-kit
  }

  if (translateWithReactKit(key) !== 'TRANSLATION_NOT_FOUND') {
    return translateWithReactKit(key);
  } // Return general TRANSLATION_NOT_FOUND key


  return 'TRANSLATION_NOT_FOUND';
}
/**
 * Check if translation exist using first [external project] then @cobrains/react-kit
 * @param key
 */


function translateExist(key) {
  var cbstate = CBReactKitState(); // External translator istance i18n

  var extTranslator = cbstate.TRANSLATE; // Search translation on external project

  if (extTranslator(key) !== 'TRANSLATION_NOT_FOUND') {
    return true; // Search translation on @cobrains/react-kit
  }

  if (translateWithReactKit(key) !== 'TRANSLATION_NOT_FOUND') {
    return true;
  } // Return general TRANSLATION_NOT_FOUND key


  return false;
}

function apiMessage(err) {
  var authorization = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch) {
    if (err.response) {
      var status = err.response.status;
      var variant = getVariantFromStatus(status); // Check if is present a specific action for the status

      actionFromStatus(status, authorization);

      if (err.response.data.messages) {
        err.response.data.messages.map(function (message) {
          var formattedMessage = formatMessage(message);
          dispatch(addMessage(formattedMessage, variant));
        });
      } else if (isWarning(status)) {
        dispatch(addMessage(translate('api_messages.general_error'), variant));
      }
    } else {
      // TODO: NETWORK CONNECTION ERROR (check other states)
      console.error(err);
    }
  };
}

function actionFromStatus(status, authorization) {
  switch (status) {
    case 401:
      authorization && isAuthenticated();
      break;
  }
}

function formatMessage(err) {
  var context = err.context,
      field = err.field,
      message = err.message;
  var label = null;
  field = "".concat(context && "".concat(context, ".")).concat(field && field);
  message = "".concat(context && "".concat(context, ".")).concat(message && message);

  if (translateExist(field) && translateExist(message)) {
    label = "".concat(field && translate(field), " ").concat(message && translate(message));
  } else if (err && err.message && translateExist("api_messages.".concat(err.message))) {
    label = "".concat(translate("api_messages.".concat(err.message)));
  } else {
    label = translate('api_messages.general_error');
  }

  return label;
}

function getVariantFromStatus(status) {
  if (isSuccess(status)) {
    return 'success';
  }

  if (isWarning(status)) {
    return 'warning';
  }

  if (isError(status)) {
    return 'error';
  }

  return false;
}

function isSuccess(status) {
  return status === 200 || status === 201 || status === 204;
}

function isWarning(status) {
  return status === 400 || status === 401 || status === 403 || status === 404;
}

function isError(status) {
  return status === 500;
}

var defaultConfig = {
  authorization: true,
  baseUrl: true
};
var defaultHeaders = {
  'Content-Type': 'application/json'
};
/**
 *
 * @param method [get/post/put/patch]
 * @param url
 * @param body
 * @param headers
 */

function apiCall(_ref) {
  var _ref$method = _ref.method,
      method = _ref$method === void 0 ? 'post' : _ref$method,
      url = _ref.url,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? defaultHeaders : _ref$headers,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? defaultConfig : _ref$config,
      rest = _objectWithoutProperties(_ref, ["method", "url", "data", "headers", "config"]);

  var cbstate = CBReactKitState();
  return function (dispatch) {
    // Headers definition
    var authentication = null; // if authorization is true and bearerKey and token are valid

    if (config.authorization && cbstate.getBearerKey() && getAccessToken()) {
      authentication = {
        'Authorization': "".concat(cbstate.getBearerKey(), " ").concat(getAccessToken())
      };
    }

    if (config.authorization) {
      headers = _objectSpread2({}, headers, {}, authentication);
    } // Define baseUrl


    if (config.baseUrl) {
      url = "".concat(cbstate.getBaseUrl() + url, "/");
    }

    return axios(_objectSpread2({
      url: url,
      method: method,
      data: data,
      headers: headers
    }, rest)).then(function (res) {
      return res;
    }, function (err) {
      var errore = err.toString();
      dispatch(apiMessage(err, config.authorization)); // TODO: verify why not reject on err

      return Promise.reject(err);
    });
  };
}
/**
 * This generator function’s purpose is simple, append page’s name to action type string with
 * delimiter of your choice, general convention uses / as redux page name delimiter, but you’re
 * good to go with your personal preferences:
 * @param name
 * @param type
 * @returns {string}
 */


var typeGenerator = function typeGenerator(name, type) {
  return "".concat(name !== "" ? "".concat(name, "/") : "").concat(type);
};
/**
 * Action Handler Generator helps in generating action handlers object to be used by our reducer.
 * @param name
 * @param actionHandler
 * @returns {{}}
 */


var actionHandlerGenerator = function actionHandlerGenerator(name, actionHandler) {
  return Object.keys(actionHandler).reduce(function (result, key) {
    var actionType = typeGenerator(name, key); // eslint-disable-next-line no-param-reassign

    result[actionType] = actionHandler[key];
    return result;
  }, {});
};
/**
 * Action Creators Generator will help us generate the necessary action creators
 * based on our page’s name.
 * @param name
 * @param actionCreators
 * @param params
 * @returns {{}}
 */


var actionCreatorGenerator = function actionCreatorGenerator(name, actionCreators, params) {
  return Object.keys(actionCreators).reduce(function (result, key) {
    // eslint-disable-next-line no-param-reassign
    result[key] = actionCreators[key](name, params);
    return result;
  }, {});
};
/**
 * Reducer generator with the help of Action Handler Generator will help in generating
 * the necessary reducer.
 * @param name
 * @param defaultActionHandler
 * @param initialState
 * @returns {function(*=, *=): *}
 */


var reducerGenerator = function reducerGenerator() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var defaultActionHandler = arguments.length > 1 ? arguments[1] : undefined;
  var initialState = arguments.length > 2 ? arguments[2] : undefined;
  /* Memoize the action handler so we won't generate it again every reducer call */

  var actionHandler = actionHandlerGenerator(name, defaultActionHandler);
  /* Return the reducer */

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return actionHandler[action.type] ? actionHandler[action.type](state, action) : state;
  };
};
/** Change the action creator implementations as function that returns action creator */

/** GET */


var getCrudLoading = function getCrudLoading(name) {
  return function () {
    return {
      type: typeGenerator(name, "GET_CRUD_LOADING")
    };
  };
};

var getCrudFailed = function getCrudFailed(name) {
  return function (error) {
    return {
      type: typeGenerator(name, "GET_CRUD_FAILED"),
      error: error
    };
  };
};

var getCrudSuccess = function getCrudSuccess(name) {
  return function (data) {
    return {
      type: typeGenerator(name, "GET_CRUD_SUCCESS"),
      data: data
    };
  };
};
/** CREATE */


var createCrudLoading = function createCrudLoading(name) {
  return function () {
    return {
      type: typeGenerator(name, "CREATE_CRUD_LOADING")
    };
  };
};

var createCrudFailed = function createCrudFailed(name) {
  return function (error) {
    return {
      type: typeGenerator(name, "CREATE_CRUD_FAILED"),
      error: error
    };
  };
};

var createCrudSuccess = function createCrudSuccess(name) {
  return function (data) {
    return {
      type: typeGenerator(name, "CREATE_CRUD_SUCCESS"),
      data: data
    };
  };
};
/** PREPARE */


var prepareCrudLoading = function prepareCrudLoading(name) {
  return function () {
    return {
      type: typeGenerator(name, "PREPARE_CRUD_LOADING")
    };
  };
};

var prepareCrudFailed = function prepareCrudFailed(name) {
  return function (error) {
    return {
      type: typeGenerator(name, "PREPARE_CRUD_FAILED"),
      error: error
    };
  };
};

var prepareCrudSuccess = function prepareCrudSuccess(name) {
  return function (data) {
    return {
      type: typeGenerator(name, "PREPARE_CRUD_SUCCESS"),
      data: data
    };
  };
};

var resetPrepareCrud = function resetPrepareCrud(name) {
  return function () {
    return {
      type: typeGenerator(name, "RESET_PREPARE_CRUD")
    };
  };
};
/** TABLE */


var prepareTableLoading = function prepareTableLoading(name) {
  return function () {
    return {
      type: typeGenerator(name, "PREPARE_TABLE_LOADING")
    };
  };
};

var prepareTableFailed = function prepareTableFailed(name) {
  return function (error) {
    return {
      type: typeGenerator(name, "PREPARE_TABLE_FAILED"),
      error: error
    };
  };
};

var prepareTableSuccess = function prepareTableSuccess(name) {
  return function (data) {
    return {
      type: typeGenerator(name, "PREPARE_TABLE_SUCCESS"),
      data: data
    };
  };
};

var resetPrepareTable = function resetPrepareTable(name) {
  return function () {
    return {
      type: typeGenerator(name, "RESET_PREPARE_TABLE")
    };
  };
};
/** EDIT */


var editCrudLoading = function editCrudLoading(name) {
  return function () {
    return {
      type: typeGenerator(name, "EDIT_CRUD_LOADING")
    };
  };
};

var editCrudFailed = function editCrudFailed(name) {
  return function (error) {
    return {
      type: typeGenerator(name, "EDIT_CRUD_FAILED"),
      error: error
    };
  };
};

var editCrudSuccess = function editCrudSuccess(name) {
  return function (data, clear) {
    return {
      type: typeGenerator(name, "EDIT_CRUD_SUCCESS"),
      data: data,
      clear: clear
    };
  };
};
/** DELETE */


var deleteCrudLoading = function deleteCrudLoading(name) {
  return function () {
    return {
      type: typeGenerator(name, "DELETE_CRUD_LOADING")
    };
  };
};

var deleteCrudFailed = function deleteCrudFailed(name) {
  return function (error) {
    return {
      type: typeGenerator(name, "DELETE_CRUD_FAILED"),
      error: error
    };
  };
};

var deleteCrudSuccess = function deleteCrudSuccess(name) {
  return function (id) {
    return {
      type: typeGenerator(name, "DELETE_CRUD_SUCCESS"),
      id: id
    };
  };
};
/** SELECTED */


var selectedCrud = function selectedCrud(name) {
  return function (data) {
    return {
      type: typeGenerator(name, "SELECTED_CRUD"),
      data: data
    };
  };
};

var resetSelectedCrud = function resetSelectedCrud(name) {
  return function () {
    return {
      type: typeGenerator(name, "RESET_SELECTED_CRUD")
    };
  };
};
/** SET OPEN DIALOG */


var setDialog = function setDialog(name) {
  return function (dialog) {
    return {
      type: typeGenerator(name, "SET_DIALOG"),
      dialog: dialog
    };
  };
};
/** ADD QUERY FILTER */


var addQueryFilter = function addQueryFilter(name) {
  return function (filter) {
    return {
      type: typeGenerator(name, "ADD_QUERY_FILTER"),
      filter: filter
    };
  };
};
/** RESET DATA CRUD */


var resetDataCrud = function resetDataCrud(name) {
  return function () {
    return {
      type: typeGenerator(name, "RESET_DATA_CRUD")
    };
  };
};
/** we'll then compose it as object and pass it to actionCreatorGenerator */


var crudActionsGenerator = function crudActionsGenerator(pageName) {
  return actionCreatorGenerator(pageName, {
    setDialog: setDialog,
    getCrudLoading: getCrudLoading,
    getCrudFailed: getCrudFailed,
    getCrudSuccess: getCrudSuccess,
    prepareCrudLoading: prepareCrudLoading,
    prepareCrudFailed: prepareCrudFailed,
    prepareCrudSuccess: prepareCrudSuccess,
    resetPrepareCrud: resetPrepareCrud,
    prepareTableLoading: prepareTableLoading,
    prepareTableFailed: prepareTableFailed,
    prepareTableSuccess: prepareTableSuccess,
    resetPrepareTable: resetPrepareTable,
    createCrudLoading: createCrudLoading,
    createCrudFailed: createCrudFailed,
    createCrudSuccess: createCrudSuccess,
    editCrudLoading: editCrudLoading,
    editCrudFailed: editCrudFailed,
    editCrudSuccess: editCrudSuccess,
    deleteCrudLoading: deleteCrudLoading,
    deleteCrudFailed: deleteCrudFailed,
    deleteCrudSuccess: deleteCrudSuccess,
    selectedCrud: selectedCrud,
    resetSelectedCrud: resetSelectedCrud,
    addQueryFilter: addQueryFilter,
    resetDataCrud: resetDataCrud
  });
};

var actionHandler = function actionHandler(guardedInitialState) {
  return {
    SET_TO_INITIAL_STATE: function SET_TO_INITIAL_STATE() {
      return guardedInitialState;
    },

    /** GET */
    GET_CRUD_LOADING: function GET_CRUD_LOADING(state) {
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'get', true));
    },
    GET_CRUD_FAILED: function GET_CRUD_FAILED(state, payload) {
      var setPayload = {
        data: {
          messages: []
        }
      };
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'get', false), {}, setProperty('errors', state, 'get', payload.error.response ? payload.error.response : setPayload));
    },
    GET_CRUD_SUCCESS: function GET_CRUD_SUCCESS(state, payload) {
      var items = [].concat(_toConsumableArray(state.data.content.items), _toConsumableArray(payload.data.content.items));
      if (payload.data.content.items) payload.data.content.items = getUnique(items, 'id');
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'get', false), {
        data: {
          content: _objectSpread2({
            items: getUnique(items, 'id'),
            count: payload.data.content.count
          }, payload.data.content)
        }
      });
    },

    /** CREATE */
    CREATE_CRUD_LOADING: function CREATE_CRUD_LOADING(state) {
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'create', true));
    },
    CREATE_CRUD_FAILED: function CREATE_CRUD_FAILED(state, payload) {
      var setPayload = {
        data: {
          messages: []
        }
      };
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'create', false), {}, setProperty('errors', state, 'create', payload.error.response ? payload.error.response : setPayload));
    },
    CREATE_CRUD_SUCCESS: function CREATE_CRUD_SUCCESS(state, payload) {
      var data = state.data;

      if (payload.data.content.items) {
        data.content = {
          items: [].concat(_toConsumableArray(payload.data.content.items), _toConsumableArray(data.content.items)),
          count: payload.data.content.count
        };
      } else {
        data.content.items.push(payload.data.content);
        data.content.count++;
      }

      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'create', false), {}, setProperty('dialogs', state, 'add', false), {
        prepare: {
          fields: []
        },
        data: data
      });
    },

    /** EDIT */
    EDIT_CRUD_LOADING: function EDIT_CRUD_LOADING(state) {
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'edit', true));
    },
    EDIT_CRUD_FAILED: function EDIT_CRUD_FAILED(state, payload) {
      var setPayload = {
        data: {
          messages: []
        }
      };
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'edit', false), {}, setProperty('errors', state, 'edit', payload.error.response ? payload.error.response : setPayload));
    },
    EDIT_CRUD_SUCCESS: function EDIT_CRUD_SUCCESS(state, payload) {
      var data = state.data;
      var items = data.content.items;
      items[findIndex(items, payload.data)] = payload.data.data.content;
      data.content.items = items;
      return payload.clear ? _objectSpread2({}, state, {}, setProperty('loaders', state, 'edit', false), {}, setProperty('dialogs', state, 'edit', false), {
        prepare: {
          fields: []
        },
        selected: [],
        data: data
      }) : _objectSpread2({}, state, {}, setProperty('loaders', state, 'edit', false), {}, setProperty('dialogs', state, 'edit', false), {
        prepare: {
          fields: []
        },
        data: data
      });
    },

    /** DELETE */
    DELETE_CRUD_LOADING: function DELETE_CRUD_LOADING(state) {
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'delete', true));
    },
    DELETE_CRUD_FAILED: function DELETE_CRUD_FAILED(state, payload) {
      var setPayload = {
        data: {
          messages: []
        }
      };
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'delete', false), {}, setProperty('errors', state, 'delete', payload.error.response ? payload.error.response : setPayload));
    },
    DELETE_CRUD_SUCCESS: function DELETE_CRUD_SUCCESS(state, payload) {
      var data = state.data;
      var items = data.content.items;
      items.splice(findIndex(items, payload), 1);
      data.content.items = items;
      data.content.count--;
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'delete', false), {}, setProperty('dialogs', state, 'delete', false), {
        data: data
      });
    },

    /** SELECTED */
    SELECTED_CRUD: function SELECTED_CRUD(state, payload) {
      return _objectSpread2({}, state, {
        selected: payload.data
      });
    },

    /** RESET SELECTED */
    RESET_SELECTED_CRUD: function RESET_SELECTED_CRUD(state) {
      return _objectSpread2({}, state, {
        selected: []
      });
    },

    /** RESET DATA CRUD */
    RESET_DATA_CRUD: function RESET_DATA_CRUD(state) {
      return _objectSpread2({}, state, {
        data: {
          content: {
            items: [],
            count: 0
          }
        }
      });
    },

    /** SET DIALOG */
    SET_DIALOG: function SET_DIALOG(state, payload) {
      return _objectSpread2({}, state, {}, setProperty('dialogs', state, [payload.dialog.name], payload.dialog.status));
    },
    PREPARE_CRUD_LOADING: function PREPARE_CRUD_LOADING(state) {
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'prepare', true));
    },
    PREPARE_CRUD_FAILED: function PREPARE_CRUD_FAILED(state, payload) {
      var setPayload = {
        data: {
          messages: []
        }
      };
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'prepare', false), {}, setProperty('errors', state, 'prepare', payload.error.response ? payload.error.response : setPayload));
    },
    PREPARE_CRUD_SUCCESS: function PREPARE_CRUD_SUCCESS(state, payload) {
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'prepare', false), {
        prepare: payload.data
      });
    },
    RESET_PREPARE_CRUD: function RESET_PREPARE_CRUD(state) {
      return _objectSpread2({}, state, {
        prepare: {
          fields: []
        }
      });
    },

    /** SET TABLE */
    PREPARE_TABLE_LOADING: function PREPARE_TABLE_LOADING(state) {
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'table', true));
    },
    PREPARE_TABLE_FAILED: function PREPARE_TABLE_FAILED(state, payload) {
      var setPayload = {
        data: {
          messages: []
        }
      };
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'table', false), {}, setProperty('errors', state, 'table', payload.error.response ? payload.error.response : setPayload));
    },
    PREPARE_TABLE_SUCCESS: function PREPARE_TABLE_SUCCESS(state, payload) {
      return _objectSpread2({}, state, {}, setProperty('loaders', state, 'table', false), {
        table: payload.data
      });
    },
    RESET_PREPARE_TABLE: function RESET_PREPARE_TABLE(state) {
      return _objectSpread2({}, state, {
        table: {
          fields: []
        }
      });
    },

    /** FILTERS */
    ADD_QUERY_FILTER: function ADD_QUERY_FILTER(state, payload) {
      return _objectSpread2({}, state, {
        filters: _objectSpread2({}, state.filters, {}, payload.filter)
      });
    }
  };
};
/**
 * Set state of redux
 * @param property
 * @param state
 * @param name
 * @param error
 * @returns {{}}
 */


function setProperty(property, state, name, value) {
  return _defineProperty({}, property, _objectSpread2({}, state[property], _defineProperty({}, name, value)));
}
/**
 * Find the index for edit/remove
 * @param state
 * @param payload
 * @returns {*}
 */


function findIndex(items, payload) {
  var filter = items.filter(function (item) {
    return item.id === payload.id;
  })[0];
  var index = items.indexOf(filter);
  return index;
}

var crudDefaultState = {
  loaders: {
    get: false,
    create: false,
    prepare: false,
    table: false
  },
  errors: {
    get: {
      data: {
        messages: []
      }
    },
    edit: {
      data: {
        messages: []
      }
    },
    create: {
      data: {
        messages: []
      }
    },
    prepare: {
      data: {
        messages: []
      }
    },
    table: {
      data: {
        messages: []
      }
    }
  },
  dialogs: {
    add: false,
    edit: false,
    delete: false
  },
  data: {
    content: {
      items: [],
      count: 0
    }
  },
  selected: [],
  prepare: {
    fields: []
  },
  table: {
    fields: []
  },
  filters: {}
};
/** Change reducer implementation to use reducerGenerator */

var crudReducerGenerator = function crudReducerGenerator(pageName, pageInitialState) {
  var guardedInitialState = pageInitialState; // || initialState;

  return reducerGenerator(pageName, actionHandler(guardedInitialState), guardedInitialState);
};
/**
 * Create the initial state for crud
 */


function getCrudInitialState(CRUD_MODELS) {
  var initialState = {};
  CRUD_MODELS.forEach(function (key) {
    initialState = _objectSpread2({}, initialState, _defineProperty({}, "".concat(key, "Page"), _objectSpread2({}, crudDefaultState)));
  });
  return initialState;
}

var has$2 = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = function () {
  var array = [];

  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }

  return array;
}();

var compactQueue = function compactQueue(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];

    if (isArray(obj)) {
      var compacted = [];

      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }

      item.obj[item.prop] = compacted;
    }
  }
};

var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};

  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }

  return obj;
};

var merge = function merge(target, source, options) {
  /* eslint no-param-reassign: 0 */
  if (!source) {
    return target;
  }

  if (typeof source !== 'object') {
    if (isArray(target)) {
      target.push(source);
    } else if (target && typeof target === 'object') {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$2.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }

    return target;
  }

  if (!target || typeof target !== 'object') {
    return [target].concat(source);
  }

  var mergeTarget = target;

  if (isArray(target) && !isArray(source)) {
    mergeTarget = arrayToObject(target, options);
  }

  if (isArray(target) && isArray(source)) {
    source.forEach(function (item, i) {
      if (has$2.call(target, i)) {
        var targetItem = target[i];

        if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
          target[i] = merge(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }

  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];

    if (has$2.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }

    return acc;
  }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};

var decode = function decode(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, ' ');

  if (charset === 'iso-8859-1') {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  } // utf-8


  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};

var encode = function encode(str, defaultEncoder, charset) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }

  var string = str;

  if (typeof str === 'symbol') {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== 'string') {
    string = String(str);
  }

  if (charset === 'iso-8859-1') {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
  }

  var out = '';

  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);

    if (c === 0x2D // -
    || c === 0x2E // .
    || c === 0x5F // _
    || c === 0x7E // ~
    || c >= 0x30 && c <= 0x39 // 0-9
    || c >= 0x41 && c <= 0x5A // a-z
    || c >= 0x61 && c <= 0x7A // A-Z
    ) {
        out += string.charAt(i);
        continue;
      }

    if (c < 0x80) {
      out = out + hexTable[c];
      continue;
    }

    if (c < 0x800) {
      out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    if (c < 0xD800 || c >= 0xE000) {
      out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    i += 1;
    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
  }

  return out;
};

var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];

  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);

    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];

      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }

  compactQueue(queue);
  return value;
};

var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
  return [].concat(a, b);
};

var utils = {
  arrayToObject: arrayToObject,
  assign: assign,
  combine: combine,
  compact: compact,
  decode: decode,
  encode: encode,
  isBuffer: isBuffer,
  isRegExp: isRegExp,
  merge: merge
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: 'RFC1738',
  RFC3986: 'RFC3986'
};
var formats = utils.assign({
  'default': Format.RFC3986,
  formatters: {
    RFC1738: function RFC1738(value) {
      return replace.call(value, percentTwenties, '+');
    },
    RFC3986: function RFC3986(value) {
      return String(value);
    }
  }
}, Format);
var has$3 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + '[]';
  },
  comma: 'comma',
  indices: function indices(prefix, key) {
    return prefix + '[' + key + ']';
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$1 = Array.isArray;
var push = Array.prototype.push;

var pushToArray = function pushToArray(arr, valueOrArray) {
  push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;
var defaultFormat = formats['default'];
var defaults = {
  addQueryPrefix: false,
  allowDots: false,
  charset: 'utf-8',
  charsetSentinel: false,
  delimiter: '&',
  encode: true,
  encoder: utils.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats.formatters[defaultFormat],
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};

var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset) {
  var obj = object;

  if (typeof filter === 'function') {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate(obj);
  } else if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
    obj = obj.join(',');
  }

  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
    }

    obj = '';
  }

  if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
    }

    return [formatter(prefix) + '=' + formatter(String(obj))];
  }

  var values = [];

  if (typeof obj === 'undefined') {
    return values;
  }

  var objKeys;

  if (isArray$1(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (skipNulls && obj[key] === null) {
      continue;
    }

    if (isArray$1(obj)) {
      pushToArray(values, stringify(obj[key], typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
    } else {
      pushToArray(values, stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
    }
  }

  return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
  if (!opts) {
    return defaults;
  }

  if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
    throw new TypeError('Encoder has to be a function.');
  }

  var charset = opts.charset || defaults.charset;

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var format = formats['default'];

  if (typeof opts.format !== 'undefined') {
    if (!has$3.call(formats.formatters, opts.format)) {
      throw new TypeError('Unknown format option provided.');
    }

    format = opts.format;
  }

  var formatter = formats.formatters[format];
  var filter = defaults.filter;

  if (typeof opts.filter === 'function' || isArray$1(opts.filter)) {
    filter = opts.filter;
  }

  return {
    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
    filter: filter,
    formatter: formatter,
    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
    sort: typeof opts.sort === 'function' ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};

var stringify_1 = function stringify_1(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;

  if (typeof options.filter === 'function') {
    filter = options.filter;
    obj = filter('', obj);
  } else if (isArray$1(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }

  var keys = [];

  if (typeof obj !== 'object' || obj === null) {
    return '';
  }

  var arrayFormat;

  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && 'indices' in opts) {
    arrayFormat = opts.indices ? 'indices' : 'repeat';
  } else {
    arrayFormat = 'indices';
  }

  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

  if (!objKeys) {
    objKeys = Object.keys(obj);
  }

  if (options.sort) {
    objKeys.sort(options.sort);
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (options.skipNulls && obj[key] === null) {
      continue;
    }

    pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.formatter, options.encodeValuesOnly, options.charset));
  }

  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? '?' : '';

  if (options.charsetSentinel) {
    if (options.charset === 'iso-8859-1') {
      // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
      prefix += 'utf8=%26%2310003%3B&';
    } else {
      // encodeURIComponent('✓')
      prefix += 'utf8=%E2%9C%93&';
    }
  }

  return joined.length > 0 ? prefix + joined : '';
};

var has$4 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;
var defaults$1 = {
  allowDots: false,
  allowPrototypes: false,
  arrayLimit: 20,
  charset: 'utf-8',
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: '&',
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1000,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};

var interpretNumericEntities = function interpretNumericEntities(str) {
  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
}; // This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.


var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1; // Keep track of where the utf8 sentinel was found

  var i;
  var charset = options.charset;

  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf('utf8=') === 0) {
        if (parts[i] === charsetSentinel) {
          charset = 'utf-8';
        } else if (parts[i] === isoSentinel) {
          charset = 'iso-8859-1';
        }

        skipIndex = i;
        i = parts.length; // The eslint settings do not allow break;
      }
    }
  }

  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }

    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;

    if (pos === -1) {
      key = options.decoder(part, defaults$1.decoder, charset, 'key');
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults$1.decoder, charset, 'key');
      val = options.decoder(part.slice(pos + 1), defaults$1.decoder, charset, 'value');
    }

    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
      val = interpretNumericEntities(val);
    }

    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
      val = val.split(',');
    }

    if (part.indexOf('[]=') > -1) {
      val = isArray$2(val) ? [val] : val;
    }

    if (has$4.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }

  return obj;
};

var parseObject = function parseObject(chain, val, options) {
  var leaf = val;

  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];

    if (root === '[]' && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var index = parseInt(cleanRoot, 10);

      if (!options.parseArrays && cleanRoot === '') {
        obj = {
          0: leaf
        };
      } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else {
        obj[cleanRoot] = leaf;
      }
    }

    leaf = obj;
  }

  return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
  if (!givenKey) {
    return;
  } // Transform dot notation to bracket notation


  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g; // Get the parent

  var segment = options.depth > 0 && brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

  var keys = [];

  if (parent) {
    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
    if (!options.plainObjects && has$4.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(parent);
  } // Loop through children appending to the array until we hit depth


  var i = 0;

  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;

    if (!options.plainObjects && has$4.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(segment[1]);
  } // If there's a remainder, just add whatever is left


  if (segment) {
    keys.push('[' + key.slice(segment.index) + ']');
  }

  return parseObject(keys, val, options);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
  if (!opts) {
    return defaults$1;
  }

  if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var charset = typeof opts.charset === 'undefined' ? defaults$1.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults$1.allowPrototypes,
    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults$1.arrayLimit,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults$1.comma,
    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults$1.decoder,
    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults$1.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults$1.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults$1.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults$1.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults$1.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};

var parse = function parse(str, opts) {
  var options = normalizeParseOptions(opts);

  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }

  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options);
    obj = utils.merge(obj, newObj, options);
  }

  return utils.compact(obj);
};

var lib = {
  formats: formats,
  parse: parse,
  stringify: stringify_1
};
/** Get Crud Thunk */

var getCrud = function getCrud(action, url, params) {
  var paramsSerializer = null;

  if (params && params.filter) {
    paramsSerializer = function paramsSerializer(apiParams) {
      return lib.stringify(apiParams, {
        arrayFormat: 'repeat',
        encode: false
      });
    };
  }

  var apiOptions = {
    method: 'GET',
    url: url,
    params: params,
    paramsSerializer: paramsSerializer
  };
  return function (dispatch) {
    dispatch(action.getCrudLoading());
    dispatch(action.getCrudLoading());
    dispatch(apiCall(apiOptions)).then(function (res) {
      dispatch(action.getCrudSuccess(res.data));
    }, function (err) {
      dispatch(action.getCrudFailed(err));
    });
  };
};
/** Prepare Crud Thunk */


var prepareCrud = function prepareCrud(action, url, params) {
  var paramsSerializer = null;

  if (params && params.filter) {
    paramsSerializer = function paramsSerializer(apiParams) {
      return lib.stringify(apiParams, {
        arrayFormat: 'repeat',
        encode: false
      });
    };
  }

  var apiOptions = {
    method: 'GET',
    url: url,
    params: params,
    paramsSerializer: paramsSerializer
  };
  return function (dispatch) {
    dispatch(action.prepareCrudLoading());
    dispatch(apiCall(apiOptions)).then(function (res) {
      return dispatch(action.prepareCrudSuccess(res.data.content));
    }, function (err) {
      return dispatch(action.prepareCrudFailed(err));
    });
  };
};
/** Reset prepare Crud Thunk */


var resetPrepareCrud$1 = function resetPrepareCrud(action, item) {
  return function (dispatch) {
    dispatch(action.resetPrepareCrud(item));
  };
};

var prepareTable = function prepareTable(action, url) {
  var apiOptions = {
    method: 'GET',
    url: url
  };
  return function (dispatch) {
    dispatch(action.prepareTableLoading());
    dispatch(apiCall(apiOptions)).then(function (res) {
      return dispatch(action.prepareTableSuccess(res.data.content));
    }, function (err) {
      return dispatch(action.prepareTableFailed(err));
    });
  };
};

var resetPrepareTable$1 = function resetPrepareTable(action, item) {
  return function (dispatch) {
    dispatch(action.resetPrepareTable(item));
  };
};
/** Create Crud Thunk */


var createCrud = function createCrud(action, url, data, resActions, errActions) {
  var apiOptions = {
    method: 'POST',
    url: url,
    data: data
  };
  return function (dispatch) {
    dispatch(action.createCrudLoading());
    dispatch(apiCall(apiOptions)).then(function (res) {
      dispatch(action.createCrudSuccess(res.data));
      if (resActions) resActions();
    }, function (err) {
      dispatch(action.createCrudFailed(err));
      if (errActions) errActions();
    });
  };
};
/** Edit Crud Thunk */
// TODO: fix return apiCall dispatch


var editCrud = function editCrud(action, url, data) {
  var clear = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var apiOptions = {
    method: 'PUT',
    url: url,
    data: data.data
  };
  return function (dispatch) {
    dispatch(action.editCrudLoading());
    dispatch(apiCall(apiOptions)).then(function (res) {
      return dispatch(action.editCrudSuccess({
        data: res.data,
        id: data.id
      }, clear));
    }, function (err) {
      return dispatch(action.editCrudFailed(err));
    });
  };
};
/** Delete Crud Thunk */


var deleteCrud = function deleteCrud(action, url, id) {
  var apiOptions = {
    method: 'DELETE',
    url: url
  };
  return function (dispatch) {
    dispatch(action.deleteCrudLoading());
    dispatch(apiCall(apiOptions)).then(function () {
      return dispatch(action.deleteCrudSuccess(id));
    }, function (err) {
      return dispatch(action.deleteCrudFailed(err));
    });
  };
};
/** Selected Crud Thunk */


var selectedCrud$1 = function selectedCrud(action, item) {
  return function (dispatch) {
    dispatch(action.selectedCrud(item));
  };
};
/** Selected Crud Thunk */


var resetSelectedCrud$1 = function resetSelectedCrud(action, item) {
  return function (dispatch) {
    dispatch(action.resetSelectedCrud(item));
  };
};
/** Set Dialog Crud Thunk */


var setCrudDialog = function setCrudDialog(action, dialog) {
  return function (dispatch) {
    dispatch(action.setDialog(dialog));
  };
};
/** Add query filter Crud Thunk */


var addQueryFilter$1 = function addQueryFilter(action, filter) {
  return function (dispatch) {
    dispatch(action.addQueryFilter(filter));
  };
};
/** Reset Data Crud Thunk */


var resetDataCrud$1 = function resetDataCrud(action) {
  return function (dispatch) {
    dispatch(action.resetDataCrud());
  };
};

var useStyles$7 = makeStyles$2(function () {
  return {
    root: {
      width: '100%'
    },
    strength0: {
      display: 'none'
    },
    strength1: {
      '& div': {
        background: '#b5b5b5'
      }
    },
    strength2: {
      '& div': {
        background: '#ba0018'
      }
    },
    strength3: {
      '& div': {
        background: '#e9b200'
      }
    },
    strength4: {
      '& div': {
        background: '#0077a8'
      }
    },
    strength5: {
      '& div': {
        background: '#04aa00'
      }
    }
  };
});
var minSecurity = 59;

function ChangePassword(props) {
  var classes = useStyles$7();
  var theme = useTheme$1();
  var onSubmit = props.onSubmit;
  var title = props.title,
      open = props.open,
      oldPassword = props.oldPassword;
  var submitProps = props.submitProps;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      passwordVisibility = _useState2[0],
      setPasswordVisibility = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      passwordVisibilityPrev = _useState4[0],
      setPasswordVisibilityPrev = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      strengthValue = _useState6[0],
      setStrengthValue = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      password = _useState8[0],
      setPassword = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      confirmPassword = _useState10[0],
      setConfirmPassword = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      prevPassword = _useState12[0],
      setPrevPassword = _useState12[1];

  function getColorPasswordStrength(value, classes) {
    switch (value) {
      case 20:
        return classes.strength1;

      case 40:
        return classes.strength2;

      case 60:
        return classes.strength3;

      case 80:
        return classes.strength4;

      case 100:
        return classes.strength5;

      default:
        return null;
    }
  }

  function handleOnChange(event) {
    event.persist();
    var valueStrength = checkStrength(event.target.value);
    setStrengthValue(event.target.value !== '' ? valueStrength : 0);
    setPassword(event.target.value);
  }

  function checkValidation() {
    if (password !== confirmPassword || !password || strengthValue < minSecurity) {
      var errorMessage = [];
      if (password !== confirmPassword) errorMessage.push(translate('change_password.password_not_match'));
      if (strengthValue < minSecurity) errorMessage.push(translate('change_password.password_not_strong'));
      if (!password) errorMessage.push(translate('change_password.password_empty'));
      errorMessage = errorMessage.join("\n");
      props.onAddMessage(errorMessage, 'warning');
    } else onSubmit(password);
  }

  return React.createElement(ChangePasswordLayout, {
    title: title,
    onSubmit: function onSubmit() {
      return checkValidation();
    },
    onCancel: props.onCancel,
    open: props.open,
    cancelProps: props.cancelProps,
    submitProps: submitProps
  }, oldPassword && React.createElement(TextField, {
    style: {
      marginBottom: 40
    },
    label: translate('change_password.old_password'),
    id: "password-textField",
    className: classes.root,
    variant: "outlined",
    value: prevPassword,
    type: !passwordVisibilityPrev ? 'password' : 'text',
    onChange: function onChange(e) {
      return setPrevPassword(e.target.value);
    },
    name: "old_password",
    helperText: null,
    InputProps: {
      endAdornment: React.createElement(InputAdornment, {
        position: "end"
      }, React.createElement(IconButton, {
        "aria-label": "toggle password visibility",
        onClick: function onClick() {
          return setPasswordVisibilityPrev(!passwordVisibilityPrev);
        },
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      }, passwordVisibilityPrev ? React.createElement(Visibility, null) : React.createElement(VisibilityOff, null)))
    }
  }), React.createElement(TextField, {
    label: translate('change_password.password'),
    className: classes.root,
    variant: "outlined",
    id: "confirmPassword-textField",
    value: password,
    type: !passwordVisibility ? 'password' : 'text',
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    name: "password",
    helperText: null,
    InputProps: {
      endAdornment: React.createElement(InputAdornment, {
        position: "end"
      }, React.createElement(IconButton, {
        "aria-label": "toggle password visibility",
        onClick: function onClick() {
          return setPasswordVisibility(!passwordVisibility);
        },
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      }, passwordVisibility ? React.createElement(Visibility, null) : React.createElement(VisibilityOff, null)))
    }
  }), React.createElement("div", {
    style: {
      marginBottom: 20
    }
  }, React.createElement(LinearProgress, {
    variant: "determinate",
    className: getColorPasswordStrength(strengthValue, classes),
    style: {
      background: '#f5f6f7',
      marginTop: 12,
      marginBottom: 4
    },
    value: strengthValue
  })), React.createElement(TextField, {
    label: translate('change_password.confirm_password'),
    className: classes.root,
    variant: "outlined",
    value: confirmPassword,
    type: "password",
    onChange: function onChange(e) {
      return setConfirmPassword(e.target.value);
    },
    name: "confirm_password"
  }));
}

var mapActionsToProps$2 = {
  onAddMessage: addMessage
};

var mapStateToProps$8 = function mapStateToProps() {
  return {};
};

var ChangePassword$1 = compose(connect(mapStateToProps$8, mapActionsToProps$2))(ChangePassword);
var useStyles$8 = makeStyles$2(function () {
  return {
    root: {
      width: '100%'
    },
    dialogWidth: {
      minWidth: 375
    }
  };
});

function ConfirmDialog(props) {
  var classes = useStyles$8();
  var theme = useTheme();
  var fullScreen = useMediaQuery$1(theme.breakpoints.down('sm'));
  var onCancel = props.onCancel,
      onSubmit = props.onSubmit;
  var _props$open = props.open,
      open = _props$open === void 0 ? true : _props$open,
      _props$title = props.title,
      title = _props$title === void 0 ? 'Dialog Title' : _props$title,
      confirmText = props.confirmText,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? '#f44336' : _props$textColor,
      _props$textBackground = props.textBackgroundColor,
      textBackgroundColor = _props$textBackground === void 0 ? '#ffd0bf' : _props$textBackground;
  var cancelProps = props.cancelProps,
      submitProps = props.submitProps;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      confirm = _useState2[0],
      setConfirm = _useState2[1];

  var _props$buttonVariant = props.buttonVariant,
      buttonVariant = _props$buttonVariant === void 0 ? 'outlined' : _props$buttonVariant;

  function getButtonStyle() {
    switch (buttonVariant) {
      case 'outlined':
        return {};

      case 'contained':
        return {
          variant: 'contained',
          style: {
            borderRadius: 18
          }
        };

      default:
        return {};
    }
  }

  function Submit() {
    if (confirmText) {
      if (confirmText === confirm) onSubmit();
    } else onSubmit();
  }

  return React.createElement(Dialog, {
    fullScreen: fullScreen,
    open: open,
    onClose: function onClose() {
      return onCancel;
    },
    classes: {
      paperWidthSm: classes.dialogWidth
    },
    "aria-labelledby": "responsive-dialog-title"
  }, React.createElement(DialogTitle, {
    id: "responsive-dialog-title",
    style: props.message ? {} : {
      padding: '36px 16px'
    }
  }, typeof title === 'function' ? title() : title), props.message && React.createElement(DialogContent, null, typeof props.message === 'function' ? props.message(confirmText && React.createElement("b", {
    style: {
      color: textColor,
      background: textBackgroundColor,
      padding: 4,
      borderRadius: 4
    }
  }, confirmText)) : props.message, confirmText && React.createElement(TextField$1, {
    className: classes.root,
    variant: "outlined",
    value: confirm,
    id: "confirm-textField",
    onChange: function onChange(e) {
      return setConfirm(e.target.value);
    },
    name: "confirm"
  })), React.createElement(DialogActions, null, React.createElement(Button, _extends({
    onClick: function onClick() {
      return onCancel();
    },
    color: "primary",
    style: {
      color: '#8a8a8a'
    }
  }, cancelProps), cancelProps && cancelProps.label), React.createElement(Button, _extends({
    style: {
      color: '#e00000'
    },
    onClick: function onClick() {
      return Submit();
    },
    disabled: confirmText ? confirmText !== confirm : false,
    color: "primary"
  }, getButtonStyle(), {
    id: "submit-button",
    autoFocus: true
  }, submitProps), submitProps && submitProps.label)));
}

ConfirmDialog.propTypes = {
  /** Define if dialog is open or not */
  open: propTypes.bool.required,

  /**  Message content of dialog */
  message: propTypes.string,

  /** Title of the dialog */
  title: propTypes.string,

  /** Props of cancel button */
  cancelProps: {
    label: propTypes.string
  },

  /** Props of submit button */
  submitProps: {
    label: propTypes.string
  },

  /** text to type for submit */
  confirmText: propTypes.string.required,

  /** color of background of confirm text */
  textBackgroundColor: propTypes.string,

  /** color of confirm text */
  textColor: propTypes.string
};
ConfirmDialog.defaultProps = {
  onCancel: function onCancel() {
    return console.log('cancel');
  },
  onSubmit: function onSubmit() {
    return console.log('submit');
  },
  cancelProps: {
    label: 'Cancel'
  },
  submitProps: {
    label: 'Submit'
  },
  textBackgroundColor: '#ffd0bf',
  textColor: '#f44336'
};
var useStyle = makeStyles(function (theme) {
  return {
    dropzoneRoot: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    dropzoneText: {
      color: '#777',
      fontSize: 15,
      fontWeight: 200
    },
    loaderFileStatusText: {
      marginTop: 12,
      fontSize: 12
    },
    dropzone: {
      width: '90%',
      height: 200,
      margin: 20,
      cursor: 'pointer',
      backgroundColor: '#ffffff',
      borderWidth: 1,
      borderStyle: 'dashed',
      borderRadius: 2,
      display: 'flex',
      justifyContent: 'center',
      justifyItems: 'center',
      alignItems: 'center',
      flexFlow: 'row wrap',
      boxShadow: '0px 2px 2px rgba(131, 138, 154, 0.50)'
    },
    icon: {
      fontSize: 44,
      marginTop: 20
    },
    dropText: {
      padding: 20,
      paddingTop: 0,
      textAlign: 'center'
    },
    templateUrl: {}
  };
});

function SimpleDropzone(props) {
  var classes = useStyle(props);

  function _onDrop(acceptedFiles) {
    var file = acceptedFiles;

    if (file) {
      // max number of megabytes
      var maxMb = props.maxMb ? props.maxMb : 5;

      if (file[0].size < maxMb * 1024 * 1024) {
        props.onDrop(acceptedFiles);
      } else {
        // Error message dimension of file is too big
        window.alert("The max dimension allowed for file is ".concat(maxMb, " MB."));
      }
    }
  }
  /**
   * @return {string}
   */


  function CheckHidden(loader) {
    if (loader) return 'none';
    return 'block';
  }

  var _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      loading = props.loading,
      filesStep = props.filesStep,
      filesToBeSent = props.filesToBeSent,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? 'cloud_upload' : _props$icon,
      _props$helperText = props.helperText,
      helperText = _props$helperText === void 0 ? 'Clicca o trascina direttamente qui i file per caricarli.' : _props$helperText;
  return React.createElement("div", {
    className: classes.dropzoneRoot
  }, React.createElement(Dropzone$1, _extends({
    multiple: multiple,
    onDrop: function onDrop(files) {
      return _onDrop(files);
    },
    ref: function ref(_ref2) {
      return props.getRef(_ref2);
    }
  }, props), function (_ref) {
    var getRootProps = _ref.getRootProps,
        getInputProps = _ref.getInputProps;
    return React.createElement("div", _extends({
      className: classes.dropzone,
      style: _objectSpread2({}, props.zoneStyle)
    }, getRootProps()), React.createElement("input", getInputProps()), React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }
    }, React.createElement(Icon$1, {
      className: classes.icon,
      style: {
        display: CheckHidden(loading)
      }
    }, icon), React.createElement(Typography$1, {
      className: [classes.typography, classes.dropText],
      style: {
        display: CheckHidden(loading)
      }
    }, helperText)), React.createElement("div", {
      style: {
        textAlign: 'center'
      },
      hidden: !loading
    }, React.createElement(CircularProgress, {
      size: 40
    }), React.createElement("br", null), React.createElement(Typography$1, {
      className: classes.loaderFileStatusText
    }, filesStep, ' ', "/", ' ', filesToBeSent)));
  }));
}

var SimpleDropzone$1 = compose(withStyles$1({
  withTheme: true
}))(SimpleDropzone);
var useStyle$1 = makeStyles(function (theme) {
  return {
    dialogPaper: _defineProperty({}, theme.breakpoints.down('xs'), {
      margin: 10
    })
  };
});

function DialogDropzone(props) {
  var classes = useStyle$1(props);

  function _onDrop(acceptedFiles) {
    var file = acceptedFiles;

    if (file) {
      // max number of megabytes
      var maxMb = props.maxMb ? props.maxMb : 5;

      if (file[0].size < maxMb * 1024 * 1024) {
        props.onDrop(acceptedFiles);
      } else {
        // Error message dimension of file is too big
        window.alert("The max dimension allowed for file is ".concat(maxMb, " MB."));
      }
    }
  }

  var open = props.open,
      title = props.title,
      contentText = props.contentText,
      multiple = props.multiple,
      loading = props.loading,
      cancelText = props.cancelText;
  return React.createElement("div", null, React.createElement(Dialog$1, {
    open: open,
    onClose: function onClose() {
      return props.onClose();
    },
    PaperProps: {
      classes: {
        root: classes.dialogPaper
      }
    }
  }, React.createElement(DialogTitle$1, null, title), React.createElement(DialogContentText, {
    style: {
      padding: '0px 24px 8px 24px',
      marginBottom: 0
    }
  }, React.createElement(Typography$1, null, contentText)), React.createElement(DialogContent$1, {
    style: {
      borderTop: '1px solid rgba(0, 0, 0, 0.12)'
    }
  }, React.createElement(SimpleDropzone$1, _extends({
    multiple: multiple,
    onDrop: function onDrop(files) {
      return _onDrop(files);
    }
  }, props))), React.createElement(DialogActions$1, null, React.createElement(Button$1, {
    disabled: loading,
    onClick: props.onClose
  }, cancelText))));
}

var DialogDropzone$1 = compose(withStyles$1({
  withTheme: true
}))(DialogDropzone);

function Dropzone(props) {
  return React.createElement(React.Fragment, null, props.dialog ? React.createElement(DialogDropzone$1, props) : React.createElement(SimpleDropzone$1, props));
}
/**
 * Render the correct component usign component
 * @param item
 * @returns {*}
 */


function renderField(item, extProps) {
  var props = _objectSpread2({}, item);

  switch (item.component) {
    case 'button':
      return React.createElement(FunctionButton, props);

    default:
      return React.createElement(FunctionButton, props);
  }
}

function FunctionButton(props) {
  var styles = {
    label: {
      display: 'flex',
      flexDirection: 'row'
    },
    labelReverse: {
      display: 'flex',
      flexDirection: 'row-reverse'
    }
  };
  var _props$reverse = props.reverse,
      reverse = _props$reverse === void 0 ? false : _props$reverse;
  return (// props.onClick()
    React.createElement(Button, _extends({
      style: props.label ? {
        minWidth: 100,
        marginRight: 8
      } : {
        marginRight: 8
      }
    }, props, {
      styles: !reverse ? _objectSpread2({}, styles.label) : _objectSpread2({}, styles.labelReverse),
      onClick: function onClick() {
        return props.func();
      }
    }), props.icon && typeof props.icon === 'function' ? props.icon({
      fontSize: 16,
      margin: reverse ? '0px 0xp 0xp 4px' : '0px 4xp 0xp 0px'
    }) : props.icon && React.createElement(Icon, {
      style: {
        fontSize: 16,
        margin: reverse ? '0px 0xp 0xp 4px' : '0px 4xp 0xp 0px'
      }
    }, props.icon), props.label)
  );
}

var useStyles$9 = makeStyles(function (theme) {
  return {};
});

function FunctionsToolbar(props) {
  var classes = useStyles$9();
  var items = props.items;
  return React.createElement("div", _extends({}, props, {
    style: _objectSpread2({}, props.style)
  }), items.map(function (item) {
    return renderField(item);
  }));
}

FunctionsToolbar.propTypes = {
  /** Define the list of elements of functions toolbar */
  items: propTypes.array.isRequired,

  /** Define style */
  style: propTypes.object
};
FunctionsToolbar.defaultProps = {};
var Settings = {
  gridWidth: 200,
  componentWidth: '100%',
  margin: '12px 9px'
};
var useStyles$a = makeStyles(function () {
  return {
    root: {
      flexBasis: '100%',
      minWidth: Settings.gridWidth,
      margin: Settings.margin,
      float: 'left',
      height: 64,
      display: 'flex',
      alignItems: 'center',
      '& div:first-of-type': {
        flex: 1
      }
    }
  };
});

function LayoutProvider(props) {
  var classes = useStyles$a();
  var field = props.field;
  var _field$layoutStyle = field.layoutStyle,
      layoutStyle = _field$layoutStyle === void 0 ? {} : _field$layoutStyle;
  return React.createElement("div", {
    className: classes.root,
    style: _objectSpread2({}, props.style, {}, getStyle(field, props), {}, layoutStyle)
  }, props.children);
}

function getStyle(field, props) {
  var style = props.style;

  if (field.visible === false) {
    return _objectSpread2({}, style, {
      display: 'none'
    });
  }

  if (field.wrap) {
    return _objectSpread2({}, style, {
      clear: 'both'
    });
  }

  return null;
}
/**
 * @description Return true or false if the component is a classComponent
 * @param {component} Component
 * @return {boolean} return if is a classComponent
 */


function isClassComponent(component) {
  return !!(typeof component === 'function' && !!component.prototype.isReactComponent);
}

function isFunctionComponent(component) {
  return !!(typeof component === 'function' && String(component).includes('return React.createElement'));
}

function isReactComponent(component) {
  return !!(isClassComponent(component) || isFunctionComponent(component));
}

function isElement(element) {
  return React.isValidElement(element);
}

function isDOMTypeElement(element) {
  return isElement(element) && typeof element.type === 'string';
}

function isCompositeTypeElement(element) {
  return isElement(element) && typeof element.type === 'function';
}

function consoleLogComponent(Component) {
  console.group('REACT DOM ELEMENT');
  console.log('isReactComponent:', isReactComponent(Component)); // true

  console.log('isClassComponent:', isClassComponent(Component)); // true

  console.log('isFunctionComponent:', isFunctionComponent(Component)); // false

  console.log('isElement:', isElement(Component)); // false

  console.log('isReactComponent:', isReactComponent(React.createElement(Component, null))); // false

  console.log('isElement:', isElement(React.createElement(Component, null))); // true

  console.log('isDOMTypeElement:', isDOMTypeElement(React.createElement(Component, null))); // false

  console.log('isCompositeTypeElement:', isCompositeTypeElement(React.createElement(Component, null))); // true

  console.groupEnd();
}

var useStyles$b = makeStyles(function () {
  return {
    root: {
      padding: '20px 0'
    },
    title: {
      fontWeight: 500,
      fontSize: 14
    }
  };
});

function Divider(props) {
  var classes = useStyles$b();
  var field = props.field;
  return React.createElement("div", {
    className: classes.root
  }, field.label && React.createElement(Typography, {
    className: classes.title
  }, field.label));
}

var useStyles$c = makeStyles(function () {
  return {
    root: {
      height: 52
    }
  };
});

function Checkbox(props) {
  var classes = useStyles$c();
  var field = props.field;
  return React.createElement(FormControlLabel, {
    className: classes.root,
    control: React.createElement(Checkbox$1, _extends({
      checked: field.value,
      name: field.key,
      onChange: function onChange(e) {
        return props.onChange(props.prepareValue(field.key, e.target.checked));
      }
    }, field)),
    label: field.label
  });
}

function InputValidator(props) {
  var field = props.field; // input validator select

  var styleValidator = {
    opacity: 0,
    height: 0,
    marginTop: 52,
    position: 'absolute',
    left: 0,
    width: '100%',
    padding: 0
  };
  return React.createElement("input", {
    name: field.key,
    id: "".concat(field.component, "-").concat(field.key),
    style: _objectSpread2({}, styleValidator),
    required: field.required,
    value: field.value
  });
}

var useStyles$d = makeStyles(function (theme) {
  return {
    formControl: {
      minWidth: Settings.componentWidth
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  };
});

function Select(props) {
  var classes = useStyles$d();
  var field = props.field;
  var inputLabel = React.useRef(null);

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      labelWidth = _React$useState2[0],
      setLabelWidth = _React$useState2[1];

  React.useEffect(function () {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []); // input validator select

  var styleValidator = {
    opacity: 0,
    height: 0,
    marginTop: 52,
    position: 'absolute',
    width: '100%',
    padding: 0
  };
  return React.createElement(FormControl, {
    required: field.required,
    variant: "outlined",
    className: classes.formControl
  }, React.createElement(InputLabel, {
    ref: inputLabel,
    htmlFor: "".concat(field.component, "-").concat(field.key)
  }, field.label), React.createElement(Select$1, _extends({
    onChange: function onChange(e) {
      return props.onChange(e);
    },
    labelWidth: labelWidth,
    style: {
      maxWidth: '100%'
    },
    inputProps: {
      name: field.key,
      id: "".concat(field.component, "-").concat(field.key),
      type: 'text',
      style: _objectSpread2({}, styleValidator),
      required: field.required
    },
    MenuProps: {
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    },
    value: field.value
  }, field), React.createElement(MenuItem, {
    key: "$item-$null",
    value: null
  }), field.values && sortValues(field.values).map(function (item, index) {
    return React.createElement(MenuItem, {
      key: "".concat(item, "-").concat(index),
      value: item
    }, item.label);
  })), React.createElement(InputValidator, {
    field: field
  }));
}

var useStyles$e = makeStyles$1(function (theme) {
  return {
    root: {},
    labelContainer: {
      transform: 'translate(14px, -6px) scale(0.75)',
      pointerEvents: 'none',
      transformOrigin: 'top left',
      top: 0,
      padding: '0px 2px',
      left: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      zIndex: 1
    },
    label: {
      color: 'rgba(0, 0, 0, 0.54)',
      padding: 0,
      fontSize: '0.9285714285714286rem',
      fontFamily: 'Poppins,sans-serif',
      fontWeight: 400,
      lineHeight: 1
    },
    formControl: {
      minWidth: Settings.componentWidth
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    boxShadow: {
      boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
    },
    noWrap: {
      flexWrap: 'nowrap'
    },
    background: {
      background: '#fff',
      margin: '0px',
      padding: '4px 0px'
    }
  };
});

function SelectAuto(props) {
  var classes = useStyles$e();
  var field = props.field;
  var _field$value = field.value;
  var icon = React.createElement(CheckBoxOutlineBlankIcon, {
    fontSize: "small",
    color: "primary"
  });
  var checkedIcon = React.createElement(CheckBoxIcon, {
    fontSize: "small",
    color: "primary"
  });

  var handleChange = function handleChange(value) {
    var changeValue = value;
    props.onChange(props.prepareValue(field.key, changeValue));
  };

  return React.createElement(React.Fragment, null, React.createElement(Autocomplete$1, _extends({
    options: sortValues(field.values),
    getOptionLabel: function getOptionLabel(option) {
      return "".concat(option.label);
    },
    className: classes.formControl,
    autoHighlight: true,
    variant: "outlined",
    fullWidth: true,
    clearText: "",
    openText: "",
    disableCloseOnSelect: field.multiple,
    name: field.key,
    onChange: function onChange(e, value) {
      return handleChange(value);
    },
    classes: {
      popper: classes.boxShadow,
      inputRoot: classes.noWrap,
      paper: classes.background
    }
  }, field, {
    renderInput: function renderInput(params) {
      return React.createElement(TextField, _extends({}, params, {
        label: field.label,
        variant: "outlined",
        fullWidth: true
      }));
    },
    renderTags: function renderTags(value, getTagProps) {
      return value.map(function (option, index) {
        return React.createElement("span", _extends({
          style: {
            font: 'inherit',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }
        }, getTagProps({
          index: index
        })), option.label);
      });
    },
    renderOption: function renderOption(option, _ref) {
      var selected = _ref.selected;
      return field.multiple ? React.createElement(React.Fragment, null, React.createElement(Checkbox$1, {
        color: "primary",
        icon: icon,
        checkedIcon: checkedIcon,
        style: {
          marginRight: 8
        },
        checked: selected
      }), option.label) : React.createElement(React.Fragment, null, option.label);
    }
  })));
}

var useStyles$f = makeStyles(function () {
  return {
    root: {
      minWidth: 140
    }
  };
}); // TODO: need to complete

function Slider(props) {
  var classes = useStyles$f();
  var field = props.field;
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(Typography, {
    style: {
      fontSize: 12,
      color: 'rgba(0, 0, 0, 0.54)'
    }
  }, field.label), React.createElement(SliderMaterial, _extends({
    valueLabelDisplay: "auto",
    marks: true,
    defaultValue: field.value
  }, field, {
    onChange: function onChange(e, value) {
      return value ? props.onChange(props.prepareValue(field.key, value)) : null;
    }
  })));
}

var useStyles$g = makeStyles(function () {
  return {
    root: {
      cursor: 'default',
      position: 'relative'
    },
    button: {
      width: Settings.componentWidth
    },
    label: {
      fontSize: 9,
      marginTop: 2,
      textAlign: 'center'
    }
  };
});

function File(props) {
  var fileNameCheck = props.field.value ? '1 files selected' : null;
  var classes = useStyles$g();

  var _useState = useState(fileNameCheck),
      _useState2 = _slicedToArray(_useState, 2),
      filename = _useState2[0],
      setFilename = _useState2[1];

  var field = props.field;
  var buttonProps = field.buttonProps;

  function onUpload(e) {
    setFilename("".concat(e.target.files.length, " files selected"));
    props.onChange(props.prepareValue(field.key, e.target.files[0]));
  }

  return React.createElement("div", _extends({
    className: classes.root
  }, field), React.createElement("input", {
    className: classes.input,
    style: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      opacity: 0
    },
    type: "file",
    id: field.key,
    name: field.key,
    required: field.required ? !props.field.value : false,
    onChange: function onChange(e) {
      return onUpload(e);
    },
    value: null
  }), React.createElement("label", {
    htmlFor: field.key
  }, React.createElement(Button, _extends({
    variant: "outlined",
    component: "span",
    className: classes.button,
    disabled: field.disabled
  }, buttonProps), "Upload"), React.createElement("div", {
    className: classes.label
  }, filename)));
}

var useStyles$h = makeStyles(function () {
  return {
    root: {
      width: Settings.componentWidth
    }
  };
});

function Input(props) {
  var classes = useStyles$h();

  var field = _objectSpread2({}, props.field);

  delete field.component; // prevent input error on {...field}

  return React.createElement(TextField, _extends({
    className: classes.root,
    onChange: function onChange(e) {
      return props.onChange(props.prepareValue(field.key, e.target.value));
    },
    InputLabelProps: {
      shrink: true
    },
    variant: "outlined",
    name: field.key
  }, field, {
    helperText: null // use formHelperText
    ,
    inputProps: {
      minLength: field.minLength,
      maxLength: field.maxLength,
      min: field.min,
      max: field.max
    }
    /* eslint-disable-next-line react/jsx-no-duplicate-props */
    ,
    InputProps: {
      readOnly: field.readOnly
    }
  }));
}

var useStyles$i = makeStyles(function () {
  return {
    root: {
      width: Settings.componentWidth
    }
  };
});

function Text(props) {
  var classes = useStyles$i();
  var field = props.field;
  return React.createElement(Typography, _extends({
    className: classes.root,
    name: field.key
  }, field), field.label);
}

var useStyles$j = makeStyles(function () {
  var _muiInputRoot;

  return {
    root: {
      width: Settings.componentWidth
    },
    strength0: {
      display: 'none'
    },
    strength1: {
      '& div': {
        background: '#b5b5b5'
      }
    },
    strength2: {
      '& div': {
        background: '#ba0018'
      }
    },
    strength3: {
      '& div': {
        background: '#e9b200'
      }
    },
    strength4: {
      '& div': {
        background: '#0077a8'
      }
    },
    strength5: {
      '& div': {
        background: '#04aa00'
      }
    },
    muiInputRoot: (_muiInputRoot = {
      marginTop: 6
    }, _defineProperty(_muiInputRoot, "& input", {
      padding: '12.5px 14px 8.5px 14px',
      height: '1.5em'
    }), _defineProperty(_muiInputRoot, "& label", {
      transform: 'translate(14px, 16px) scale(1)'
    }), _muiInputRoot)
  };
});

function Password(props) {
  var classes = useStyles$j();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      passwordVisibility = _useState2[0],
      setPasswordVisibility = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      strengthValue = _useState4[0],
      setStrengthValue = _useState4[1];

  var field = _objectSpread2({}, props.field); // prevent input error on {...field}


  delete field.component;
  delete field.type;

  function handleOnChange(event) {
    event.persist();
    var valueStrength = checkStrength(event.target.value);
    setStrengthValue(event.target.value !== '' ? valueStrength : 0);
    props.onChange(event);
  }

  function getColorPasswordStrength(value, classes) {
    switch (value) {
      case 20:
        return classes.strength1;

      case 40:
        return classes.strength2;

      case 60:
        return classes.strength3;

      case 80:
        return classes.strength4;

      case 100:
        return classes.strength5;

      default:
        return null;
    }
  }

  return React.createElement(React.Fragment, null, React.createElement(TextField, _extends({
    error: field.error,
    className: classes.root,
    variant: "outlined",
    classes: {
      root: classes.muiInputRoot
    },
    autoComplete: !field.autocomplete ? 'new-password' : null,
    type: !passwordVisibility ? 'password' : 'text',
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    name: field.key
  }, field, {
    helperText: null // use formHelperText
    ,
    InputProps: {
      endAdornment: React.createElement(InputAdornment, {
        position: "end"
      }, React.createElement(IconButton, {
        "aria-label": "toggle password visibility",
        onClick: function onClick() {
          return setPasswordVisibility(!passwordVisibility);
        },
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      }, passwordVisibility ? React.createElement(Visibility, null) : React.createElement(VisibilityOff, null)))
    }
  })), React.createElement("div", null, React.createElement(LinearProgress, {
    variant: "determinate",
    className: getColorPasswordStrength(strengthValue, classes),
    style: {
      background: '#f5f6f7',
      marginTop: 8,
      marginBottom: 4
    },
    value: strengthValue
  })));
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/* Override the font-style italic for address */\naddress{\n  font-style: normal;\n}\n";
styleInject(css);
var useStyles$k = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      minWidth: 200
    },
    input: {
      display: 'flex',
      padding: 0,
      height: 'auto',
      cursor: 'pointer'
    },
    valueContainer: _defineProperty({
      display: 'flex',
      width: '100%',
      height: 54,
      padding: '0px 14px',
      alignItems: 'center',
      overflow: 'hidden'
    }, '& p', {
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      maxHeight: '100%',
      overflow: 'hidden'
    }),
    chip: {
      margin: theme.spacing(0.5, 0.25)
    },
    chipFocused: {
      backgroundColor: emphasize(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2)
    },
    singleValue: {
      fontSize: 14
    },
    placeholder: {
      position: 'absolute',
      left: 2,
      bottom: 6,
      fontSize: 16
    },
    paper: {
      position: 'absolute',
      zIndex: 99,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0
    },
    divider: {
      height: theme.spacing(2)
    },
    textField: {
      maxWidth: 320,
      fontStyle: 'inherit',
      font: 'inherit'
    }
  };
});
var components = {
  Control: Control,
  Menu: Menu,
  MultiValue: MultiValue,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

function Autocomplete(props) {
  var classes = useStyles$k();
  var theme = useTheme();

  var handleChange = function handleChange(value) {
    var changeValue = value ? value : {
      value: null,
      label: ''
    };
    props.onChange(props.prepareValue(props.name, changeValue));
  };

  var selectStyles = {
    input: function input(base) {
      return _objectSpread2({}, base, {
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit'
        }
      });
    },
    menuPortal: function menuPortal(base, state) {
      return _objectSpread2({}, base, {
        zIndex: 9999
      });
    }
  };
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(NoSsr, null, React.createElement(Select$2, {
    classes: classes,
    styles: selectStyles,
    inputId: "react-select",
    menuPortalTarget: document.body,
    TextFieldProps: {
      InputLabelProps: {
        htmlFor: 'react-select',
        shrink: true
      },
      field: _objectSpread2({}, props.field),
      onSearch: function onSearch(e) {
        return typeof props.onSearch === "function" && props.onSearch(e);
      }
    },
    placeholder: props.placeholder,
    options: props.values,
    components: components,
    value: props.value,
    onChange: handleChange,
    menuPosition: "absolute",
    isClearable: true,
    isMulti: props.multiple,
    isDisabled: props.readOnly,
    isLoading: props.isLoading
  })));
}

function NoOptionsMessage(props) {
  return React.createElement(Typography, _extends({
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}

NoOptionsMessage.propTypes = {
  /**
   * The children to be rendered.
   */
  children: propTypes.node,

  /**
   * Props to be passed on to the wrapper.
   */
  innerProps: propTypes.object.isRequired,
  selectProps: propTypes.object.isRequired
};

function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return React.createElement("div", _extends({
    ref: inputRef
  }, props));
}

inputComponent.propTypes = {
  inputRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.any.isRequired
  })])
};

function Control(props) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeValue = _useState2[0],
      setActiveValue = _useState2[1];

  var children = props.children,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      _props$selectProps = props.selectProps,
      classes = _props$selectProps.classes,
      TextFieldProps = _props$selectProps.TextFieldProps;
  useEffect(function () {
    // Clean the value if receive a new props(value/values)
    if (activeValue !== TextFieldProps.field.value) {
      props.setValue(TextFieldProps.field.value);
      setActiveValue(TextFieldProps.field.value);
    }
  });
  return React.createElement(React.Fragment, null, React.createElement(TextField, _extends({
    variant: "outlined",
    fullWidth: true,
    InputProps: {
      inputComponent: inputComponent,
      inputProps: _objectSpread2({
        className: classes.input,
        ref: innerRef,
        children: children
      }, innerProps, {}, TextFieldProps.field)
    },
    className: classes.textfield
  }, TextFieldProps, {
    onChange: function onChange(e) {
      return TextFieldProps.onSearch && TextFieldProps.onSearch(e);
    },
    helperText: null
  })), React.createElement(InputValidator, {
    field: TextFieldProps.field
  }));
}

Control.propTypes = {
  /**
   * Children to render.
   */
  children: propTypes.node,

  /**
   * The mouse down event and the innerRef to pass down to the controller element.
   */
  innerProps: propTypes.shape({
    onMouseDown: propTypes.func.isRequired
  }).isRequired,
  innerRef: propTypes.oneOfType([propTypes.oneOf([null]), propTypes.func, propTypes.shape({
    current: propTypes.any.isRequired
  })]).isRequired,
  selectProps: propTypes.object.isRequired
};

function Option(props) {
  return React.createElement(MenuItem, _extends({
    ref: props.innerRef,
    selected: props.isFocused,
    component: "div",
    style: {
      fontWeight: props.isSelected ? 500 : 400
    }
  }, props.innerProps), props.children);
}

Option.propTypes = {
  /**
   * The children to be rendered.
   */
  children: propTypes.node,

  /**
   * props passed to the wrapping element for the group.
   */
  innerProps: propTypes.shape({
    id: propTypes.string.isRequired,
    key: propTypes.string.isRequired,
    onClick: propTypes.func.isRequired,
    onMouseMove: propTypes.func.isRequired,
    onMouseOver: propTypes.func.isRequired,
    tabIndex: propTypes.number.isRequired
  }).isRequired,

  /**
   * Inner ref to DOM Node
   */
  innerRef: propTypes.oneOfType([propTypes.oneOf([null]), propTypes.func, propTypes.shape({
    current: propTypes.any.isRequired
  })]).isRequired,

  /**
   * Whether the option is focused.
   */
  isFocused: propTypes.bool.isRequired,

  /**
   * Whether the option is selected.
   */
  isSelected: propTypes.bool.isRequired
};

function Placeholder(props) {
  var selectProps = props.selectProps,
      _props$innerProps = props.innerProps,
      innerProps = _props$innerProps === void 0 ? {} : _props$innerProps,
      children = props.children;
  return React.createElement(Typography, _extends({
    color: "textSecondary",
    className: selectProps.classes.placeholder
  }, innerProps), children);
}

Placeholder.propTypes = {
  /**
   * The children to be rendered.
   */
  children: propTypes.node,

  /**
   * props passed to the wrapping element for the group.
   */
  innerProps: propTypes.object,
  selectProps: propTypes.object.isRequired
};

function SingleValue(props) {
  return React.createElement(Typography, _extends({
    className: props.selectProps.classes.singleValue
  }, props.innerProps), props.children);
}

SingleValue.propTypes = {
  /**
   * The children to be rendered.
   */
  children: propTypes.node,

  /**
   * Props passed to the wrapping element for the group.
   */
  innerProps: propTypes.any.isRequired,
  selectProps: propTypes.object.isRequired
};

function ValueContainer(props) {
  return React.createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}

ValueContainer.propTypes = {
  /**
   * The children to be rendered.
   */
  children: propTypes.node,
  selectProps: propTypes.object.isRequired
};

function MultiValue(props) {
  return React.createElement(Chip, {
    tabIndex: -1,
    label: props.children,
    className: clsx(props.selectProps.classes.chip, _defineProperty({}, props.selectProps.classes.chipFocused, props.isFocused)),
    onDelete: props.removeProps.onClick,
    deleteIcon: React.createElement(CancelIcon, props.removeProps)
  });
}

MultiValue.propTypes = {
  children: propTypes.node,
  isFocused: propTypes.bool.isRequired,
  removeProps: propTypes.shape({
    onClick: propTypes.func.isRequired,
    onMouseDown: propTypes.func.isRequired,
    onTouchEnd: propTypes.func.isRequired
  }).isRequired,
  selectProps: propTypes.object.isRequired
};

function Menu(props) {
  return React.createElement(Paper, _extends({
    className: props.selectProps.classes.paper
  }, props.innerProps), props.children);
}

Menu.propTypes = {
  /**
   * The children to be rendered.
   */
  children: propTypes.element.isRequired,

  /**
   * Props to be passed to the menu wrapper.
   */
  innerProps: propTypes.object.isRequired,
  selectProps: propTypes.object.isRequired
};
var useStyles$l = makeStyles$2(function (theme) {
  return {
    root: {},
    labelContainer: {
      transform: 'translate(14px, -6px) scale(0.75)',
      pointerEvents: 'none',
      transformOrigin: 'top left',
      top: 0,
      padding: '0px 2px',
      left: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      zIndex: 1
    },
    label: {
      color: 'rgba(0, 0, 0, 0.54)',
      padding: 0,
      fontSize: '0.9285714285714286rem',
      fontFamily: 'Poppins,sans-serif',
      fontWeight: 400,
      lineHeight: 1
    }
  };
});

function Address(props) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loader = _useState4[0],
      setLoader = _useState4[1];

  var classes = useStyles$l(props);
  var field = props.field;
  var value = {
    label: getAddressValue(field.value.value),
    value: field.value.value
  };

  function getAddressValue(addressValue) {
    var combinedValue = [];

    if (addressValue) {
      Object.keys(addressValue).map(function (item) {
        var filterData = ['country_code', 'longitude', 'latitude', 'postcode', 'state', 'country'];
        var address = filterData.findIndex(function (filter) {
          return filter === item;
        }) === -1 ? addressValue[item] : null;
        return combinedValue = [].concat(_toConsumableArray(combinedValue), [address]);
      });
      combinedValue = combinedValue.filter(function (item) {
        return item !== null;
      }).join(', ');
    } else combinedValue = '';

    return combinedValue;
  }

  function getApiUrl(address, addressProps) {
    var _addressProps$format = addressProps.format,
        format = _addressProps$format === void 0 ? 'json' : _addressProps$format,
        _addressProps$address = addressProps.addressDetails,
        addressDetails = _addressProps$address === void 0 ? '1' : _addressProps$address,
        _addressProps$country = addressProps.countryCodes,
        countryCodes = _addressProps$country === void 0 ? null : _addressProps$country,
        _addressProps$limit = addressProps.limit,
        limit = _addressProps$limit === void 0 ? 100 : _addressProps$limit;
    var BASE_URL = "https://nominatim.openstreetmap.org/search";
    var FORMAT = "format=".concat(format);
    var ADDRESS_DETAILS = "addressdetails=".concat(addressDetails);
    var QUERY = "q=".concat(address.split(' ').join('+'));
    var COUNTRY_CODES = countryCodes ? "countrycodes=".concat(countryCodes) : null;
    var LIMIT = "limit=".concat(limit);
    return "".concat(BASE_URL, "?").concat(FORMAT, "&").concat(ADDRESS_DETAILS, "&").concat(COUNTRY_CODES, "&").concat(QUERY, "&").concat(LIMIT);
  }

  function handleChange(e) {
    e.persist();
    var addressProps = field.addressProps ? field.addressProps : {};
    var address = e.target.value;
    var url = getApiUrl(address, addressProps);
    getData(url);
  }

  function getData(url) {
    setLoader(true);
    props.onApiCall({
      method: 'post',
      url: url,
      config: {
        baseUrl: false,
        authorization: false
      }
    }).then(function (res) {
      var data = res.data;
      setValues(data.map(function (item) {
        return {
          label: item.display_name,
          value: _objectSpread2({}, item.address, {
            latitude: item.lat,
            longitude: item.lon
          })
        };
      }));
      setLoader(false);
    }, function (err) {
      console.warn(err);
      setLoader(false);
    });
  }

  return React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React.createElement("div", {
    className: classes.labelContainer
  }, React.createElement("label", {
    className: classes.label
  }, field.label)), React.createElement(Autocomplete, {
    placeholder: "",
    field: field,
    value: value,
    name: field.key,
    values: values,
    onChange: function onChange(text) {
      return props.onChange(text);
    },
    prepareValue: function prepareValue(name, text) {
      return props.prepareValue(name, text);
    },
    onSearch: function onSearch(e) {
      return handleChange(e);
    },
    isLoading: loader
  }));
}

var mapStateToProps$9 = function mapStateToProps() {
  return {};
};

var mapActionsToProps$3 = {
  onApiCall: apiCall
};
var Address$1 = compose(connect(mapStateToProps$9, mapActionsToProps$3))(Address);

function ChangePasswordForm(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return React.createElement(React.Fragment, null, React.createElement(Button$1$1, {
    color: "primary",
    variant: "contained",
    onClick: function onClick() {
      return setOpen(true);
    }
  }, "Open change password"), React.createElement(ChangePassword$1, {
    open: open,
    title: "Change password dialog",
    field: {
      keyName: 'password',
      fieldName: 'Password'
    },
    onCancel: function onCancel() {
      return setOpen(false);
    },
    onSubmit: function onSubmit(value) {
      props.field.onSubmit(value);
      setOpen(false);
    },
    cancelProps: {
      label: 'Cancel'
    },
    submitProps: {
      label: 'Confirm'
    }
  }));
}

var MomentUtils =
/** @class */
function () {
  function MomentUtils(_a) {
    var _b = _a === void 0 ? {} : _a,
        locale = _b.locale,
        instance = _b.instance,
        moment$1 = _b.moment;

    this.yearFormat = "YYYY";
    this.yearMonthFormat = "MMMM YYYY";
    this.dateTime12hFormat = "MMMM Do hh:mm a";
    this.dateTime24hFormat = "MMMM Do HH:mm";
    this.time12hFormat = "hh:mm A";
    this.time24hFormat = "HH:mm";
    this.dateFormat = "MMMM Do";
    this.moment = instance || moment$1 || moment;
    this.locale = locale;
  }

  MomentUtils.prototype.parse = function (value, format) {
    if (value === "") {
      return null;
    }

    return this.moment(value, format, true);
  };

  MomentUtils.prototype.date = function (value) {
    if (value === null) {
      return null;
    }

    var moment = this.moment(value);
    moment.locale(this.locale);
    return moment;
  };

  MomentUtils.prototype.isValid = function (value) {
    return this.moment(value).isValid();
  };

  MomentUtils.prototype.isNull = function (date) {
    return date === null;
  };

  MomentUtils.prototype.getDiff = function (date, comparing) {
    return date.diff(comparing);
  };

  MomentUtils.prototype.isAfter = function (date, value) {
    return date.isAfter(value);
  };

  MomentUtils.prototype.isBefore = function (date, value) {
    return date.isBefore(value);
  };

  MomentUtils.prototype.isAfterDay = function (date, value) {
    return date.isAfter(value, "day");
  };

  MomentUtils.prototype.isBeforeDay = function (date, value) {
    return date.isBefore(value, "day");
  };

  MomentUtils.prototype.isBeforeYear = function (date, value) {
    return date.isBefore(value, "year");
  };

  MomentUtils.prototype.isAfterYear = function (date, value) {
    return date.isAfter(value, "year");
  };

  MomentUtils.prototype.startOfDay = function (date) {
    return date.clone().startOf("day");
  };

  MomentUtils.prototype.endOfDay = function (date) {
    return date.clone().endOf("day");
  };

  MomentUtils.prototype.format = function (date, formatString) {
    date.locale(this.locale);
    return date.format(formatString);
  };

  MomentUtils.prototype.formatNumber = function (numberToFormat) {
    return numberToFormat;
  };

  MomentUtils.prototype.getHours = function (date) {
    return date.get("hours");
  };

  MomentUtils.prototype.addDays = function (date, count) {
    return count < 0 ? date.clone().subtract(Math.abs(count), "days") : date.clone().add(count, "days");
  };

  MomentUtils.prototype.setHours = function (date, count) {
    return date.clone().hours(count);
  };

  MomentUtils.prototype.getMinutes = function (date) {
    return date.get("minutes");
  };

  MomentUtils.prototype.setMinutes = function (date, count) {
    return date.clone().minutes(count);
  };

  MomentUtils.prototype.getSeconds = function (date) {
    return date.get("seconds");
  };

  MomentUtils.prototype.setSeconds = function (date, count) {
    return date.clone().seconds(count);
  };

  MomentUtils.prototype.getMonth = function (date) {
    return date.get("month");
  };

  MomentUtils.prototype.isSameDay = function (date, comparing) {
    return date.isSame(comparing, "day");
  };

  MomentUtils.prototype.isSameMonth = function (date, comparing) {
    return date.isSame(comparing, "month");
  };

  MomentUtils.prototype.isSameYear = function (date, comparing) {
    return date.isSame(comparing, "year");
  };

  MomentUtils.prototype.isSameHour = function (date, comparing) {
    return date.isSame(comparing, "hour");
  };

  MomentUtils.prototype.setMonth = function (date, count) {
    return date.clone().month(count);
  };

  MomentUtils.prototype.getMeridiemText = function (ampm) {
    return ampm === "am" ? "AM" : "PM";
  };

  MomentUtils.prototype.startOfMonth = function (date) {
    return date.clone().startOf("month");
  };

  MomentUtils.prototype.endOfMonth = function (date) {
    return date.clone().endOf("month");
  };

  MomentUtils.prototype.getNextMonth = function (date) {
    return date.clone().add(1, "month");
  };

  MomentUtils.prototype.getPreviousMonth = function (date) {
    return date.clone().subtract(1, "month");
  };

  MomentUtils.prototype.getMonthArray = function (date) {
    var firstMonth = date.clone().startOf("year");
    var monthArray = [firstMonth];

    while (monthArray.length < 12) {
      var prevMonth = monthArray[monthArray.length - 1];
      monthArray.push(this.getNextMonth(prevMonth));
    }

    return monthArray;
  };

  MomentUtils.prototype.getYear = function (date) {
    return date.get("year");
  };

  MomentUtils.prototype.setYear = function (date, year) {
    return date.clone().set("year", year);
  };

  MomentUtils.prototype.mergeDateAndTime = function (date, time) {
    return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
  };

  MomentUtils.prototype.getWeekdays = function () {
    return this.moment.weekdaysShort(true);
  };

  MomentUtils.prototype.isEqual = function (value, comparing) {
    if (value === null && comparing === null) {
      return true;
    }

    return this.moment(value).isSame(comparing);
  };

  MomentUtils.prototype.getWeekArray = function (date) {
    var start = date.clone().startOf("month").startOf("week");
    var end = date.clone().endOf("month").endOf("week");
    var count = 0;
    var current = start;
    var nestedWeeks = [];

    while (current.isBefore(end)) {
      var weekNumber = Math.floor(count / 7);
      nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
      nestedWeeks[weekNumber].push(current);
      current = current.clone().add(1, "day");
      count += 1;
    }

    return nestedWeeks;
  };

  MomentUtils.prototype.getYearRange = function (start, end) {
    var startDate = this.moment(start).startOf("year");
    var endDate = this.moment(end).endOf("year");
    var years = [];
    var current = startDate;

    while (current.isBefore(endDate)) {
      years.push(current);
      current = current.clone().add(1, "year");
    }

    return years;
  }; // displaying methods


  MomentUtils.prototype.getCalendarHeaderText = function (date) {
    return this.format(date, this.yearMonthFormat);
  };

  MomentUtils.prototype.getYearText = function (date) {
    return this.format(date, "YYYY");
  };

  MomentUtils.prototype.getDatePickerHeaderText = function (date) {
    return this.format(date, "ddd, MMM D");
  };

  MomentUtils.prototype.getDateTimePickerHeaderText = function (date) {
    return this.format(date, "MMM D");
  };

  MomentUtils.prototype.getMonthText = function (date) {
    return this.format(date, "MMMM");
  };

  MomentUtils.prototype.getDayText = function (date) {
    return this.format(date, "D");
  };

  MomentUtils.prototype.getHourText = function (date, ampm) {
    return this.format(date, ampm ? "hh" : "HH");
  };

  MomentUtils.prototype.getMinuteText = function (date) {
    return this.format(date, "mm");
  };

  MomentUtils.prototype.getSecondText = function (date) {
    return this.format(date, "ss");
  };

  return MomentUtils;
}();

var useStyles$m = makeStyles(function () {
  return {
    root: {
      height: 52
    },
    hidden: _defineProperty({}, "& input", {
      visibility: 'hidden'
    }),
    date: {
      minWidth: 130,
      '& label': {
        transform: 'translate(14px, -6px) scale(0.75)',
        backgroundColor: '#fff'
      }
    },
    normal: {}
  };
});

function Date$1(props) {
  var classes = useStyles$m(props);
  var field = props.field;

  var _useState = useState(field.value ? field.value : null),
      _useState2 = _slicedToArray(_useState, 2),
      clearedDate = _useState2[0],
      setClearedDate = _useState2[1];

  var _onChange = props.onChange;

  var pickerProps = _objectSpread2({}, field);

  delete pickerProps.value;
  return React.createElement(React.Fragment, null, React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, React.createElement(KeyboardDatePicker, _extends({
    inputVariant: "outlined",
    onChange: function onChange(date) {
      setClearedDate(date);

      _onChange(props.prepareValue(field.key, getDateISO(date)));
    },
    format: "DD/MM/YYYY",
    views: ["year", "month", "date"],
    autoOk: true,
    className: classes.date,
    variant: "inline",
    value: clearedDate,
    helperText: null
  }, pickerProps))));
}

var useStyles$n = makeStyles(function () {
  return {
    root: {
      height: 52
    }
  };
});

function DateTime(props) {
  var classes = useStyles$n();
  var field = props.field;
  return React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, React.createElement(KeyboardDateTimePicker, _extends({
    inputVariant: "outlined",
    onChange: function onChange(date) {
      return props.onChange(props.prepareValue(field.key, getDateTimeISO(date)));
    },
    format: "DD/MM/YY HH:mm",
    views: ["year", "month", "date"],
    variant: "inline"
  }, field, {
    helperText: null // use formHelperText

  })));
}

var useStyles$o = makeStyles(function () {
  return {
    root: {
      height: 52
    }
  };
});

function Time(props) {
  var classes = useStyles$o();
  var field = props.field;
  return React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, React.createElement(KeyboardTimePicker, _extends({
    ampm: false,
    inputVariant: "outlined",
    onChange: function onChange(date) {
      return props.onChange(props.prepareValue(field.key, getTimeISO(date)));
    },
    variant: "inline"
  }, field, {
    helperText: null // use formHelperText

  })));
}
/**
 * merge the fields from backend with the frontend structure
 * @param fieldsFromBackend
 * @param frontPrepare
 * @returns {*}
 */


function prepareFields(formName, fieldsFromBackend, frontPrepare) {
  var fields = frontPrepare.map(function (frontField) {
    var backField = fieldsFromBackend.filter(function (item) {
      return frontField.key === item.key;
    })[0]; // Generate condition function for refs on backend

    if (backField && backField.refs) {
      backField.refs.map(function (ref) {
        return ref.refCondition = function (value) {
          return getFieldRefCondition(ref.condition, value, ref.value);
        };
      });
    } // Generate condition function for refs on frontend


    if (frontField && frontField.refs) {
      frontField.refs.map(function (ref) {
        return ref.refCondition = function (value) {
          return getFieldRefCondition(ref.condition, value, ref.value);
        };
      });
    }

    var mergedField = _objectSpread2({}, backField, {}, frontField); // Prepare the structure {label:translate(field.key].[value]), value:value} for select/select_auto ...


    mergedField = prepareValuesLabel(formName, mergedField);
    return mergedField;
  }); // transform backend properties in camelCase

  return arrayObjToCamelCase(fields);
}
/**
 * Prepare the label structure using translation and default {label: "", value: ""}
 * @param fields
 * @param translate
 */


function prepareValuesLabel(formName, originalField) {
  var field = originalField; // Select

  if (field.component === 'select') {
    if (field.values) {
      field.values = field.values.map(function (item) {
        return getValues(item);
      });
      field.value = field.multiple ? field.values.filter(function (item) {
        return field.value && field.value.includes(item.value);
      }) : field.values.filter(function (item) {
        return item.value === field.value;
      })[0]; // if value is undefined set [] for multiple fields

      if (field.multiple && typeof field.value === 'undefined') field.value = [];
    }
  } // Autocomplete


  if (field.component === 'select_auto') {
    if (field.values) {
      field.values = field.values.map(function (item) {
        return getValues(item);
      });

      if (Array.isArray(field.value)) {
        if (field.multiple && field.value.length > 0) {
          field.value = field.value.map(function (item) {
            var index = field.values.findIndex(function (values) {
              return values.value === item;
            });
            return field.values[index];
          });
        } else field.value = field.value.map(function (item) {
          return {
            label: getLabel(field.key, item),
            value: item
          };
        });
      } else {
        field.value = field.values.filter(function (item) {
          return item.value === field.value;
        })[0];
        if (field.multiple && typeof field.value === 'undefined') field.value = [];
      }
    }
  } // Address


  if (field.component === 'address') {
    field.value = {
      label: field.value && field.value.address,
      value: field.value
    };
  }

  function getValues(item) {
    if (_typeof(item) !== 'object') {
      return {
        label: getLabel(field.key, item),
        value: item
      };
    }

    return item;
  }

  function getLabel(key, item) {
    // if formName props exist create the translation string as {formName}.{key}.{item}
    var label = formName ? "".concat(formName, ".").concat(key, ".").concat(item) : "".concat(key, ".").concat(item);
    var translation = translate(label);

    if (translation !== 'TRANSLATION_NOT_FOUND') {
      return translation;
    }

    return item;
  }

  return field;
}
/**
 * Clean the labels and check the value
 * @param field
 */


function cleanValuesLabel(field) {
  // Select Component
  if (field.component === 'select') {
    if (field.values) {
      field.values = field.values.map(function (item) {
        return item.value;
      });
      field.value = field.multiple ? field.values.filter(function (item) {
        return item === field.value;
      }) : field.values.filter(function (item) {
        return item === field.value.value;
      })[0];
    }
  } // Autocomplete Component


  if (field.component === 'select_auto') {
    if (field.values) {
      field.values = field.values.map(function (item) {
        return item.value ? item.value : item;
      });

      if (field.value) {
        if (Array.isArray(field.value)) {
          field.value = field.value.map(function (item) {
            return item.value ? item.value : item;
          });
        } else {
          field.value = field.values.filter(function (item) {
            return item === field.value;
          })[0];
        }
      }
    }
  } // Address Component


  if (field.component === 'address') {
    field.value = field.value.value;
  }
}
/**
 * Get value checking the typeof
 * @param field
 * @param property
 * @returns {*}
 */


function getValue(field) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  var value = ""; // object control for {label:"",value:""} structure

  if (_typeof(field[property]) === 'object') {
    // array control for [{label:"",value:""},...] structure (select_auto_multiple)
    if (Array.isArray(field.value)) {
      value = field[property].map(function (item) {
        return item.value;
      });
    } else {
      value = field[property] && field[property].value ? field[property].value : field.value;
    }
  } else {
    value = field.value;
  }

  return value;
}
/**
 * Define if the field is renderable using a condition
 * @param formSerialized
 * @param field
 * @returns {*|boolean|boolean}
 */


function fieldConditionally(formSerialized, field) {
  if (field.refs) {
    var result = field.refs.map(function (ref) {
      var refObj = formSerialized.filter(function (item) {
        return item.key === ref.key;
      })[0];
      var refValue = refObj && getValue(refObj);

      if (typeof ref.refCondition === 'function' && ref.refCondition(refValue)) {
        return true;
      }

      return false;
    });
    return result.every(function (item) {
      return item === true;
    });
  }

  return true;
}
/**
 * Init the state of the form generator
 * @param fields
 * @param data
 * @returns {*}
 */


function initFormSerializedState(fields, props) {
  return fields.map(function (field) {
    return _objectSpread2({}, field, {}, props);
  });
}

function defineErrorsProps(formSerialized, errors) {
  formSerialized.map(function (field) {
    var error = errors.filter(function (err) {
      return err.field === field.key;
    })[0];

    if (error) {
      var index = formSerialized.indexOf(formSerialized.filter(function (field) {
        return field.key === error.field;
      })[0]);

      if (error && index > -1) {
        // eslint-disable-next-line no-param-reassign
        field.error = true;
        field.helperText = error.message;
      } else {
        cleanError(field);
      }
    } else {
      cleanError(field);
    }

    function cleanError(el) {
      el.error = null;
      el.helperText = null;
    }
  });
  return formSerialized;
}

function isSerializable(formSerialized, field) {
  // if is renderable and serializable
  var isVisible = fieldConditionally(formSerialized, field);
  var index = formSerialized.indexOf(formSerialized.filter(function (item) {
    return item.key === field.key;
  })[0]);

  if (!('serialize' in formSerialized[index])) {
    formSerialized[index].serialize = true;
  }

  return isVisible;
}

function _prepareValue(name, value) {
  return {
    target: {
      name: name,
      value: value
    }
  };
}

function renderField$1(field, _onChange) {
  var props = {
    field: field,
    onChange: function onChange(e) {
      return _onChange(e, field.action);
    },
    prepareValue: function prepareValue(name, value) {
      return _prepareValue(name, value);
    }
  };

  if (!isElement(field.component)) {
    switch (field.component) {
      case 'divider':
        return React.createElement(Divider, props);

      case 'checkbox':
        return React.createElement(Checkbox, props);

      case 'select':
        return React.createElement(Select, props);

      case 'select_auto':
        return React.createElement(SelectAuto, props);

      case 'slider':
        return React.createElement(Slider, props);

      case 'file':
        return React.createElement(File, props);

      case 'input':
        return React.createElement(Input, props);

      case 'text':
        return React.createElement(Text, props);

      case 'password':
        return React.createElement(Password, props);

      case 'change-password':
        return React.createElement(ChangePasswordForm, props);

      case 'address':
        return React.createElement(Address$1, props);

      case 'date':
        return React.createElement(Date$1, props);

      case 'datetime':
        return React.createElement(DateTime, props);

      case 'time':
        return React.createElement(Time, props);

      default:
        return React.createElement(Text, props);
    }
  } else {
    var Component = field.component;
    return React.createElement(Component, props);
  }
}

var useStyles$p = makeStyles(function () {
  return {
    root: {},
    empty: {
      height: 20
    }
  };
});

function ErrorLayoutProvider(props) {
  var classes = useStyles$p();
  var field = props.field;

  function getHelperText(text) {
    // if formName props exist create the translation string as {formName}.{key}.{item}
    var translation = translate(text);

    if (translation !== 'TRANSLATION_NOT_FOUND') {
      return translation;
    }

    return text;
  }

  return React.createElement("div", {
    className: classes.root
  }, field.helperText ? React.createElement(FormHelperText, {
    error: field.error
  }, getHelperText(field.helperText)) : React.createElement("div", {
    className: classes.empty
  }));
}

var useStyles$q = makeStyles(function () {
  return {
    root: {}
  };
});

function FormGeneratorActions(props) {
  var classes = useStyles$q();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openCancelDialog = _useState2[0],
      setOpenCancelDialog = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openSubmitDialog = _useState4[0],
      setOpenSubmitDialog = _useState4[1];

  var readOnly = props.readOnly;
  var cancelProps = props.cancelProps,
      submitProps = props.submitProps;
  var onCancel = props.onCancel,
      _onSubmit = props.onSubmit;
  var loading = props.loading;
  var _props$customActions = props.customActions,
      customActions = _props$customActions === void 0 ? null : _props$customActions;
  var _props$buttonVariant = props.buttonVariant,
      buttonVariant = _props$buttonVariant === void 0 ? 'outlined' : _props$buttonVariant;

  function getButtonStyle() {
    switch (buttonVariant) {
      case 'outlined':
        return {};

      case 'contained':
        return {
          variant: 'contained',
          style: {
            borderRadius: 18
          }
        };

      default:
        return {};
    }
  }

  var ActionButton = function ActionButton(props) {
    var _props$disabled = props.disabled,
        disabled = _props$disabled === void 0 ? false : _props$disabled,
        label = props.label,
        type = props.type;
    var _props$confirm = props.confirm,
        confirm = _props$confirm === void 0 ? false : _props$confirm;
    if (readOnly && type === 'cancel') confirm = false;
    return !disabled && React.createElement(Button, _extends({}, props, {
      onClick: function onClick() {
        return props.onClick(confirm);
      },
      color: "secondary",
      disabled: loading
    }), !loading ? label : type === 'submit' ? React.createElement(CircularProgress, {
      color: "primary",
      size: 20
    }) : label);
  };

  var CustomActions = customActions;
  return React.createElement(React.Fragment, null, customActions && React.createElement(CustomActions, null), React.createElement(ActionButton, _extends({
    type: "cancel"
  }, cancelProps, {
    label: translate('form_generator.actions.cancel'),
    onClick: function onClick(confirm) {
      return confirm ? setOpenCancelDialog(true) : onCancel();
    }
  })), !readOnly && React.createElement(ActionButton, _extends({
    type: "submit"
  }, getButtonStyle(), submitProps, {
    label: translate('form_generator.actions.submit'),
    onClick: function onClick(confirm) {
      return confirm ? setOpenSubmitDialog(true) : null;
    }
  })), openCancelDialog && React.createElement(ConfirmDialog, {
    open: openCancelDialog,
    title: function title() {
      return React.createElement(React.Fragment, null, React.createElement(Typography$1, {
        style: {
          fontSize: 20,
          marginBottom: 8
        }
      }, translate('form_generator.actions.cancel_confirm_dialog.title')), React.createElement(Typography$1, {
        style: {
          fontFamily: 'Raleway, sans-serif',
          fontSize: 16
        }
      }, translate('form_generator.actions.cancel_confirm_dialog.title_sub')));
    } // message={translate('form_generator.actions.cancel_confirm_dialog.message')}
    ,
    cancelProps: {
      label: translate('form_generator.actions.cancel_confirm_dialog.cancel_btn_label')
    },
    onCancel: function onCancel() {
      return setOpenCancelDialog(false);
    },
    onSubmit: function onSubmit() {
      onCancel();
      setOpenCancelDialog(false);
    },
    submitProps: {
      label: translate('form_generator.actions.cancel_confirm_dialog.submit_btn_label')
    }
  }), openSubmitDialog && React.createElement(ConfirmDialog, {
    open: openSubmitDialog,
    title: translate('form_generator.actions.submit_confirm_dialog.title'),
    message: translate('form_generator.actions.submit_confirm_dialog.message'),
    cancelProps: {
      label: translate('form_generator.actions.submit_confirm_dialog.cancel_btn_label')
    },
    onCancel: function onCancel() {
      return setOpenSubmitDialog(false);
    },
    onSubmit: function onSubmit() {
      _onSubmit();

      setOpenSubmitDialog(false);
    },
    submitProps: {
      label: translate('form_generator.actions.submit_confirm_dialog.submit_btn_label')
    }
  }));
}

var useStyles$r = makeStyles(function () {
  return {};
});

function FormProvider(props) {
  var classes = useStyles$r();
  return React.createElement("form", {
    id: props.id,
    name: props.name,
    className: classes.root,
    autoComplete: "off",
    onSubmit: function onSubmit(e) {
      return typeof props.onSubmit === 'function' ? props.onSubmit(e) : null;
    }
  }, props.children);
}

var useStyles$s = makeStyles$1(function (theme) {
  return {
    subtitle: {
      fontSize: 14,
      fontWeight: 'inherit',
      padding: '0px 24px',
      paddingBottom: 8
    },
    dialogRoot: {
      overflow: 'visible'
    },
    actions: {
      padding: 24,
      position: 'sticky',
      bottom: 0,
      left: 0,
      zIndex: 10,
      background: '#fff',
      borderTop: '1px solid rgba(0, 0, 0, 0.12)'
    },
    dividers: {
      borderBottom: 0
    }
  };
});

function DialogFormGenerator(props) {
  var classes = useStyles$s();
  var open = props.open,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      title = props.title,
      subtitle = props.subtitle;
  var dialogProps = props.dialogProps;
  var confirm = props.confirm;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openCancelDialog = _useState2[0],
      setOpenCancelDialog = _useState2[1];

  return React.createElement(React.Fragment, null, openCancelDialog && React.createElement(ConfirmDialog, {
    open: openCancelDialog // title={translate('form_generator.actions.cancel_confirm_dialog.title')}
    ,
    title: function title() {
      return React.createElement(React.Fragment, null, React.createElement(Typography, {
        style: {
          fontSize: 20
        }
      }, translate('form_generator.actions.cancel_confirm_dialog.title')), React.createElement("br", null), React.createElement(Typography, {
        style: {
          fontFamily: 'Raleway, sans-serif',
          fontSize: 16
        }
      }, translate('form_generator.actions.cancel_confirm_dialog.title_sub')));
    } // message={translate('form_generator.actions.cancel_confirm_dialog.message')}
    ,
    cancelProps: {
      label: translate('form_generator.actions.cancel_confirm_dialog.cancel_btn_label')
    },
    onCancel: function onCancel() {
      return setOpenCancelDialog(false);
    },
    onSubmit: function onSubmit() {
      props.onCancel();
      setOpenCancelDialog(false);
    },
    submitProps: {
      label: translate('form_generator.actions.cancel_confirm_dialog.submit_btn_label')
    }
  }), React.createElement(Dialog, _extends({
    open: open,
    classes: {
      paperWidthMd: classes.dialogRoot
    },
    onClose: function onClose() {
      return props.onClose();
    },
    scroll: scroll,
    "aria-labelledby": "form-generator-dialog-title"
  }, props, {
    maxWidth: "md"
  }, dialogProps), React.createElement("div", {
    style: {
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement(Typography, {
    variant: "h6",
    style: {
      flex: 1
    }
  }, title), React.createElement(IconButton, {
    style: {
      padding: 0
    }
  }, React.createElement(Icon, {
    style: {
      alignItems: 'center'
    },
    onClick: function onClick() {
      return confirm ? setOpenCancelDialog(true) : props.onCancel();
    }
  }, "close"))), subtitle && React.createElement(Typography, {
    className: classes.subtitle
  }, subtitle), React.createElement(FormProvider, {
    id: props.id // TODO: remove submit for multiple api call
    // TODO: two times on submit with dialog verify!!!
    // onSubmit={(e) => props.onSubmit(e)}

  }, React.createElement(DialogContent, {
    dividers: scroll === 'paper',
    classes: {
      dividers: classes.dividers
    },
    style: {
      maxHeight: '72vh'
    }
  }, props.children), React.createElement(DialogActions$1, {
    className: classes.actions
  }, props.action))));
}

var useStyles$t = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    container: {
      marginTop: 12,
      display: 'flow-root'
    }
  };
});

function FormGenerator(props) {
  var classes = useStyles$t();
  var layoutStyle = props.layoutStyle;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      formSerialized = _useState2[0],
      setFormSerialized = _useState2[1];

  var dialogProps = props.dialogProps;
  var name = props.name;
  var readOnly = props.readOnly,
      _props$dialog = props.dialog,
      dialog = _props$dialog === void 0 ? false : _props$dialog,
      isPending = props.isPending,
      errors = props.errors;
  var actionProps = props.actionsProps ? props.actionsProps : {
    cancelProps: {},
    submitProps: {}
  };
  var cancelProps = actionProps.cancelProps,
      submitProps = actionProps.submitProps;
  var onCancel = props.onCancel;
  useEffect(function () {
    var fields = props.fields; // prepare fields (merging backend/frontend) & labels translation

    prepareFormFields(fields);
  }, [props.errors]);
  /**
   * Prepare fields (merging backend/frontend) & labels translation
   * @param fields
   */

  function prepareFormFields(fields) {
    console.debug('back fields:', fields[0]);
    console.debug('front fields:', fields[1]);

    if (formSerialized.length < 1) {
      if (fields[0].constructor === Array) {
        // 0: backend fields - 1: frontend fields
        fields = prepareFields(name, fields[0], fields[1]);
      } else {
        fields = prepareFields(name, fields, fields);
      }
    } else fields = formSerialized; // Init form state


    var formProps = {
      readOnly: props.readOnly,
      disabled: props.readOnly
    }; // restore the disabled after the api call

    if (!props.readOnly) {
      formSerialized.map(function (field) {
        field.disabled = false;
      });
    } // define the errors when it receive new props


    if (formSerialized.length > 0 && props.errors && props.errors.length > 0) {
      fields = defineErrorsProps(formSerialized, props.errors);
    }

    setFormSerialized(initFormSerializedState(fields, formProps));
  }
  /**
   * Update the formSerializedState
   * @param key
   * @param property
   * @param value
   */


  function updateState(key, property, value) {
    try {
      // eslint-disable-next-line no-eval
      var tmp = _toConsumableArray(formSerialized);

      var index = tmp.indexOf(tmp.filter(function (item) {
        return item.key === key;
      })[0]);
      tmp[index][property] = value; // if the new property is values clean the value state

      if (property === 'values') {
        tmp[index].value = null;
      } // Clean values/value of select and autocomplete fields


      formSerialized.map(function (field) {
        return cleanValuesLabel(field);
      }); // update labels fields

      console.debug('form update', tmp);
      prepareFormFields(tmp);
    } catch (e) {
      console.debug('form update error', e);
    }
  }
  /**
   * on sub components change value
   * @param e: default structure {target:{name:"", value:""}}
   * @param action: additional action function
   */


  function onChange(e, action) {
    var serialized = _toConsumableArray(formSerialized);

    var value = null;
    if (e.target.value !== null) value = e.target.value;
    var filter = formSerialized.filter(function (item) {
      return item.key === e.target.name;
    })[0];
    var indexChange = formSerialized.indexOf(filter);
    serialized[indexChange].value = value !== undefined && value !== null ? value : null;
    setFormSerialized(serialized); // execute action field if exist

    if (action) action(e.target, updateState);
  }
  /**
   * on Form submit
   * @param e: form event
   */


  function _onSubmit(e) {
    if (e) e.preventDefault();
    var serialized = {}; // clean the value

    formSerialized.map(function (field) {
      // serialize the fields with serialize property
      if (field.serialize === true) {
        serialized[field.key] = getValue(field);

        if (typeof serialized[field.key] === 'undefined') {
          delete serialized[field.key];
        }
      }
    }); // disabled all inputs to prevent editing

    formSerialized.map(function (field) {
      return field.disabled = true;
    });
    if (typeof props.onSubmit === 'function') props.onSubmit(serialized);
  }

  function Close() {
    setFormSerialized([]);
    onCancel();
  }

  function Action() {
    return React.createElement(FormGeneratorActions, {
      cancelProps: _objectSpread2({}, cancelProps),
      submitProps: _objectSpread2({}, submitProps),
      onCancel: Close,
      onSubmit: _onSubmit,
      buttonVariant: props.buttonVariant,
      loading: props.isPending,
      customActions: props.customActions,
      readOnly: readOnly
    });
  }

  return dialog ? React.createElement(DialogFormGenerator, _extends({
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    },
    id: props.id,
    onCancel: onCancel,
    open: dialogProps.open
  }, dialogProps, {
    confirm: cancelProps.confirm,
    action: React.createElement(Action, null)
  }), React.createElement("div", _extends({
    className: classes.container
  }, props), formSerialized.map(function (field) {
    return (// verify the field condition
      isSerializable(formSerialized, field) && React.createElement(LayoutProvider, {
        key: "".concat(field.key),
        field: field,
        style: layoutStyle
      }, React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '100%'
        }
      }, renderField$1(field, onChange), React.createElement(ErrorLayoutProvider, {
        field: field
      })))
    );
  }))) : React.createElement(FormProvider, {
    id: props.id,
    name: name,
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    }
  }, React.createElement("div", _extends({
    className: classes.container
  }, props), formSerialized.map(function (field) {
    return (// verify the field condition
      isSerializable(formSerialized, field) && React.createElement(LayoutProvider, {
        key: "".concat(field.key),
        field: field,
        style: layoutStyle
      }, React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, renderField$1(field, onChange), React.createElement(ErrorLayoutProvider, {
        field: field
      })))
    );
  })), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, React.createElement(Action, null)));
}

FormGenerator.propTypes = {
  /** Fields object array with definition, can use [backData, frontData] to prepare data */
  fields: propTypes.array.isRequired,

  /** Loader if api submit is pending */
  isPending: propTypes.bool,

  /** Submit function after submit form */
  onSubmit: propTypes.func.isRequired,

  /** Cancel function after cancel button click */
  onCancel: propTypes.func.isRequired,

  /** Define if form is dialog type */
  dialog: propTypes.bool,

  /** Dialog props */
  dialogProps: {
    /** Function after dialog close */
    onClose: propTypes.func,

    /** Status of dialog */
    open: propTypes.bool.isRequired,

    /** Dialog title */
    title: propTypes.string,

    /** Dialog subtitle */
    subtitle: propTypes.string
  }
};
FormGenerator.defaultProps = {
  fields: []
};

var styles = function styles(theme) {
  return {
    root: _defineProperty({
      minWidth: 240,
      marginBottom: 16
    }, theme.breakpoints.down('xs'), {
      padding: 0
    }),
    label: {
      marginTop: 8,
      color: '#fff',
      cursor: 'pointer',
      padding: 8,
      borderRadius: 4,
      background: theme.palette.secondary.main,
      boxShadow: '0px 1px 4px #c3c3c3',
      display: 'flex',
      alignItems: 'center',
      maxHeight: 44,
      textTransform: 'uppercase',
      justifyContent: 'center'
    },
    uploadInput: {
      opacity: 0,
      position: 'absolute'
    },
    fileName: {
      marginLeft: 8
    },
    imgPreview: {
      width: '100%',
      maxWidth: 200,
      flex: 1,
      color: 'rgba(0, 0, 0, 0.63)',
      display: 'flex',
      boxShadow: 'none',
      height: 'auto',
      alignItems: 'center',
      borderRadius: 4,
      margin: 'auto',
      marginTop: 16
    }
  };
};

var FileInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileInput).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (fileList) {
      var file = fileList;

      if (file) {
        // max number of megabytes
        var maxMb = _this.props.maxMb ? _this.props.maxMb : 5; // add id and name

        var random = Math.random().toString(36).substr(2, 9);
        file.id = _this.props.id ? _this.props.id : "file_".concat(random);
        file.key = _this.props.name ? _this.props.name : "file-".concat(random);

        if (file.size < maxMb * 1024 * 1024) {
          _this.setState({
            fileList: file,
            fileName: file.name
          });

          _this.props.onLoaded(file);
        } else {
          // Error message dimension of file is too big
          window.alert("The max dimension allowed for file is ".concat(maxMb, " MB."));
        }
      }
    });

    _this.state = {
      fileList: _this.props.file ? _this.props.file : null,
      fileName: null
    };
    return _this;
  }

  _createClass(FileInput, [{
    key: "renderPreview",
    value: function renderPreview(file) {
      // if file type exist it means that it has just been uploaded
      if (file.type) {
        switch (file.type) {
          case 'image/gif':
          case 'image/jpeg':
          case 'image/png':
          case 'image/webp':
          case 'image/svg+xml':
            return React.createElement("img", {
              src: typeof this.state.fileList !== 'string' ? URL.createObjectURL(this.state.fileList) : this.state.fileList,
              className: this.props.classes.imgPreview
            });

          default:
            return React.createElement("div", {
              style: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 16
              }
            }, React.createElement(Icon$1$1, {
              style: {
                fontSize: 40,
                color: '#646f79'
              }
            }, "insert_drive_file"), file.name);
        }
      } else {
        // render the string
        return React.createElement("img", {
          src: typeof this.state.fileList !== 'string' ? URL.createObjectURL(this.state.fileList) : this.state.fileList,
          className: this.props.classes.imgPreview
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          required = _this$props.required,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          style = _this$props.style,
          accept = _this$props.accept,
          _this$props$fileNameV = _this$props.fileNameVisible,
          fileNameVisible = _this$props$fileNameV === void 0 ? false : _this$props$fileNameV,
          _this$props$preview = _this$props.preview,
          preview = _this$props$preview === void 0 ? true : _this$props$preview,
          id = _this$props.id,
          name = _this$props.name;
      var _this$state = this.state,
          fileName = _this$state.fileName,
          fileList = _this$state.fileList;
      return React.createElement("div", {
        className: classes.root
      }, React.createElement("label", {
        htmlFor: id,
        style: disabled ? {
          background: '#ccc'
        } : null,
        disabled: disabled,
        className: classes.label
      }, this.props.children ? this.props.children : React.createElement("span", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, React.createElement(Icon$1$1, {
        style: {
          color: '#fff',
          marginRight: 8
        }
      }, "cloud_upload"), "Upload File")), React.createElement("input", {
        type: "file",
        name: name,
        id: id,
        disabled: disabled,
        style: style,
        required: required,
        onChange: function onChange(e) {
          return _this2.handleChange(e.target.files[0]);
        },
        className: classes.uploadInput,
        accept: accept
      }), fileNameVisible && React.createElement("span", {
        className: classes.fileName
      }, fileName), fileList && preview && this.renderPreview(fileList));
    }
  }]);

  return FileInput;
}(Component);

_defineProperty(FileInput, "propTypes", {
  id: propTypes.string,
  name: propTypes.string,
  classes: propTypes.object.isRequired,
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]).isRequired,
  disabled: propTypes.bool,
  required: propTypes.bool,
  fileNameVisible: propTypes.bool,
  style: propTypes.object,
  onLoaded: propTypes.func,
  preview: propTypes.bool,
  maxMb: propTypes.number,
  file: propTypes.string,
  accept: propTypes.string
});

var FileInput$1 = compose(withStyles$1(styles, {
  withTheme: true
}))(FileInput);

function GdocViewer(props) {
  var iframeTimeoutId;
  var iframe = useRef({
    src: ''
  });

  function iframeLoaded() {
    clearInterval(iframeTimeoutId);
    if (props.onLoad) props.onLoad();
  }

  function getIframeLink() {
    return "https://docs.google.com/viewerng/viewer?url=".concat(props.url, "&embedded=true"); // no need for this if thats not dynamic
  }

  function updateIframeSrc() {
    iframe.current.src = getIframeLink();
  }

  return React.createElement("iframe", {
    title: "idocs",
    onLoad: function onLoad() {
      return iframeLoaded();
    },
    onError: updateIframeSrc(),
    src: getIframeLink(),
    width: "100%",
    height: "600",
    ref: iframe,
    style: {
      border: 'none'
    }
  });
}

GdocViewer.propTypes = {
  /** Define the doc url that will be rendered  */
  url: propTypes.string.isRequired,

  /** Callback when the doc is loaded */
  onLoad: propTypes.func.isRequired
};
GdocViewer.defaultProps = {};

function FullScreenLoader(props) {
  var classes = props.classes;
  var logo = props.logo,
      _props$background = props.background,
      background = _props$background === void 0 ? '#fff' : _props$background,
      _props$label = props.label,
      label = _props$label === void 0 ? '#222' : _props$label,
      _props$loaderProps = props.loaderProps,
      loaderProps = _props$loaderProps === void 0 ? {
    color: '#222',
    size: 40
  } : _props$loaderProps;
  return React.createElement("div", null, React.createElement(FullScreenContainer, {
    background: background
  }, logo && React.createElement("img", {
    alt: "logo",
    src: logo,
    width: 240
  }), React.createElement("br", null), React.createElement(Typography, {
    className: classes.label
  }, label), React.createElement(CircularProgress$1, {
    size: loaderProps.size,
    color: loaderProps.color
  })));
}

var styles$1 = function styles(theme) {
  return {
    label: {
      color: '#fff',
      marginBottom: 8
    }
  };
};

FullScreenLoader.propTypes = {
  /** Define a logo img */
  logo: propTypes.string,

  /** Define the background color of container */
  background: propTypes.string,

  /** Define a label below a logo (if exist) */
  label: propTypes.string,

  /** Define the props of the CircularProgress */
  loaderProps: propTypes.object
};
FullScreenLoader.defaultProps = {};
var FullScreenLoader$1 = withStyles$1(styles$1)(FullScreenLoader);

var Search =
/*#__PURE__*/
function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, props));
    _this.state = {
      originalData: [],
      value: ''
    };
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (this.state.originalData && this.state.originalData.length === 0) {
        this.setState({
          originalData: nextProps.data
        });
      }
    } // On change of input search

  }, {
    key: "handleOnSearch",
    value: function handleOnSearch(e) {
      var keySearch = this.props.keySearch; // set the value on state

      this.setState({
        value: e.target.value
      }); // check if data is present

      if (this.props.data) {
        var data = this.state.originalData; // Check if the input value is not undefined

        if (e.target.value !== '') {
          if (typeof keySearch === 'string') {
            // search function
            var split = keySearch.split('.');

            var search = function search(stringToSearch) {
              return data.filter(function (element) {
                split.map(function (key) {
                  return element = element[key];
                });
                return element.toLowerCase().includes(stringToSearch.toLowerCase());
              });
            };

            var searchResult = search(e.target.value); // call onResult function to set the searchResult

            this.props.onResult(searchResult);
          } else if (Array.isArray(keySearch)) {
            var searcResult = [];
            keySearch.map(function (item) {
              // search function
              var split = item.split('.');

              var search = function search(stringToSearch) {
                return data.filter(function (element) {
                  split.map(function (key) {
                    if (element !== null) {
                      return element = element[key];
                    }

                    return false;
                  }); // check if the element found is null

                  if (element !== null && element !== 'undefined') {
                    try {
                      return element.toLowerCase().includes(stringToSearch.toLowerCase());
                    } catch (e) {
                      console.error('Element of Search not found - check the keySearch props');
                    }
                  } else {
                    return false;
                  }
                });
              };

              var findValue = search(e.target.value); // call onResult function to set the searchResult

              searcResult.push(findValue);
            });
            searcResult = searcResult.reduce(function (r, c) {
              return Object.assign(r, c);
            }, []);

            if (this.props.onResult) {
              // TODO: change keySearch in queryKey
              this.props.onResult(searcResult);
            }
          }
        } else if (this.props.onResult) {
          this.props.onResult(this.state.originalData);
        }
      } // Send to onChange props the string searched


      if (this.props.onChange) {
        this.props.onChange(e.target.value);
      }
    }
  }, {
    key: "onConfirm",
    value: function onConfirm(e) {
      e.preventDefault();

      if (this.props.onConfirm) {
        var obj = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.props.keySearch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;
            obj[key] = this.state.value;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.props.onConfirm(this.state.value, obj);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          style = _this$props.style,
          _this$props$buttonSty = _this$props.buttonStyle,
          buttonStyle = _this$props$buttonSty === void 0 ? {} : _this$props$buttonSty,
          _this$props$inputStyl = _this$props.inputStyle,
          inputStyle = _this$props$inputStyl === void 0 ? {} : _this$props$inputStyl;
      return React.createElement("div", {
        className: classes.container,
        style: _objectSpread2({}, style)
      }, React.createElement("form", {
        onSubmit: function onSubmit(e) {
          return _this2.onConfirm(e);
        },
        style: {
          display: 'flex'
        }
      }, React.createElement(Input$1, {
        className: classes.inputSearch,
        style: _objectSpread2({}, inputStyle),
        classes: {
          underline: classes.noUnderline,
          input: classes.radius
        },
        onChange: function onChange(e) {
          return _this2.handleOnSearch(e);
        },
        placeholder: this.props.placeholder ? this.props.placeholder : 'Search'
      }), React.createElement(Button, {
        type: "submit",
        variant: "contained",
        color: "primary",
        style: _objectSpread2({
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0
        }, buttonStyle)
      }, React.createElement(Icon, null, "search"))));
    }
  }]);

  return Search;
}(Component);

_defineProperty(Search, "propTypes", {
  classes: propTypes.object.isRequired,
  data: propTypes.object.isRequired,
  placeholder: propTypes.string,
  keySearch: propTypes.oneOfType([propTypes.string, propTypes.array]),
  onResult: propTypes.func,
  onChange: propTypes.func,
  onConfirm: propTypes.func,
  style: propTypes.object
});

var styles$2 = function styles(theme) {
  return {
    container: {
      flex: 1
    },
    inputSearch: {
      width: '100%',
      background: '#fff',
      borderTopRightRadius: 4,
      borderTopLeftRadius: 4,
      '& input': {
        padding: 12,
        border: '1px solid rgba(42, 58, 75, 0.45)',
        borderTopLeftRadius: 4
      }
    },
    radius: {
      borderTopLeftRadius: '22px !important',
      borderBottomLeftRadius: '22px !important'
    },
    noUnderline: {
      '&:before': {
        borderBottom: 0
      },
      '&:hover': {
        '&:before': {
          borderBottom: '0px !important'
        }
      },
      '&:after': {
        borderBottom: 0
      }
    }
  };
};

var Search$1 = compose(withStyles$1(styles$2, {
  withTheme: true
}))(Search);
var height = 39;
var border = '1px solid #dfdfdf';

var styles$3 = function styles(theme) {
  var _firstChild, _firstChild2;

  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      margin: 4
    },
    root: {
      height: height,
      border: border,
      marginTop: 3,
      borderRadius: 4,
      display: 'flex',
      '& input': _defineProperty({
        background: 'transparent',
        borderRadius: 4,
        fontSize: 12,
        transitionDuration: '0.4s',
        border: 0,
        padding: '8px 0',
        minWidth: 200,
        fontWeight: 400
      }, theme.breakpoints.down('xs'), {
        minWidth: '100%'
      })
    },
    imageSelect: {
      width: 300,
      height: 60,
      borderRadius: 4,
      marginRight: 4,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center'
    },
    selectError: {
      fontFamily: 'Poppins',
      fontSize: 14,
      color: '#b92e2e',
      '& span': {
        display: 'none'
      },
      '&:first-child': (_firstChild = {
        padding: 0,
        paddingBottom: 2,
        border: 0,
        borderBottom: '1px solid #b92e2e',
        borderRadius: 0
      }, _defineProperty(_firstChild, theme.breakpoints.down('xs'), {
        width: '100%'
      }), _defineProperty(_firstChild, '& div', {
        padding: 0,
        border: 0
      }), _firstChild)
    },
    select: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      '& span': {
        display: 'none'
      },
      '&:first-child': (_firstChild2 = {
        padding: 0,
        border: 0,
        borderBottom: '0px solid #949494',
        borderRadius: 0
      }, _defineProperty(_firstChild2, theme.breakpoints.down('xs'), {
        width: '100%'
      }), _defineProperty(_firstChild2, '& div', {
        border: 0
      }), _firstChild2)
    },
    option: {
      fontSize: 13,
      color: '#111',
      padding: 16,
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        background: '#f5f5f5'
      }
    },
    label: {
      marginTop: -10,
      fontSize: 10,
      color: '#7e7e7e'
    },
    labelError: {
      marginTop: -10,
      fontSize: 10,
      color: '#b92e2e'
    }
  };
};

var SelectAutocomplete =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectAutocomplete, _Component);

  function SelectAutocomplete(props) {
    var _this;

    _classCallCheck(this, SelectAutocomplete);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectAutocomplete).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (selectedOption) {
      _this.setState({
        selectedOption: selectedOption
      });

      if (_this.props.input && _this.props.input.rel_attribute && _this.props.getValuesPrepare) {
        if (selectedOption) {
          // call the api for the parameterized select
          if (_this.props.input.rel_attribute) {
            _this.props.getValuesPrepare({
              get_attribute: _this.props.input.rel_attribute,
              post_attribute: _this.props.input.name,
              post_code: selectedOption.code
            });
          }
        } else {
          // call the api for CLEAN the parameterized select
          if (_this.props.input.rel_attribute) {
            _this.props.getValuesPrepare({
              get_attribute: _this.props.input.rel_attribute,
              post_attribute: _this.props.input.name,
              post_code: '-'
            });
          }
        }
      }

      if (_this.props.onChange) {
        _this.props.onChange(selectedOption);
      }
    });

    if (props.defaultValue && props.values.filter(function (item) {
      return item.code === props.defaultValue;
    })[0] !== undefined) {
      var defaultLabel = props.values.filter(function (item) {
        return item.code === props.defaultValue;
      })[0].label;
      _this.state = {
        selectedOption: {
          label: defaultLabel,
          code: props.defaultValue
        }
      };
    } else {
      _this.state = {
        selectedOption: null
      };
    }

    return _this;
  }

  _createClass(SelectAutocomplete, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      var _this$props = this.props,
          name = _this$props.name,
          values = _this$props.values,
          defaultValue = _this$props.defaultValue,
          placeholder = _this$props.placeholder,
          required = _this$props.required,
          label = _this$props.label,
          _this$props$isClearab = _this$props.isClearable,
          isClearable = _this$props$isClearab === void 0 ? true : _this$props$isClearab;
      var selectedOption = this.state.selectedOption;

      var CustomOption = function CustomOption(props) {
        var data = props.data,
            innerRef = props.innerRef,
            innerProps = props.innerProps;
        return data.image ? React.createElement("div", _extends({
          ref: innerRef
        }, innerProps), React.createElement(Typography, {
          key: data.code,
          className: classes.option
        }, React.createElement("img", {
          src: data.image,
          width: 240,
          alt: data.label
        }), data.label)) :
        /* <components.Option {...props} /> */
        React.createElement("div", _extends({
          ref: innerRef
        }, innerProps), React.createElement(Typography, {
          key: data.code,
          className: classes.option
        }, data.label));
      }; // Style menu


      var selectStyles = {
        menu: function menu(base) {
          return _objectSpread2({}, base, {
            background: '#fff',
            zIndex: 100
          });
        }
      };
      return React.createElement("div", {
        className: classes.container
      }, values.length > 0 ? React.createElement("div", {
        style: this.props.hidden ? {
          display: 'none'
        } : null
      }, React.createElement(Typography, {
        className: this.props.error === true ? classes.labelError : classes.label
      }, required ? "".concat(label, " *") : label), React.createElement("div", {
        className: classes.root
      }, React.createElement(Select$2, {
        defaultValue: defaultValue,
        className: this.props.error === true ? classes.selectError : classes.select,
        value: selectedOption,
        name: this.props.name,
        onChange: this.handleChange,
        options: values,
        components: {
          Option: CustomOption
        },
        placeholder: placeholder,
        isClearable: isClearable,
        noOptionsMessage: function noOptionsMessage() {
          return 'Nessun risultato trovato';
        } // onMenuOpen={() => this.setState({selectedOption:null})}
        // onMenuClose={() => this.handleOnMenuClose()}
        ,
        styles: selectStyles,
        theme: function theme(_theme) {
          return _objectSpread2({}, _theme, {
            borderRadius: 0,
            colors: {
              /* ...theme.colors, */
              primary: 'transparent'
            }
          });
        },
        classes: {
          select: {
            border: border // backgroundColor: '#b92e2e'

          },
          root: {
            backgroundColor: '#b92e2e'
          }
        }
      }), React.createElement("input", {
        required: required,
        name: name,
        value: selectedOption ? selectedOption.code : '',
        style: {
          opacity: 0,
          position: 'absolute',
          zIndex: -999999,
          left: -1000,
          top: -1000,
          visibility: 'hidden'
        }
      }))) : null);
    }
  }]);

  return SelectAutocomplete;
}(Component);

_defineProperty(SelectAutocomplete, "propTypes", {
  classes: propTypes.object.isRequired,
  required: propTypes.bool,
  hidden: propTypes.bool,
  onChange: propTypes.func,
  getValuesPrepare: propTypes.func,
  placeholder: propTypes.string,
  label: propTypes.string,
  defaultValue: propTypes.string,
  input: propTypes.string,
  name: propTypes.string,
  values: propTypes.array.isRequired,
  error: propTypes.array
});

var SelectAutocomplete$1 = compose(withStyles$1(styles$3, {
  withTheme: true
}))(SelectAutocomplete);

var actionsStyles = function actionsStyles(theme) {
  return {
    root: {
      flexShrink: 0,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing(2.5)
    },
    icon: {
      fontSize: '1.485714rem'
    }
  };
};

function Paginator(props) {
  function handleFirstPageButtonClick(event) {
    props.onChangePage(event, 0);
  }

  function handleBackButtonClick(event) {
    props.onChangePage(event, props.page - 1);
  }

  function handleNextButtonClick(event) {
    props.onChangePage(event, props.page + 1);
  }

  var classes = props.classes,
      count = props.count,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      theme = props.theme,
      loader = props.loader;
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(IconButton, {
    onClick: function onClick() {
      return handleFirstPageButtonClick();
    },
    disabled: page === 0 || loader,
    "aria-label": "First Page"
  }, theme.direction === 'rtl' ? React.createElement(LastPageIcon, null) : React.createElement(FirstPageIcon, null)), React.createElement(IconButton, {
    onClick: handleBackButtonClick,
    disabled: page === 0 || loader,
    "aria-label": "Previous Page"
  }, theme.direction === 'rtl' ? React.createElement(KeyboardArrowRight, null) : React.createElement(KeyboardArrowLeft, null)), React.createElement(IconButton, {
    onClick: handleNextButtonClick,
    disabled: page >= Math.ceil(count / rowsPerPage) - 1 || loader,
    "aria-label": "Next Page"
  }, theme.direction === 'rtl' ? React.createElement(KeyboardArrowLeft, null) : React.createElement(KeyboardArrowRight, null)));
}

Paginator.propTypes = {
  classes: propTypes.object.isRequired,
  count: propTypes.number.isRequired,
  onChangePage: propTypes.func.isRequired,
  page: propTypes.number.isRequired,
  rowsPerPage: propTypes.number.isRequired,
  theme: propTypes.object.isRequired
};
var Paginator$1 = withStyles$1(actionsStyles, {
  withTheme: true
})(Paginator);
var useStyle$2 = makeStyles(function (theme) {
  return {
    root: {
      flex: 1
    }
  };
});

function TableGeneratorFooter(props) {
  var classes = useStyle$2(props);
  var labelRowsPerPage = props.labelRowsPerPage,
      rowsPerPageOptions = props.rowsPerPageOptions,
      rowsPerPage = props.rowsPerPage,
      page = props.page,
      count = props.count,
      loader = props.loader,
      offset = props.offset;
  return React.createElement(TableFooter, null, React.createElement(TableRow, {
    style: {
      height: 56
    }
  }, React.createElement(TablePagination, {
    style: {
      position: 'absolute',
      border: 0,
      minWidth: 'unset',
      maxWidth: 'unset'
    },
    colSpan: 3,
    count: count || 0,
    rowsPerPage: rowsPerPage,
    labelRowsPerPage: labelRowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    backIconButtonProps: {
      disabled: true
    },
    page: page,
    onChangePage: function onChangePage(e, page) {
      return props.handleChangePage(e, page, rowsPerPage, offset);
    },
    onChangeRowsPerPage: props.handleChangeRowsPerPage,
    ActionsComponent: function ActionsComponent(props) {
      return React.createElement(Paginator$1, _extends({}, props, {
        loader: loader
      }));
    }
  })));
}

function CollapseTableGenerator(props) {
  var item = props.item;
  return React.createElement(Collapse$1, {
    in: "openCollapse-".concat(item.id),
    collapsedHeight: 0,
    transitionDuration: "auto"
  }, this.state["openCollapse-".concat(item.id)] && React.createElement(TableRow, {
    style: {
      position: 'relative',
      overflow: 'auto',
      height: item.collapse.props.style.height
    }
  }, React.createElement("div", {
    id: "contentCollapse-".concat(item.id),
    style: {
      height: item.collapse.props.style.height - 40,
      position: 'absolute',
      width: '93.36%',
      padding: 20,
      borderBottom: '1px solid #e0e0e0',
      overflow: 'scroll'
    }
  }, item.collapse)));
}

function getValue$1(key, item, tableName) {
  var label = tableName ? "".concat(tableName, ".").concat(key, ".").concat(item) : "".concat(key, ".").concat(item);
  var translation = translate("".concat(label));

  if (translation !== 'TRANSLATION_NOT_FOUND') {
    return translation;
  }

  return item;
} // #####################################################################################################################
//  DEFAULT COMPONENT
// #####################################################################################################################


function DefaultCellComponent(props) {
  var _useState = useState(props.value),
      _useState2 = _slicedToArray(_useState, 2),
      newValue = _useState2[0],
      setValue = _useState2[1];

  var traslated = getValue$1(props.keyName, props.value, props.tableName);

  function handleChange(value) {
    setValue(value);
  }

  useEffect(function () {
    setValue(props.value);
  }, [props.value]);
  if (props.edit) return React.createElement("div", {
    style: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  }, React.createElement(TextField, {
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    variant: "outlined",
    name: props.keyName,
    value: newValue,
    InputProps: {
      endAdornment: React.createElement(Icon$1, {
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return props.editFunction(props.id, _defineProperty({}, props.keyName, newValue));
        }
      }, "save")
    }
  }));
  return React.createElement("div", {
    style: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  }, traslated || '-');
} // #####################################################################################################################
// TYPE TEXT OVERFLOW
// #####################################################################################################################


function TextOverflowCell(props) {
  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialog = _useState4[0],
      setOpenDialog = _useState4[1];

  var value = props.value;
  return React.createElement("div", {
    onMouseOver: function onMouseOver() {
      return setOpenDialog(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setOpenDialog(false);
    }
  }, React.createElement("div", {
    style: {
      width: 400,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      cursor: 'pointer'
    }
  }, value), openDialog && React.createElement("div", {
    style: {
      marginTop: -24,
      padding: 12,
      position: 'absolute',
      width: 400,
      height: 'auto',
      background: 'white',
      overflowX: 'hidden',
      overflowY: 'auto',
      boxShadow: '0px 1px 5px rgba(200, 200, 200, 0.7)',
      borderRadius: 5,
      zIndex: 1,
      color: '#111'
    }
  }, value));
} // #####################################################################################################################
// TYPE DATE
// #####################################################################################################################


function DateCell(props) {
  var FORMAT_DATE = 'DD/MM/YYYY';
  var value = props.value;
  return React.createElement("div", null, value ? moment(value).format(FORMAT_DATE) : '-');
} // #####################################################################################################################
// TYPE INPUT
// #####################################################################################################################


function InputCell(props) {
  var onCellSetState = props.onCellSetState,
      index = props.index,
      editData = props.editData,
      filterData = props.filterData,
      field = props.field,
      value = props.value,
      tmpEdit = props.tmpEdit;

  var _ref = props.field ? props.field : false,
      _ref$onBlur = _ref.onBlur,
      _onBlur = _ref$onBlur === void 0 ? false : _ref$onBlur;

  var tmpEditData = JSON.parse(JSON.stringify(editData));
  return field.editable ? React.createElement(TextField, {
    value: tmpEditData[index][field.keyName],
    InputProps: {
      style: {
        minWidth: 100,
        fontSize: '0.85rem'
      }
    },
    type: field && field.type ? field.type : 'text',
    name: field.keyName,
    onChange: function onChange(e) {
      // call the props onCellSetState to set on TableGeneratorState
      var tmpEdit = {
        value: e.target.value,
        i: index,
        keyName: field.keyName
      };
      tmpEditData[index][field.keyName] = e.target.value;
      onCellSetState({
        tmpEdit: tmpEdit,
        editData: tmpEditData
      });
    },
    onBlur: function onBlur() {
      if (tmpEdit && _onBlur) {
        // TODO: new props here
        filterData[index][field.keyName] = tmpEdit.value; // call the props onCellSetState to set on TableGeneratorState

        onCellSetState({
          filterData: filterData,
          tmpEdit: null
        });
      }
    }
  }) : React.createElement(DefaultCellComponent, {
    value: value
  });
} // #####################################################################################################################
// TYPE SELECT
// #####################################################################################################################


function SelectCell(props) {
  var onCellSetState = props.onCellSetState,
      index = props.index,
      editData = props.editData,
      field = props.field,
      value = props.value;
  var tmpEditData = JSON.parse(JSON.stringify(editData));
  var style = field.style;
  return field.editable ? React.createElement(Select$1, {
    style: _objectSpread2({
      minWidth: 100
    }, style || null),
    value: tmpEditData[index][field.keyName],
    name: field.keyName,
    onChange: function onChange(e) {
      tmpEditData[index][field.keyName] = e.target.value; // call the props onCellSetState to set on TableGeneratorState

      onCellSetState({
        editData: tmpEditData
      });
    }
  }, field.values && field.values.map(function (item) {
    return React.createElement(MenuItem, {
      value: item.value
    }, item.label);
  })) : // TODO: change the default if nothing is selected
  React.createElement(DefaultCellComponent, {
    value: value
  });
} // #####################################################################################################################
// TYPE IMAGE
// #####################################################################################################################


function Image(props) {
  var value = props.value;
  var imageWidth = '50%';
  var style = {
    backgroundImage: "url(".concat(value, ")"),
    backgroundSize: 'cover',
    width: imageWidth,
    height: 22,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: 2
  };
  return value ? React.createElement("a", {
    href: value,
    rel: "noopener noreferrer",
    target: "_blank",
    style: {
      cursor: 'zoom-in'
    }
  }, React.createElement("div", {
    style: style
  })) : React.createElement("div", {
    style: style
  });
} // #####################################################################################################################
// SAVE EDITABLE ROW BUTTON
// #####################################################################################################################


function SaveEditable(props) {
  var field = props.field,
      filterData = props.filterData,
      index = props.index,
      value = props.value,
      tmpEdit = props.tmpEdit,
      editData = props.editData;
  var color = field.color,
      variant = field.variant,
      style = field.style,
      label = field.label;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loader = _React$useState2[0],
      setLoader = _React$useState2[1];

  var onLoading = function onLoading() {
    setLoader(true);
    setTimeout(function () {
      setLoader(false);
    }, 1000);
  };

  return React.createElement(Button, {
    disabled: isValueChange(editData[index], filterData[index]),
    color: color || 'primary',
    variant: variant || 'outlined',
    style: _objectSpread2({
      padding: 4
    }, style || null),
    onClick: function onClick() {
      onLoading();
      field.onSave(editData[index]);
    }
  }, !loader ? label || 'Save' : React.createElement(CircularProgress$1, {
    size: 20,
    color: color || 'primary'
  }));

  function isValueChange(editValue, initialValue) {
    return JSON.stringify(editValue) === JSON.stringify(initialValue);
  }
}
/**
 *
 * @param value
 * @param keyName
 * @param DefaultComponent
 * @returns {*}
 */


function renderItemCell(field, value, id, tableName, idx) {
  if (!(typeof field.component === 'function')) {
    switch (field.component) {
      case 'text':
        return React.createElement(DefaultCellComponent, _extends({
          key: "".concat(field.keyName, "-").concat(id, "-").concat(idx),
          value: value,
          id: id,
          keyName: field.keyName,
          tableName: tableName
        }, field));

      case 'image':
        return React.createElement(Image, _extends({
          value: value
        }, field));

      case 'input':
        return React.createElement(InputCell, _extends({
          value: value
        }, field));

      case 'textOverflow':
        return React.createElement(TextOverflowCell, _extends({
          value: value
        }, field));

      case 'select':
        return React.createElement(SelectCell, _extends({
          value: value
        }, field));

      case 'date':
        return React.createElement(DateCell, _extends({
          value: value
        }, field));

      case 'avatar':
        return React.createElement(Avatar, _extends({
          src: value,
          alt: "table-avatar-".concat(value)
        }, field));

      case 'save':
        return React.createElement(SaveEditable, _extends({
          value: value
        }, field));

      default:
        return React.createElement(DefaultCellComponent, _extends({
          key: "".concat(field.keyName, "-").concat(id),
          value: value,
          id: id,
          keyName: field.keyName,
          tableName: tableName
        }, field));
    }
  } else {
    var Component = field.component;
    return React.createElement(Component, _extends({}, field, {
      value: value
    }));
  }
}

function findValue(data, field, idx) {
  if (Array.isArray(field.keyName)) {
    var tmpKey = _toConsumableArray(field.keyName);

    var combinedValue = [];
    tmpKey.map(function (item) {
      return combinedValue = [].concat(_toConsumableArray(combinedValue), [findValueByKeyName(data, item)]);
    });
    combinedValue = combinedValue.join(' ');
    if (combinedValue === ' ') combinedValue = null;
    return combinedValue;
  }

  return findValueByKeyName(data, field.keyName);
}
/**
 * TODO: Add descriptions
 * @param array
 * @param cmp
 * @returns {*}
 */


function stableSort(array, cmp) {
  var stabilizedThis = array.map(function (el, index) {
    return [el, index];
  });
  stabilizedThis.sort(function (a, b) {
    var order = cmp(a[0], b[0]); // if (order !== 0)

    return order; // return a[1] - b[1]
  });
  return stabilizedThis.map(function (el) {
    return el[0];
  });
}
/**
 * TODO: Add descriptions
 * @param order
 * @param orderBy
 * @returns {function(*=, *=): number}
 */


function getSorting(order, orderBy, data) {
  return order === 'desc' ? function (a, b) {
    return desc(a, b, orderBy, order);
  } : function (a, b) {
    return -desc(a, b, orderBy, order);
  };
}
/**
 * Sorting function
 * @param a
 * @param b
 * @param orderBy
 * @returns {number}
 */


function desc(a, b, orderBy, order) {
  var stringA = null;
  var stringB = null;

  if (Array.isArray(orderBy)) {
    stringB = findValueByKeyNameArray(b, orderBy);
    stringA = findValueByKeyNameArray(a, orderBy);
  } else {
    stringB = findValueByKeyName(b, orderBy);
    stringA = findValueByKeyName(a, orderBy);
  }

  if (orderBy) {
    stringB = stringB && typeof stringB === 'string' ? stringB.toLowerCase() : stringB;
    stringA = stringA && typeof stringB === 'string' ? stringA.toLowerCase() : stringA;

    if (stringB === stringA) {
      return 0;
    }

    if (stringB === null) {
      var returnValue = order === 'desc' ? -1 : 1;
      return returnValue;
    }

    if (stringA === null) {
      var _returnValue = order === 'desc' ? 1 : -1;

      return _returnValue;
    }

    if (stringB < stringA) {
      return -1;
    }

    if (stringB > stringA) {
      return 1;
    }
  }

  return 0;
}
/**
 * @param id
 * @returns {boolean}
 */


function isSelected(selectedElements, id) {
  if (selectedElements) {
    var idExist = selectedElements.filter(function (item) {
      return item.id === id;
    })[0];
    return !!idExist;
  }

  return false;
}

function NoResultsFound(props) {
  return React.createElement(TableRow, {
    key: "no-result",
    style: {
      minHeight: 40
    }
  }, React.createElement(TableCell, {
    colspan: props.colspan,
    component: "th",
    scope: "row"
  }, React.createElement(Typography$1, null, props.labelNoResultFound)));
}

var useStyle$3 = makeStyles$1(function () {
  return {
    activeCell: {
      background: 'red'
    },
    root: {
      minWidth: '88.8px !important',
      maxWidth: '88.8px !important',
      width: '88.8px !important'
    }
  };
});

function CheckboxColumn(props) {
  var classes = useStyle$3(props);
  var checkboxColumn = props.checkboxColumn,
      searchColumnsFilter = props.searchColumnsFilter,
      item = props.item,
      handleOnChangeCheckbox = props.handleOnChangeCheckbox,
      selected = props.selected,
      idx = props.idx;

  var isSelectable = function isSelectable() {
    return props.disableCheckbox ? props.disableCheckbox(item, idx) : false;
  };

  return checkboxColumn && React.createElement(TableCell, {
    align: "left",
    padding: "checkbox",
    classes: {
      root: classes.root
    }
  }, React.createElement(Checkbox$2, {
    checked: isSelectable ? selected : false,
    className: classes.checkbox,
    color: "primary",
    disabled: isSelectable(),
    onClick: function onClick(e) {
      return handleOnChangeCheckbox(item, e, idx);
    }
  }));
}

var useStyle$4 = makeStyles$1(function (theme) {
  return {
    root: {
      flex: 1
    }
  };
});
/**
 * @return {null}
 * or
 * @return {component}
 */

function CollapseController(props) {
  var classes = useStyle$4(props);
  var item = props.item,
      collapseFields = props.collapseFields,
      openCollapse = props.openCollapse,
      onControllerChange = props.onControllerChange;

  function setCollapse(id) {
    var index = openCollapse.indexOf(id);

    if (index >= 0) {
      var tmpCollapse = _toConsumableArray(openCollapse);

      tmpCollapse.slice(index);
      onControllerChange(tmpCollapse);
    } else onControllerChange(function (s) {
      return [id].concat(_toConsumableArray(s.openCollapse));
    });
  }

  return collapseFields && item.collapse ? React.createElement(TableCell, {
    style: {
      padding: 0
    }
  }, React.createElement(IconButton$1, {
    onClick: function onClick() {
      return setCollapse(item.id);
    },
    style: {
      padding: 4
    }
  }, openCollapse.includes(item.id) ? React.createElement(Icon$1, null, "keyboard_arrow_down") : React.createElement(Icon$1, null, "keyboard_arrow_right"))) : null;
}

function RenderRowComponent(props) {
  var idx = props.idx,
      item = props.item,
      data = props.data;
  var _item$id = item.id,
      id = _item$id === void 0 ? idx : _item$id;
  return props.fields.map(function (field) {
    return field.visible !== false && React.createElement(TableCell, {
      key: "item-".concat(field.keyName),
      align: "left"
    }, renderItemCell(field, findValue(data, field), id, props.tableName, idx));
  });
}

var useStyle$5 = makeStyles$1(function (theme) {
  return {
    checkboxHeader: {
      minWidth: '88.8px !important',
      maxWidth: '88.8px !important',
      width: '88.8px !important'
    }
  };
});

function LoaderSkeletonTable(props) {
  var _props$fields = props.fields,
      fields = _props$fields === void 0 ? [] : _props$fields,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? Array.from(Array(5)) : _props$rows,
      _props$customColumn = props.customColumn,
      customColumn = _props$customColumn === void 0 ? [] : _props$customColumn;
  var classes = useStyle$5(props);

  function renderSkeleton(field) {
    switch (field.component) {
      case 'avatar':
        return React.createElement(Skeleton, {
          variant: "circle",
          width: 40,
          height: 40
        });

      case 'image':
        return React.createElement(Skeleton, {
          variant: "rect",
          width: 100,
          height: 48
        });

      default:
        return React.createElement(Skeleton, {
          variant: "text"
        });
    }
  }

  return rows.map(function () {
    return React.createElement(TableRow, {
      key: "loading-table-skeleton",
      style: {
        minHeight: 40
      }
    }, props.checkboxColumn && React.createElement(TableCell, {
      style: {
        minWidth: '88.8px !important',
        maxWidth: '88.8px !important'
      },
      className: classes.checkboxHeader,
      classes: {
        root: classes.checkboxHeader
      }
    }, React.createElement(Skeleton, {
      variant: "rect",
      width: 20,
      height: 20
    })), customColumn.map(function () {
      return React.createElement(TableCell, {
        style: {
          minWidth: '88.8px !important',
          maxWidth: '88.8px !important',
          width: '88.8px !important'
        },
        className: classes.checkboxHeader,
        classes: {
          root: classes.checkboxHeader
        }
      }, React.createElement(Skeleton, {
        variant: "rect",
        width: 20,
        height: 20
      }));
    }), fields.length > 0 && fields.map(function (field) {
      return React.createElement(TableCell, {
        component: "td",
        scope: "row"
      }, renderSkeleton(field));
    }));
  });
}

var useStyle$6 = makeStyles(function (theme) {
  return {
    root: {
      flex: 1
    },
    row: {
      position: 'relative',
      zIndex: 1
    },
    customRoot: {
      minWidth: '88.8px !important',
      maxWidth: '88.8px !important',
      width: '88.8px !important'
    }
  };
});

function TableGeneratorBody(props) {
  var classes = useStyle$6(props);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      openCollapse = _useState2[0],
      setOpenCollapse = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var loader = props.loader,
      dataFilteredPerPage = props.dataFilteredPerPage,
      editData = props.editData,
      _props$checkboxColumn = props.checkboxColumn,
      checkboxColumn = _props$checkboxColumn === void 0 ? true : _props$checkboxColumn,
      colspan = props.colspan,
      disableCheckbox = props.disableCheckbox,
      selectedElements = props.selectedElements,
      rowFunctions = props.rowFunctions,
      fakeLoader = props.fakeLoader,
      filterData = props.filterData,
      labelNoResultFound = props.labelNoResultFound,
      _props$onRowClick = props.onRowClick,
      onRowClick = _props$onRowClick === void 0 ? null : _props$onRowClick,
      fields = props.fields,
      _props$customColumn = props.customColumn,
      customColumn = _props$customColumn === void 0 ? [] : _props$customColumn;
  var parentContainer = document.getElementById(props.parentId);
  var parentWidth = parentContainer ? parentContainer.clientWidth : 0;

  function renderCustomColumn(data) {
    var DefaultStyle = {
      minWidth: '88.8px !important',
      maxWidth: '88.8px !important',
      width: '88.8px !important'
    };
    return customColumn.map(function (item) {
      var _item$cellProps = item.cellProps,
          cellProps = _item$cellProps === void 0 ? {} : _item$cellProps;
      return React.createElement(TableCell, _extends({
        key: "item-".concat(item.keyName),
        align: "left"
      }, cellProps, {
        classes: {
          root: classes.customRoot
        }
      }), item.component(data, DefaultStyle));
    });
  }

  var FunctionsToolbarRow = function FunctionsToolbarRow(props) {
    var idx = props.idx,
        item = props.item;
    var row = document.getElementById("".concat(item, "-").concat(idx));
    var isVisible = hover === idx && rowFunctions;
    return React.createElement("div", {
      style: {
        position: 'absolute',
        height: 64,
        marginLeft: parentWidth // TODO: remove it
        // pointerEvents: 'none'

      }
    }, React.createElement("div", {
      style: {
        position: 'relative',
        whiteSpace: 'nowrap'
      }
    }, isVisible && React.createElement("div", {
      style: {
        direction: 'rtl',
        height: row && row.clientHeight ? row.clientHeight : 64,
        top: 0,
        right: 0,
        position: 'absolute',
        // If u want a fix dimension add here with a negative marginRight
        width: 10,
        marginLeft: -10,
        // background:'rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        zIndex: 1
      }
    }, React.createElement(FunctionsToolbar, {
      onMouseEnter: function onMouseEnter() {
        return setHover(idx);
      },
      items: rowFunctions,
      style: {
        flex: 1,
        padding: 4,
        display: 'flex',
        flexDirection: 'row-reverse',
        borderRadius: 4,
        background: 'rgba(255,255,255,0.9)'
      }
    }))));
  };

  return React.createElement(TableBody, null, !loader ? dataFilteredPerPage && dataFilteredPerPage.length > 0 && editData && editData.length > 0 ? dataFilteredPerPage.map(function (item, idx) {
    var selected = isSelected(selectedElements, item.id ? item.id : idx);
    return React.createElement(React.Fragment, null, React.createElement(FunctionsToolbarRow, {
      idx: idx,
      item: item
    }), React.createElement(TableRow, {
      key: "".concat(item, "-").concat(idx),
      id: "".concat(item, "-").concat(idx),
      onClick: function onClick() {
        return onRowClick && onRowClick(item);
      },
      onMouseEnter: function onMouseEnter() {
        return setHover(idx);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(-1);
      },
      className: classes.row,
      style: onRowClick ? {
        cursor: 'pointer'
      } : null
    }, React.createElement(CollapseController, {
      openCollapse: openCollapse,
      onControllerChange: function onControllerChange(status) {
        return setOpenCollapse(status);
      }
    }), React.createElement(CheckboxColumn, {
      checkboxColumn: checkboxColumn,
      selected: selected,
      searchColumnsFilter: props.searchColumnsFilter,
      handleOnChangeCheckbox: props.handleOnChangeCheckbox,
      disableCheckbox: disableCheckbox,
      item: item,
      idx: idx
    }), renderCustomColumn(dataFilteredPerPage[idx]), React.createElement(RenderRowComponent, {
      tableName: props.tableName,
      data: dataFilteredPerPage[idx],
      fields: props.fields,
      idx: idx,
      item: item
    })), item.collapse && CollapseTableGenerator);
  }) : filterData.length > 0 && fakeLoader === true ? React.createElement(LoaderSkeletonTable, {
    fields: fields,
    customColumn: customColumn,
    checkboxColumn: checkboxColumn
  }) : React.createElement(NoResultsFound, {
    colspan: colspan,
    labelNoResultFound: labelNoResultFound
  }) : React.createElement(LoaderSkeletonTable, {
    fields: fields,
    customColumn: customColumn,
    checkboxColumn: checkboxColumn
  }));
}

var useStyle$7 = makeStyles$1(function (theme) {
  return {
    date: _defineProperty({
      minWidth: 130
    }, "& input", {
      padding: '6.5px 14px'
    }),
    normal: {}
  };
});

function Date$2(props) {
  var classes = useStyle$7(props);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      clearedDate = _useState2[0],
      setClearedDate = _useState2[1];

  var field = props.field;
  var handleFiltersChange = props.handleFiltersChange;
  return React.createElement(React.Fragment, null, React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, React.createElement(KeyboardDatePicker, {
    onChange: function onChange(date) {
      setClearedDate(date);
      handleFiltersChange(date ? getDateISO(date) : date, field.filterOptions.key, field.filterOptions.component);
    },
    format: "DD/MM/YYYY",
    views: ["year", "month", "date"],
    autoOk: true,
    className: classes.date,
    variant: "inline",
    clearLabel: "Cancella",
    cancelLabel: "Chiudi",
    okLabel: "Conferma",
    value: clearedDate,
    KeyboardButtonProps: {
      style: {
        padding: 0
      }
    },
    helperText: null
  })));
}

var useStyle$8 = makeStyles$1(function (theme) {
  return {
    selectInput: {
      padding: '6.5px 14px'
    },
    operatorInput: {
      padding: '7px 0px 7px 0px !important'
    },
    date: _defineProperty({
      minWidth: 130
    }, "& input", {
      padding: '6.5px 14px'
    }),
    normal: {},
    noUnderline: {
      '&:before': {
        borderBottom: 0
      },
      '&:hover': {
        '&:before': {
          borderBottom: '0px !important'
        }
      },
      '&:after': {
        borderBottom: 0
      }
    }
  };
});

function FilterInputNumber(props) {
  var classes = useStyle$8(props);

  var _useState = useState('eq'),
      _useState2 = _slicedToArray(_useState, 2),
      operator = _useState2[0],
      setOperator = _useState2[1];

  var _useState3 = useState('eq'),
      _useState4 = _slicedToArray(_useState3, 2),
      text = _useState4[0],
      setText = _useState4[1];

  var field = props.field;
  var handleFiltersChange = props.handleFiltersChange;
  var operators = [{
    label: '=',
    value: 'eq'
  }, {
    label: '>',
    value: 'gt'
  }, {
    label: '<',
    value: 'lt'
  }];

  function handleSendFilters(selectedOperator) {
    if (text) handleFiltersChange(text, field.filterOptions.key, field.component, selectedOperator);
  }

  return React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, React.createElement(Input$2, {
    startAdornment: React.createElement(FormControl$1, {
      variant: "standard"
    }, React.createElement(Select$3, {
      onChange: function onChange(e) {
        setOperator(e.target.value);
        handleSendFilters(e.target.value);
      },
      MenuProps: {
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        style: {
          marginLeft: -20
        }
      },
      IconComponent: function IconComponent() {
        return React.createElement(React.Fragment, null);
      },
      value: operator,
      classes: {
        selectMenu: classes.operatorInput,
        root: classes.noUnderline
      }
    }, operators.map(function (item, index) {
      return React.createElement(MenuItem$1, {
        key: "".concat(item, "-").concat(index),
        value: item.value,
        style: {
          display: 'flex',
          justifyContent: 'center'
        }
      }, item.label);
    }))),
    type: "number",
    onChange: function onChange(e) {
      setText(e.target.value);
      handleFiltersChange(e.target.value, field.filterOptions.key, field.component, operator);
    },
    value: text,
    placeholder: field.columnName,
    style: {
      width: '100%'
    }
  }));
}

var useStyle$9 = makeStyles$1(function (theme) {
  return {
    selectInput: {
      padding: '6.5px 14px 6.5px 0px'
    }
  };
});
var useStyles$u = makeStyles$1(function (theme) {
  return {
    root: {},
    labelContainer: {
      transform: 'translate(14px, -6px) scale(0.75)',
      pointerEvents: 'none',
      transformOrigin: 'top left',
      top: 0,
      padding: '0px 2px',
      left: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      zIndex: 1
    },
    label: {
      color: 'rgba(0, 0, 0, 0.54)',
      padding: 0,
      fontSize: '0.9285714285714286rem',
      fontFamily: 'Poppins,sans-serif',
      fontWeight: 400,
      lineHeight: 1
    },
    formControl: {
      minWidth: '100%'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    boxShadow: {
      boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
    },
    noWrap: {
      flexWrap: 'nowrap'
    },
    background: {
      background: '#fff',
      margin: '0px',
      padding: '4px 0px'
    }
  };
});

function SelectAuto$1(props) {
  var classes = useStyles$u(); // const {value = {value : null,label : ''}} = field;

  var icon = React.createElement(CheckBoxOutlineBlankIcon, {
    fontSize: "small",
    color: "primary"
  });
  var checkedIcon = React.createElement(CheckBoxIcon, {
    fontSize: "small",
    color: "primary"
  });
  var field = props.field;

  var _useState = useState({
    value: null,
    label: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  console.log('field', field);
  return React.createElement(React.Fragment, null, React.createElement(Autocomplete$1, {
    options: field.filterOptions.values,
    getOptionLabel: function getOptionLabel(option) {
      return "".concat(option.label);
    },
    className: classes.formControl,
    autoHighlight: true,
    variant: "outlined",
    fullWidth: true,
    value: value,
    clearText: "",
    openText: "",
    name: "",
    onChange: function onChange(e, value) {
      var apiValue = value ? value.value : null;
      props.handleFiltersChange(apiValue, field.filterOptions.key, field.filterOptions.component);
      setValue(value);
    },
    classes: {
      popper: classes.boxShadow,
      inputRoot: classes.noWrap,
      paper: classes.background
    },
    renderInput: function renderInput(params) {
      return React.createElement(TextField, _extends({}, params, {
        variant: "standard",
        fullWidth: true
      }));
    },
    renderTags: function renderTags(value, getTagProps) {
      return value.map(function (option, index) {
        return React.createElement("span", _extends({
          style: {
            font: 'inherit',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }
        }, getTagProps({
          index: index
        })), option.label);
      });
    },
    renderOption: function renderOption(option, _ref) {
      var selected = _ref.selected;
      return field.multiple ? React.createElement(React.Fragment, null, React.createElement(Checkbox$1, {
        color: "primary",
        icon: icon,
        checkedIcon: checkedIcon,
        style: {
          marginRight: 8
        },
        checked: selected
      }), option.label) : React.createElement(React.Fragment, null, option.label);
    }
  }));
}

var useStyle$a = makeStyles$1(function (theme) {
  return {
    checkboxHeader: {
      minWidth: '88.8px !important',
      maxWidth: '88.8px !important',
      width: '88.8px !important'
    },
    selectInput: {
      padding: '6.5px 14px 6.5px 0px'
    },
    operatorInput: {
      padding: '6px 0px 0px 0px !important'
    },
    date: _defineProperty({
      minWidth: 130
    }, "& input", {
      padding: '6.5px 14px'
    }),
    normal: {}
  };
});

function TableGeneratorHeader(props) {
  var classes = useStyle$a(props);
  var collapseFields = props.collapseFields,
      searchColumnsFilter = props.searchColumnsFilter,
      fields = props.fields,
      orderBy = props.orderBy,
      order = props.order,
      openFilters = props.openFilters,
      _props$checkboxColumn = props.checkboxColumn,
      checkboxColumn = _props$checkboxColumn === void 0 ? true : _props$checkboxColumn,
      _props$customColumn = props.customColumn,
      customColumn = _props$customColumn === void 0 ? [] : _props$customColumn;

  var FilterInput = function FilterInput(field) {
    var filter = field.filter;
    return React.createElement(Input$2, {
      onChange: function onChange(e) {
        return props.handleFiltersChange(e.target.value, field.filterOptions.key, field.component);
      },
      placeholder: field.columnName,
      style: {
        width: '100%'
      }
    });
  };

  function getFilter(field) {
    if (field.filterOptions.visible === false) {
      return React.createElement("div", {
        style: {
          height: 28
        }
      });
    }

    switch (field.filterOptions.component) {
      case 'input':
        return FilterInput(field);

      case 'select':
        return React.createElement(SelectAuto$1, {
          field: field,
          handleFiltersChange: props.handleFiltersChange
        });

      case 'date':
        return React.createElement(Date$2, {
          field: field,
          handleFiltersChange: props.handleFiltersChange
        });

      case 'number':
        return React.createElement(FilterInputNumber, {
          field: field,
          handleFiltersChange: props.handleFiltersChange
        });

      case 'image':
        return React.createElement("div", {
          style: {
            height: 28
          }
        });

      case 'file':
        return React.createElement("div", {
          style: {
            height: 28
          }
        });

      default:
        return FilterInput(field);
    }
  }

  return React.createElement(TableHead, null, React.createElement(TableRow, {
    style: {
      verticalAlign: 'bottom'
    }
  }, checkboxColumn && React.createElement(TableCell, {
    style: {
      minWidth: '88.8px !important',
      maxWidth: '88.8px !important',
      width: '88.8px !important'
    },
    className: classes.checkboxHeader,
    classes: {
      root: classes.checkboxHeader
    }
  }), customColumn.map(function () {
    return React.createElement(TableCell, {
      style: {
        minWidth: '88.8px !important',
        maxWidth: '88.8px !important',
        width: '88.8px !important'
      },
      className: classes.checkboxHeader,
      classes: {
        root: classes.checkboxHeader
      }
    });
  }), fields.map(function (field, index) {
    return field.visible !== false && React.createElement(TableCell, {
      key: "column-".concat(field, "-").concat(index),
      align: "left",
      colSpan: field.colspan,
      sortDirection: orderBy === field.keyName ? order : false
    }, React.createElement(TableSortLabel, {
      tabindex: "-1",
      style: {
        cursor: 'pointer'
      },
      active: orderBy === field.keyName,
      direction: order,
      onClick: function onClick(e) {
        return props.createSortHandler(field.keyName, e);
      }
    }, field.columnName), searchColumnsFilter && React.createElement(Collapse$1, {
      in: openFilters,
      collapsedHeight: 0,
      transitionDuration: "auto"
    }, getFilter(field)));
  })));
}

function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var committed = useRef(initial);
  var isInputMatch = Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = isInputMatch ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  useEffect(function () {
    committed.current = cache;
  }, [cache]);
  return cache.result;
}

function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}

var useMemo = useMemoOne;
var useCallback = useCallbackOne;

var _global = createCommonjsModule(function (module) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
  var core = module.exports = {
    version: '2.6.11'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});

var _core_1 = _core.version;

var _aFunction = function _aFunction(it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
}; // optional / simple context binding


var _ctx = function _ctx(fn, that, length) {
  _aFunction(fn);

  if (that === undefined) return fn;

  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var _isObject = function _isObject(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function _anObject(it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function _fails(exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
}; // Thank's IE8 for his funny defineProperty


var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

var document$1 = _global.document; // typeof document.createElement is 'object' in old IE

var is = _isObject(document$1) && _isObject(document$1.createElement);

var _domCreate = function _domCreate(it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
}); // 7.1.1 ToPrimitive(input [, PreferredType])
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string


var _toPrimitive = function _toPrimitive(it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;
var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);

  P = _toPrimitive(P, true);

  _anObject(Attributes);

  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var _objectDp = {
  f: f
};

var _propertyDesc = function _propertyDesc(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;

var _has = function _has(it, key) {
  return hasOwnProperty$1.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;

  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue; // export native or passed

    out = own ? target[key] : source[key]; // prevent global pollution for namespaces

    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global) // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();

            case 1:
              return new C(a);

            case 2:
              return new C(a, b);
          }

          return new C(a, b, c);
        }

        return C.apply(this, arguments);
      };

      F[PROTOTYPE] = C[PROTOTYPE];
      return F; // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
}; // type bitmap


$export.F = 1; // forced

$export.G = 2; // global

$export.S = 4; // static

$export.P = 8; // proto

$export.B = 16; // bind

$export.W = 32; // wrap

$export.U = 64; // safe

$export.R = 128; // real proto method for `library`

var _export = $export;
var toString = {}.toString;

var _cof = function _cof(it) {
  return toString.call(it).slice(8, -1);
}; // fallback for non-array-like ES3 and non-enumerable old V8 strings
// eslint-disable-next-line no-prototype-builtins


var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
}; // 7.2.1 RequireObjectCoercible(argument)


var _defined = function _defined(it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
}; // to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function _toIobject(it) {
  return _iobject(_defined(it));
}; // 7.1.4 ToInteger


var ceil = Math.ceil;
var floor = Math.floor;

var _toInteger = function _toInteger(it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
}; // 7.1.15 ToLength


var min = Math.min;

var _toLength = function _toLength(it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

var _toAbsoluteIndex = function _toAbsoluteIndex(index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
}; // false -> Array#indexOf
// true  -> Array#includes


var _arrayIncludes = function _arrayIncludes(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);

    var length = _toLength(O.length);

    var index = _toAbsoluteIndex(fromIndex, length);

    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }
    return !IS_INCLUDES && -1;
  };
};

var _shared = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = _global[SHARED] || (_global[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: _core.version,
    mode: 'pure',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
});

var id = 0;
var px = Math.random();

var _uid = function _uid(key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function _sharedKey(key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);

var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function _objectKeysInternal(object, names) {
  var O = _toIobject(object);

  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    if (key != IE_PROTO) _has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }

  return result;
}; // IE 8- don't enum bug keys


var _enumBugKeys = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(','); // 19.1.2.14 / 15.2.3.14 Object.keys(O)


var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);

  var keys = _objectKeys(Properties);

  var length = keys.length;
  var i = 0;
  var P;

  while (length > i) {
    _objectDp.f(O, P = keys[i++], Properties[P]);
  }

  return O;
};

var document$2 = _global.document;

var _html = document$2 && document$2.documentElement; // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


var IE_PROTO$1 = _sharedKey('IE_PROTO');

var Empty = function Empty() {
  /* empty */
};

var PROTOTYPE$1 = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');

  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';

  _html.appendChild(iframe);

  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);

  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;

  while (i--) {
    delete _createDict[PROTOTYPE$1][_enumBugKeys[i]];
  }

  return _createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO$1] = O;
  } else result = _createDict();

  return Properties === undefined ? result : _objectDps(result, Properties);
}; // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


_export(_export.S, 'Object', {
  create: _objectCreate
});

var $Object = _core.Object;

var create = function create(P, D) {
  return $Object.create(P, D);
};

var create$1 = create;

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = create$1(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var f$1 = Object.getOwnPropertySymbols;
var _objectGops = {
  f: f$1
};
var f$2 = {}.propertyIsEnumerable;
var _objectPie = {
  f: f$2
}; // 7.1.13 ToObject(argument)

var _toObject = function _toObject(it) {
  return Object(_defined(it));
}; // 19.1.2.1 Object.assign(target, source, ...)


var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {}; // eslint-disable-next-line no-undef

  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = _toObject(target);

  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;

  while (aLen > index) {
    var S = _iobject(arguments[index++]);

    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign; // 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', {
  assign: _objectAssign
});

var assign$1 = _core.Object.assign;
var assign$2 = assign$1;

function _extends$1() {
  _extends$1 = assign$2 || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';

function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};

var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};

var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse$1 = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ? process.env.NODE_ENV !== "production" ? invariant(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : invariant(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};

var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};

var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse$1(styles.marginTop),
    right: parse$1(styles.marginRight),
    bottom: parse$1(styles.marginBottom),
    left: parse$1(styles.marginLeft)
  };
  var padding = {
    top: parse$1(styles.paddingTop),
    right: parse$1(styles.paddingRight),
    bottom: parse$1(styles.paddingBottom),
    left: parse$1(styles.paddingLeft)
  };
  var border = {
    top: parse$1(styles.borderTopWidth),
    right: parse$1(styles.borderRightWidth),
    bottom: parse$1(styles.borderBottomWidth),
    left: parse$1(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};

var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};

function areInputsEqual$1(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual$1;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  function memoized() {
    var newArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }

  return memoized;
}

var isEnum = _objectPie.f;

var _objectToArray = function _objectToArray(isEntries) {
  return function (it) {
    var O = _toIobject(it);

    var keys = _objectKeys(O);

    var length = keys.length;
    var i = 0;
    var result = [];
    var key;

    while (length > i) {
      key = keys[i++];

      if (!_descriptors || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }

    return result;
  };
}; // https://github.com/tc39/proposal-object-values-entries


var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

var values = _core.Object.values;
var values$1 = values; // most Object methods by ES6 should accept primitives

var _objectSap = function _objectSap(KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);

  _export(_export.S + _export.F * _fails(function () {
    fn(1);
  }), 'Object', exp);
}; // 19.1.2.14 Object.keys(O)


_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var keys = _core.Object.keys;
var keys$1 = keys;

var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
}; // 20.3.3.1 / 15.9.4.4 Date.now()


_export(_export.S, 'Date', {
  now: function now() {
    return new Date().getTime();
  }
});

var now = _core.Date.now;
var now$1 = now; // 20.1.2.3 Number.isInteger(number)

var floor$1 = Math.floor;

var _isInteger = function isInteger(it) {
  return !_isObject(it) && isFinite(it) && floor$1(it) === it;
}; // 20.1.2.3 Number.isInteger(number)


_export(_export.S, 'Number', {
  isInteger: _isInteger
});

var isInteger = _core.Number.isInteger;
var isInteger$1 = isInteger;
var isProduction$1 = process.env.NODE_ENV === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};

var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';

function log(type, message) {
  var _console;

  if (isProduction$1) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console)[type].apply(_console, getFormattedMessage(message));
}

var warning$1 = log.bind(null, 'warn');
var error = log.bind(null, 'error');

function noop() {}

function getOptions(shared, fromBinding) {
  return _extends$1({}, shared, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}

var isProduction$1$1 = process.env.NODE_ENV === 'production';
var prefix$1 = 'Invariant failed';

function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function invariant$1(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction$1$1) {
    throw new RbdInvariant(prefix$1);
  } else {
    throw new RbdInvariant(prefix$1 + ": " + (message || ''));
  }
}

var ErrorBoundary = function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
        process.env.NODE_ENV !== "production" ? warning$1("\n        An error was caught by our window 'error' event listener while a drag was occurring.\n        The active drag has been aborted.\n      ") : void 0;
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();

        if (process.env.NODE_ENV !== 'production') {
          error(err.message);
        }
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (process.env.NODE_ENV !== 'production') {
        error(err.message);
      }

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(React.Component);

var liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  liftInstruction: liftInstruction,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};
var origin = {
  x: 0,
  y: 0
};

var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};

var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};

var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};

var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};

var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};

var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};

var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};

var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = function executeClip(frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
};

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};

var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};

var noSpacing$1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return _extends$1({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = function getSubject(_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
};

var scrollDroppable = function scrollDroppable(droppable, newScroll) {
  !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant$1(false) : invariant$1(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = _extends$1({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = _extends$1({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
};

function values$2(map) {
  return values$1(map);
}

function findIndex$1(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}

function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex$1(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}

function toArray(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = memoizeOne(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = memoizeOne(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = memoizeOne(function (droppables) {
  return values$2(droppables);
});
var toDraggableList = memoizeOne(function (draggables) {
  return values$2(draggables);
});
var getDraggablesInsideDroppable = memoizeOne(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}

function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = memoizeOne(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = function moveToNextCombine(_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return _extends$1({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex$1(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Could not find displaced item in set') : invariant$1(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
};

var isHomeOf = function isHomeOf(draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
};

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = function isWithin(lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
};

var isPartiallyVisibleThroughFrame = function isPartiallyVisibleThroughFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
};

var isTotallyVisibleThroughFrame = function isTotallyVisibleThroughFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
};

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = function isTotallyVisibleThroughFrameOnAxis(axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
};

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(_extends$1({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};

var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(_extends$1({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};

var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(_extends$1({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = function fromCombine(_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
};

var fromReorder = function fromReorder(_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
};

var moveToNextIndex = function moveToNextIndex(_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot move in direction without previous impact location') : invariant$1(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
};

var getCombinedItemDisplacement = function getCombinedItemDisplacement(_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
};

var whenCombining = function whenCombining(_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ? process.env.NODE_ENV !== "production" ? invariant$1(false) : invariant$1(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
};

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};

var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};

var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = function whenReordering(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
};

var withDroppableDisplacement = function withDroppableDisplacement(droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
};

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = function getPageBorderBoxCenterFromImpact(args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
};

var scrollViewport = function scrollViewport(viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
};

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = function speculativelyIncrease(_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = _extends$1({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
};

var withViewportDisplacement = function withViewportDisplacement(viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
};

var getClientFromPageBorderBoxCenter = function getClientFromPageBorderBoxCenter(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
};

var isTotallyVisibleInNewLocation = function isTotallyVisibleInNewLocation(_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
};

var moveToNextPlace = function moveToNextPlace(_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
};

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot get clipped area from droppable') : invariant$1(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = function getBestCrossAxisDroppable(_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
};

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};

var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = function getClosestDraggable(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
};

var getDisplacedBy = memoizeOne(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return _extends$1({}, frame, {
    scroll: _extends$1({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Should not add placeholder space to home list') : invariant$1(false) : void 0;
  !!droppable.subject.withPlaceholder ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot add placeholder size to a subject when it already has one') : invariant$1(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return _extends$1({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return _extends$1({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot remove placeholder form subject when there was none') : invariant$1(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return _extends$1({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : invariant$1(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return _extends$1({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = function moveToNewDroppable(_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
};

var moveCrossAxis = function moveCrossAxis(_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
};

var whatIsDraggedOver = function whatIsDraggedOver(impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
};

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = function moveInDirection(_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
};

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return getRect(offsetByPosition(rect, point));
};

var withDroppableScroll = function withDroppableScroll(droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
};

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = function getReorderImpact(_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
};

var combineThresholdDivisor = 4;

var getCombineImpact = function getCombineImpact(_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
};

var getDragImpact = function getDragImpact(_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
};

var patchDroppableMap = function patchDroppableMap(droppables, updated) {
  var _extends2;

  return _extends$1({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = function recomputePlaceholders(_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
};

var update = function update(_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return _extends$1({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = _extends$1({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
};

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = function recompute(_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return _extends$1({}, impact, {
    displaced: displaced
  });
};

var getClientBorderBoxCenter = function getClientBorderBoxCenter(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
};

var refreshSnap = function refreshSnap(_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ? process.env.NODE_ENV !== "production" ? invariant$1(false) : invariant$1(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Must be over a destination in SNAP movement mode') : invariant$1(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
};

var getHomeLocation = function getHomeLocation(descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
};

var getLiftEffect = function getLiftEffect(_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Expected draggable to be inside home list') : invariant$1(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
};

var patchDimensionMap = function patchDimensionMap(dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
};

var start = function start(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};

var finish = function finish(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};

var offsetDraggable = function offsetDraggable(_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = _extends$1({}, draggable, {
    placeholder: _extends$1({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
};

var getFrame = function getFrame(droppable) {
  var frame = droppable.frame;
  !frame ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Expected Droppable to have a frame') : invariant$1(false) : void 0;
  return frame;
};

var adjustAdditionsForScrollChanges = function adjustAdditionsForScrollChanges(_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
};

var publishWhileDraggingInVirtual = function publishWhileDraggingInVirtual(_ref) {
  var _extends2, _extends3;

  var state = _ref.state,
      published = _ref.published;
  start();
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = _extends$1({}, state.dimensions.droppables, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = _extends$1({}, state.dimensions.draggables, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });
  finish();

  var draggingState = _extends$1({
    phase: 'DRAGGING'
  }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = _extends$1({
    phase: 'DROP_PENDING'
  }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));

  return dropPending;
};

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return _extends$1({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};

var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return _extends$1({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'INITIAL_PUBLISH must come after a IDLE phase') : invariant$1(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    var _extends2;

    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Collection cannot start from phase " + state.phase) : invariant$1(false) : void 0;

    var _result = _extends$1({
      phase: 'COLLECTING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant$1(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, action.type + " not permitted in phase " + state.phase) : invariant$1(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, action.type + " not permitted in phase " + state.phase) : invariant$1(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Attempting to move in an unsupported phase " + state.phase) : invariant$1(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant$1(false) : void 0;
    !(_target.isEnabled !== isEnabled) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant$1(false) : void 0;

    var updated = _extends$1({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Attempting to move in an unsupported phase " + state.phase) : invariant$1(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant$1(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant$1(false) : void 0;

    var _updated = _extends$1({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot move by window in phase " + state.phase) : invariant$1(false) : void 0;
    !state.isWindowScrollAllowed ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Window scrolling is currently not supported for fixed lists') : invariant$1(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = _extends$1({}, state.viewport, {
      scroll: _extends$1({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return _extends$1({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, action.type + " received while not in DRAGGING phase") : invariant$1(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var _extends3;

    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : invariant$1(false) : void 0;

    var newState = _extends$1({
      phase: 'DROP_PENDING'
    }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot animate drop from phase " + state.phase) : invariant$1(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
};

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};

var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};

var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};

var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};

var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};

var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};

var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};

var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};

var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};

var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};

var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};

var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};

var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};

var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};

var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};

var flush = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};

var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};

var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};

var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};

var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};

var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }

  var indexes = insideDestination.map(function (d) {
    return d.descriptor.index;
  });
  var errors = {};

  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous = indexes[i - 1];

    if (current !== previous + 1) {
      errors[current] = true;
    }
  }

  if (!keys$1(errors).length) {
    return;
  }

  var formatted = indexes.map(function (index) {
    var hasError = Boolean(errors[index]);
    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
  }).join(', ');
  process.env.NODE_ENV !== "production" ? warning$1("\n    Detected non-consecutive <Draggable /> indexes.\n\n    (This can cause unexpected bugs)\n\n    " + formatted + "\n  ") : void 0;
}

function validateDimensions(critical, dimensions) {
  if (process.env.NODE_ENV !== 'production') {
    var insideDestination = getDraggablesInsideDroppable(critical.droppable.id, dimensions.draggables);
    checkIndexes(insideDestination);
  }
}

var lift$1 = function lift$1(marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Unexpected phase to start a drag') : invariant$1(false) : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        validateDimensions(critical, dimensions);
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
};

var style = function style(marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
};

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine$1 = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine$1.scale.drop + ")";
  }
};
var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;

var getDropDuration = function getDropDuration(_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
};

var getNewHomeClientOffset = function getNewHomeClientOffset(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
};

var getDropImpact = function getDropImpact(_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = _extends$1({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
};

var drop$1 = function drop$1(_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'A DROP action occurred while DROP_PENDING and still waiting') : invariant$1(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot drop in phase: " + state.phase) : invariant$1(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
};

var getWindowScroll$1 = function getWindowScroll$1() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(getWindowScroll$1());
  }

  var scheduled = rafSchd(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop;

  function isActive() {
    return unbind !== noop;
  }

  function start() {
    !!isActive() ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot start scroll listener when already active') : invariant$1(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot stop scroll listener when not active') : invariant$1(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = function scrollListener(store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
};

var getExpiringAnnounce = function getExpiringAnnounce(announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
      process.env.NODE_ENV !== "production" ? warning$1('Announcement already made. Not making a second announcement') : void 0;
      return;
    }

    if (isExpired) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
};

var getAsyncMarshal = function getAsyncMarshal() {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex$1(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Could not find timer') : invariant$1(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
};

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};

var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};

var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start();
  fn();
  finish();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = function getPublisher(getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot fire onBeforeCapture as a drag start has already been published') : invariant$1(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant$1(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant$1(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot fire onDragMove when onDragStart has not been called') : invariant$1(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = _extends$1({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Can only flush responders while dragging') : invariant$1(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : invariant$1(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = _extends$1({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
};

var responders = function responders(getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
};

var dropAnimationFinish = function dropAnimationFinish(store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot finish a drop animating when no drop is occurring') : invariant$1(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
};

var dropAnimationFlushOnScroll = function dropAnimationFlushOnScroll(store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
};

var dimensionMarshalStopper = function dimensionMarshalStopper(marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
};

var focus = function focus(marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
};

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = function autoScroll(autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : invariant$1(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
};

var pendingDrop = function pendingDrop(store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
};

var composeEnhancers = process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

var createStore$1 = function createStore$1(_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return createStore(reducer, composeEnhancers(applyMiddleware(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
};

var clean$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};

function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      start();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;
      var added = keys$1(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });
      var updated = keys$1(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });
      var result = {
        additions: added,
        removals: keys$1(removals),
        modified: updated
      };
      staging = clean$1();
      finish();
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = function getMaxScroll(_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
};

var getDocumentElement = function getDocumentElement() {
  var doc = document.documentElement;
  !doc ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot find document.documentElement') : invariant$1(false) : void 0;
  return doc;
};

var getMaxWindowScroll = function getMaxWindowScroll() {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
};

var getViewport = function getViewport() {
  var scroll = getWindowScroll$1();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
};

var getInitialPublish = function getInitialPublish(_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  start();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish();
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
};

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      You are attempting to add or remove a Draggable [id: " + entry.descriptor.id + "]\n      while a drag is occurring. This is only supported for virtual lists.\n\n      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md\n    ") : void 0;
    return false;
  }

  return true;
}

var createDimensionMarshal = function createDimensionMarshal(registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant$1(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant$1(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant$1(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Should only be subscribed when a collection is occurring') : invariant$1(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot start capturing critical dimensions as there is already a collection') : invariant$1(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
};

var canStartDrag = function canStartDrag(state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
};

var scrollWindow = function scrollWindow(change) {
  window.scrollBy(change.x, change.y);
};

var getScrollableDroppables = memoizeOne(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Invalid result') : invariant$1(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = function getBestScrollableDroppable(_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
};

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = function getDistanceThresholds(container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
};

var getPercentage = function getPercentage(_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
};

var minScroll = 1;

var getValueFromDistance = function getValueFromDistance(distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
};

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;

var dampenValueByTime = function dampenValueByTime(proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = now$1();
  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
};

var getValue$2 = function getValue$2(_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
};

var getScrollOnAxis = function getScrollOnAxis(_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue$2({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue$2({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
};

var adjustForSizeLimits = function adjustForSizeLimits(_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
};

var clean$2 = apply(function (value) {
  return value === 0 ? 0 : value;
});

var getScroll = function getScroll(_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
};

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});

var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();

var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};

var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};

var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};

var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = function getWindowScrollChange(_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
};

var getDroppableScrollChange = function getDroppableScrollChange(_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
};

var scroll$1 = function scroll$1(_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
};

var createFluidScroller = function createFluidScroller(_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = rafSchd(scrollWindow);
  var scheduleDroppableScroll = rafSchd(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot fluid scroll if not dragging') : invariant$1(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1 = function start$1(state) {
    start();
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot start auto scrolling when already started') : invariant$1(false) : void 0;
    var dragStartTime = now$1();
    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish();

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    scroll: tryScroll
  };
};

var createJumpScroller = function createJumpScroller(_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot perform a jump scroll when there is no destination') : invariant$1(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
};

var createAutoScroller = function createAutoScroller(_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
};

var prefix$1$1 = 'data-rbd';

var dragHandle = function () {
  var base = prefix$1$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();

var draggable = function () {
  var base = prefix$1$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();

var droppable = function () {
  var base = prefix$1$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();

var scrollContainer = {
  contextId: prefix$1$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';

var getStyles$1 = function getStyles$1(contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
};

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot find the head to append a style to') : invariant$1(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = useMemo(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = useRef(null);
  var dynamicRef = useRef(null);
  var setDynamicStyle = useCallback(memoizeOne(function (proposed) {
    var el = dynamicRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot set dynamic style element if it is not set') : invariant$1(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot set dynamic style element if it is not set') : invariant$1(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'style elements already mounted') : invariant$1(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot unmount ref as it is not set') : invariant$1(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = function getWindowFromEl(el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));

  if (!possible.length) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find any drag handles in the context \"" + contextId + "\"") : void 0;
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find drag handle with id \"" + draggableId + "\" as no handle with a matching id was found") : void 0;
    return null;
  }

  if (!isHtmlElement(handle)) {
    process.env.NODE_ENV !== "production" ? warning$1('drag handle needs to be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = useRef({});
  var recordRef = useRef(null);
  var restoreFocusFrameRef = useRef(null);
  var isMountedRef = useRef(false);
  var register = useCallback(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  useIsomorphicLayoutEffect(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = useMemo(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find draggable entry with id [" + id + "]") : invariant$1(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values$2(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find droppable entry with id [" + id + "]") : invariant$1(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values$2(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = useMemo(createRegistry, []);
  useEffect(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = React.createContext(null);

var getBodyElement = function getBodyElement() {
  var body = document.body;
  !body ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot find document.body') : invariant$1(false) : void 0;
  return body;
};

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};

function useAnnouncer(contextId) {
  var id = useMemo(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = useRef(null);
  useEffect(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('role', 'log');
    el.setAttribute('aria-atomic', 'true');
    assign$2(el.style, visuallyHidden);
    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        getBodyElement().removeChild(el);

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

    process.env.NODE_ENV !== "production" ? warning$1("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
  }, []);
  return announce;
}

var getId$1 = function getId(contextId) {
  return "rbd-lift-instruction-" + contextId;
};

function useLiftInstruction(contextId, liftInstruction) {
  var id = useMemo(function () {
    return getId$1(contextId);
  }, [contextId]);
  useEffect(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = liftInstruction;
    assign$2(el.style, {
      display: 'none'
    });
    getBodyElement().appendChild(el);
    return function unmount() {
      getBodyElement().removeChild(el);
    };
  }, [id, liftInstruction]);
  return id;
}

var AppContext = React.createContext(null);
var peerDependencies = {
  react: "^16.8.5",
  "react-dom": "^16.8.5"
};
var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Unable to parse React version " + value) : invariant$1(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = function checkReactVersion(peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
};

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";

var checkDoctype = function checkDoctype(doc) {
  var doctype = doc.doctype;

  if (!doctype) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
  }

  if (doctype.publicId !== '') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
  }
};

function useDev(useHook) {
  if (process.env.NODE_ENV !== 'production') {
    useHook();
  }
}

function useDevSetupWarning(fn, inputs) {
  useDev(function () {
    useEffect(function () {
      try {
        fn();
      } catch (e) {
        error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}

function useStartupValidation() {
  useDevSetupWarning(function () {
    checkReactVersion(peerDependencies.react, React.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = useRef(current);
  useEffect(function () {
    ref.current = current;
  });
  return ref;
}

function create$2() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot claim lock as it is already claimed') : invariant$1(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot release lock when there is no lock') : invariant$1(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var escape$1 = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;

var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);

var preventStandardKeyEvents = function preventStandardKeyEvents(event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
};

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot be IDLE') : invariant$1(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === escape$1) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Unexpected phase') : invariant$1(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = useRef(idle$1);
  var unbindEventsRef = useRef(noop);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = useMemo(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Expected to move from IDLE to PENDING drag') : invariant$1(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === escape$1) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = useRef(noop$1);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot stop capturing a keyboard drag when not capturing') : invariant$1(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === escape$1) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$1(false) : invariant$1(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor$1(api) {
  var phaseRef = useRef(idle$2);
  var unbindEventsRef = useRef(noop);
  var getPhase = useCallback(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot start dragging from phase " + phase.type) : invariant$1(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Expected to move from IDLE to PENDING drag') : invariant$1(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

function useValidateSensorHooks(sensorHooks) {
  useDev(function () {
    var previousRef = usePrevious(sensorHooks);
    useDevSetupWarning(function () {
      !(previousRef.current.length === sensorHooks.length) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot change the amount of sensor hooks after mounting') : invariant$1(false) : void 0;
    });
  });
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = function getBorderBoxCenterPosition(el) {
  return getRect(el.getBoundingClientRect()).center;
};

function isElement$1(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement$1(target)) {
    process.env.NODE_ENV !== "production" ? warning$1('event.target must be a Element') : void 0;
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
    process.env.NODE_ENV !== "production" ? warning$1('drag handle must be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));
  var draggable$1 = find(possible, function (el) {
    return el.getAttribute(draggable.id) === draggableId;
  });

  if (!draggable$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1)) {
    process.env.NODE_ENV !== "production" ? warning$1('Draggable element is not a HTMLElement') : void 0;
    return null;
  }

  return draggable$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive,
      shouldWarn = _ref.shouldWarn;

  if (!isLockActive()) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Cannot perform action.\n        The sensor no longer has an action lock.\n\n        Tips:\n\n        - Throw away your action handlers when forceStop() is called\n        - Check actions.isActive() if you really need to\n      ") : void 0;
    }

    return false;
  }

  if (expected !== phase) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Cannot perform action.\n        The actions you used belong to an outdated phase\n\n        Current phase: " + expected + "\n        You called an action from outdated phase: " + phase + "\n\n        Tips:\n\n        - Do not use preDragActions actions after calling preDragActions.lift()\n      ") : void 0;
    }

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find draggable with id: " + draggableId) : void 0;
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find draggable element with id: " + draggableId) : void 0;
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot lift in phase " + phase) : invariant$1(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return _extends$1({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1 = rafSchd(function (client) {
      tryDispatchWhenDragging(function () {
        return move({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1.cancel();
      },
      actions: {
        move: move$1
      }
    });
    return _extends$1({}, api, {
      move: move$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useMouseSensor$1];

function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = useState(function () {
    return create$2();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  useIsomorphicLayoutEffect(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  useIsomorphicLayoutEffect(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = useCallback(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = useCallback(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = useCallback(lockAPI.tryAbandon, [lockAPI]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = useMemo(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Could not find store from lazy ref') : invariant$1(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      liftInstruction = props.liftInstruction;
  var lazyStoreRef = useRef(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var liftInstructionId = useLiftInstruction(contextId, liftInstruction);
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = useMemo(function () {
    return bindActionCreators({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = useMemo(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = useMemo(function () {
    return createAutoScroller(_extends$1({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = useMemo(function () {
    return createStore$1({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  if (process.env.NODE_ENV !== 'production') {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning$1('unexpected store change') : void 0;
    }
  }

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = useCallback(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = useMemo(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      liftInstructionId: liftInstructionId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, focusMarshal, getCanLift, getIsMovementAllowed, liftInstructionId, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  useEffect(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return React.createElement(AppContext.Provider, {
    value: appContext
  }, React.createElement(Provider, {
    context: StoreContext,
    store: store
  }, props.children));
}

var instanceCount = 0;

function DragDropContext(props) {
  var contextId = useMemo(function () {
    return "" + instanceCount++;
  }, []);
  var liftInstruction = props.liftInstruction || preset.liftInstruction;
  return React.createElement(ErrorBoundary, null, function (setCallbacks) {
    return React.createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      liftInstruction: liftInstruction,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1('scroll');
var isAuto = isEqual$1('auto');
var isVisible$1 = isEqual$1('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ? process.env.NODE_ENV !== "production" ? invariant$1(false) : invariant$1(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = function checkForNestedScrollContainers(scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
};

var getScroll$1 = function getScroll$1(el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
};

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = function getEnv(start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
};

var getDroppableDimension = function getDroppableDimension(_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
};

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = function getDimension(_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
};

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};

var getListenerOptions = function getListenerOptions(options) {
  return options.shouldPublishImmediately ? immediate : delayed;
};

function useRequiredContext(Context) {
  var result = useContext(Context);
  !result ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Could not find required context') : invariant$1(false) : void 0;
  return result;
}

var count = 0;

function useUniqueId(prefix) {
  var countRef = useRef(count++);
  return prefix + "::" + countRef.current;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = useRef(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = useRef(descriptor);
  var memoizedUpdateScroll = useMemo(function () {
    return memoizeOne(function (x, y) {
      !whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Can only update scroll when dragging') : invariant$1(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function () {
    return rafSchd(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Could not find scroll options while scrolling') : invariant$1(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot collect a droppable while a drag is occurring') : invariant$1(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot collect without a droppable ref') : invariant$1(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (process.env.NODE_ENV !== 'production') {
        checkForNestedScrollContainers(scrollable);
      }
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : invariant$1(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot stop drag when no active drag') : invariant$1(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot scroll when there is no drag') : invariant$1(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot scroll a droppable with no closest scrollable') : invariant$1(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
        process.env.NODE_ENV !== "production" ? warning$1('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2() {}

var empty = {
  width: 0,
  height: 0,
  margin: noSpacing$1
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle$1 = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder$1(props) {
  var animateOpenTimerRef = useRef(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = useState(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  useEffect(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2;
    }

    if (animateOpenTimerRef.current) {
      return noop$2;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle$1({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return React.createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1$1 = React.memo(Placeholder$1);
var DroppableContext = React.createContext(null);

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant$1(false) : void 0;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function runChecks(args, checks) {
  checks.forEach(function (check) {
    return check(args);
  });
}

var shared$1 = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'A Droppable requires a droppableId prop') : invariant$1(false) : void 0;
  !(typeof props.droppableId === 'string') ? process.env.NODE_ENV !== "production" ? invariant$1(false, "A Droppable requires a [string] droppableId. Provided: [" + typeof props.droppableId + "]") : invariant$1(false) : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean(props.isDropDisabled) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'isDropDisabled must be a boolean') : invariant$1(false) : void 0;
  !isBoolean(props.isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'isCombineEnabled must be a boolean') : invariant$1(false) : void 0;
  !isBoolean(props.ignoreContainerClipping) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'ignoreContainerClipping must be a boolean') : invariant$1(false) : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props,
      getPlaceholderRef = _ref4.getPlaceholderRef;

  if (!props.placeholder) {
    return;
  }

  var ref = getPlaceholderRef();

  if (ref) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n      Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n      DroppableProvided > placeholder could not be found.\n\n      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n    ") : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Must provide a clone render function (renderClone) for virtual lists') : invariant$1(false) : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Expected virtual list to not have a placeholder') : invariant$1(false) : void 0;
}];

function useValidation(args) {
  useDevSetupWarning(function () {
    runChecks(args, shared$1);

    if (args.props.mode === 'standard') {
      runChecks(args, standard);
    }

    if (args.props.mode === 'virtual') {
      runChecks(args, virtual);
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  _inheritsLoose(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(React.PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine$1.opacity.drop : combine$1.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = useMemo(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = useCallback(function (windowScroll) {
    var el = getDraggableRef();
    !el ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Cannot get dimension when no ref is set') : invariant$1(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = useRef(entry);
  var isFirstPublishRef = useRef(true);
  useIsomorphicLayoutEffect(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  useIsomorphicLayoutEffect(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function useValidation$1(props, contextId, getRef) {
  useDevSetupWarning(function () {
    function prefix(id) {
      return "Draggable[id: " + id + "]: ";
    }

    var id = props.draggableId;
    !id ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Draggable requires a draggableId') : invariant$1(false) : void 0;
    !(typeof id === 'string') ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Draggable requires a [string] draggableId.\n      Provided: [type: " + typeof id + "] (value: " + id + ")") : invariant$1(false) : void 0;
    !isInteger$1(props.index) ? process.env.NODE_ENV !== "production" ? invariant$1(false, prefix(id) + " requires an integer index prop") : invariant$1(false) : void 0;

    if (props.mapped.type === 'DRAGGING') {
      return;
    }

    checkIsValidInnerRef(getRef());

    if (props.isEnabled) {
      !findDragHandle(contextId, id) ? process.env.NODE_ENV !== "production" ? invariant$1(false, prefix(id) + " Unable to find drag handle") : invariant$1(false) : void 0;
    }
  });
}

function useClonePropValidation(isClone) {
  useDev(function () {
    var initialRef = useRef(isClone);
    useDevSetupWarning(function () {
      !(isClone === initialRef.current) ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Draggable isClone prop value changed during component life') : invariant$1(false) : void 0;
    }, [isClone]);
  });
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable(props) {
  var ref = useRef(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      liftInstructionId = _useRequiredContext.liftInstructionId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = useMemo(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1(props, contextId, getRef);
  useClonePropValidation(isClone);

  if (!isClone) {
    var forPublisher = useMemo(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = useMemo(function () {
    return isEnabled ? {
      tabIndex: 0,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      'aria-labelledby': liftInstructionId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, draggableId, isEnabled, liftInstructionId]);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function () {
    var style = getStyle$1$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = useMemo(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = function isStrictEqual(a, b) {
  return a === b;
};

var whatIsDraggedOverFromResult = function whatIsDraggedOverFromResult(result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
};

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = memoizeOne(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine$1.opacity.drop : null,
        scale: _combineWith ? combine$1.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(getSecondarySnapshot);
  var getMemoizedProps = memoizeOne(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};

var mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = connect(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return React.createElement(ConnectedDraggable, props);
}

function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return React.createElement(PrivateDraggable, _extends$1({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = useContext(AppContext);
  !appContext ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'Could not find app context') : invariant$1(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = useRef(null);
  var placeholderRef = useRef(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  useValidation({
    props: props,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = React.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return React.createElement(Placeholder$1$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = useMemo(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = React.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return ReactDOM.createPortal(node, getContainerForClone());
  }

  return React.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = _extends$1({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = memoizeOne(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = memoizeOne(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};

var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ? process.env.NODE_ENV !== "production" ? invariant$1(false, 'document.body is not ready') : invariant$1(false) : void 0;
  return document.body;
}

var defaultProps = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;
var useStyle$b = makeStyles(function (theme) {
  return {
    root: {
      flex: 1
    },
    titleContainer: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      borderBottom: '1px solid #ddd'
    },
    title: {
      flex: 1,
      padding: '16px 32px',
      textAlign: 'center'
    },
    name: {
      flex: 1,
      textAlign: 'center'
    },
    fieldContainer: {
      alignItems: 'center',
      backgroundColor: '#fff',
      display: 'flex',
      padding: '12px 0',
      width: '100%',
      borderBottom: '1px solid #ddd',
      '&:hover': {
        backgroundColor: '#ededed'
      }
    },
    width: {
      width: 415,
      overflow: 'hidden'
    }
  };
});

function _SettingsDialog(props) {
  var theme = useTheme();
  var classes = useStyle$b(props);
  var fullScreen = useMediaQuery$1(theme.breakpoints.down('sm'));
  var onCancel = props.onCancel,
      onSubmit = props.onSubmit;
  var _props$open = props.open,
      open = _props$open === void 0 ? true : _props$open,
      title = props.title,
      message = props.message;
  var cancelProps = props.cancelProps,
      submitProps = props.submitProps,
      fields = props.fields,
      _props$label = props.label,
      label = _props$label === void 0 ? 'Conferma' : _props$label;

  var onDragEnd =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(evt) {
      var source, destination, item;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              source = evt.source, destination = evt.destination;
              item = props.fields[source.index];
              props.moveArray(fields, source.index, destination.index);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onDragEnd(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return React.createElement(Dialog, {
    fullScreen: fullScreen,
    open: open,
    classes: {
      paperWidthSm: classes.width
    },
    onClose: props.onCancel
  }, React.createElement("div", {
    className: classes.titleContainer
  }, React.createElement("div", {
    style: {
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    }
  }, React.createElement(Typography, {
    variant: "h6",
    style: {
      flex: 1
    }
  }, title), React.createElement(IconButton$1$1, {
    style: {
      padding: 0
    }
  }, React.createElement(Icon$1$1, {
    style: {
      alignItems: 'center'
    },
    onClick: props.onCancel
  }, "close")))), React.createElement(DialogContent, {
    style: {
      overflowY: 'auto',
      maxHeight: '70vh',
      padding: '24px 16px'
    }
  }, React.createElement(DragDropContext, {
    onDragEnd: onDragEnd
  }, React.createElement(ConnectedDroppable, {
    droppableId: "fieldDrop"
  }, function (provided, snapshot) {
    return React.createElement("div", {
      ref: provided.innerRef
    }, fields.map(function (item, index) {
      return React.createElement(PublicDraggable, {
        key: item.columnName,
        draggableId: item.columnName,
        index: index
      }, function (provided, snapshot) {
        return React.createElement("div", _extends({
          className: classes.fieldContainer,
          ref: provided.innerRef
        }, provided.draggableProps), React.createElement("div", _extends({}, provided.dragHandleProps, {
          style: {
            borderRadius: 18,
            padding: 12
          }
        }), React.createElement(Icon$1$1, null, "dehaze")), React.createElement(Typography, {
          className: classes.name
        }, item.columnName), item.required ? React.createElement(Icon$1$1, {
          style: {
            padding: 12
          }
        }, "lock") : React.createElement(IconButton$1$1, {
          onClick: function onClick() {
            return props.deleteField(index);
          }
        }, React.createElement(Icon$1$1, null, "cancel")));
      });
    }), provided.placeholder);
  }))), React.createElement(DialogActions, {
    style: {
      padding: 24,
      alignItems: 'flex-end'
    }
  }, props.fieldsDeleted.length > 0 && React.createElement(FormControl, {
    style: {
      flex: 1
    }
  }, React.createElement(InputLabel, null, "Aggiugi colonna"), React.createElement(Select$1, {
    disabled: props.fieldsDeleted.length === 0,
    onChange: function onChange(e) {
      return props.handleAddField(e.target.value);
    }
  }, props.fieldsDeleted.map(function (item) {
    return React.createElement(MenuItem, {
      value: item
    }, item.columnName);
  }))), React.createElement(Button, {
    onClick: function onClick() {
      return props.onCancel();
    },
    color: "secondary",
    variant: "contained",
    style: {
      borderRadius: 18,
      flex: 1,
      maxWidth: '33%',
      marginLeft: 12
    }
  }, label)));
}

var useStyle$c = makeStyles$1(function (theme) {
  return {
    root: {
      flex: 1
    },
    container: {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    inputSearch: {
      minWidth: 300,
      background: '#fff',
      borderTopRightRadius: 4,
      borderTopLeftRadius: 4,
      '& input': {
        padding: 12,
        borderTopLeftRadius: 4
      }
    }
  };
});

function TableSettings(props) {
  var classes = useStyle$c(props);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var fields = props.fields,
      filterIcon = props.filterIcon,
      moveArray = props.moveArray,
      deleteField = props.deleteField,
      fieldsDeleted = props.fieldsDeleted,
      handleAddField = props.handleAddField,
      openFilters = props.openFilters,
      _props$hasSearch = props.hasSearch,
      hasSearch = _props$hasSearch === void 0 ? true : _props$hasSearch,
      _props$hasFilters = props.hasFilters,
      hasFilters = _props$hasFilters === void 0 ? true : _props$hasFilters,
      _props$hasSettings = props.hasSettings,
      hasSettings = _props$hasSettings === void 0 ? true : _props$hasSettings;

  var SearchBar = function SearchBar() {
    return React.createElement("div", {
      className: classes.container
    }, React.createElement("form", {
      onSubmit: function onSubmit(e) {
        return props.onConfirm(e);
      },
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, React.createElement(Input$2, {
      className: classes.inputSearch,
      onChange: function onChange(e) {
        return props.OnSearch && props.OnSearch(e);
      },
      placeholder: props.placeholder ? props.placeholder : 'Search'
    }), React.createElement(Button$1$1, {
      type: "submit",
      variant: "contained",
      color: "primary",
      style: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }, React.createElement(Icon$1, null, "search"))));
  };

  return React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      top: -4,
      left: 0,
      position: 'sticky',
      zIndex: 20,
      marginBottom: 12
    },
    id: "settings-header"
  }, hasSettings && React.createElement("div", {
    style: {
      margin: 6,
      marginBottom: 0
    }
  }, React.createElement(IconButton$1, {
    style: {
      border: '1px solid #e0e0e0'
    },
    onClick: function onClick() {
      return setOpen(true);
    }
  }, React.createElement(Tooltip, {
    title: "Impostazioni"
  }, React.createElement(Icon$1, null, "settings_applications")))), hasFilters && React.createElement("div", {
    style: {
      margin: 6,
      marginBottom: 0
    }
  }, React.createElement(Tooltip, {
    title: "Filtri"
  }, React.createElement(IconButton$1, {
    style: {
      border: '1px solid #e0e0e0'
    },
    onClick: function onClick() {
      return props.setOpenFilters(!openFilters);
    }
  }, filterIcon))), hasSearch && props.onConfirm && React.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement(SearchBar, null)), React.createElement(_SettingsDialog, {
    open: open,
    title: "Visibilit\xE0 delle colonne",
    fields: fields,
    moveArray: moveArray,
    fieldsDeleted: fieldsDeleted,
    handleAddField: handleAddField,
    deleteField: deleteField,
    onCancel: function onCancel() {
      return setOpen(false);
    },
    onSubmit: function onSubmit() {
      setOpen(false);
    },
    cancelProps: {
      label: 'Cancel'
    },
    submitProps: {
      label: 'Confirm'
    }
  })));
}

var useStyle$d = makeStyles(function (theme) {
  return {
    root: {
      flex: 1
    }
  };
});

function useForceUpdate() {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1]; // integer state


  return function () {
    return setValue(function (value) {
      return ++value;
    });
  }; // update the state to force render
}

function TableGenerator(props) {
  var classes = useStyle$d(props);

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useState5 = useState(props.rowsPerPage ? props.rowsPerPage : 5),
      _useState6 = _slicedToArray(_useState5, 2),
      rowsPerPage = _useState6[0],
      setRowsPerPage = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      formSerialized = _useState8[0],
      setFormSerialized = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedElements = _useState10[0],
      setSelectedElements = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      lastChecked = _useState12[0],
      setLastChecked = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      searchQuery = _useState14[0],
      setSearchQuery = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      filterData = _useState16[0],
      setFilterData = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      editData = _useState18[0],
      setEditData = _useState18[1];

  var _useState19 = useState(''),
      _useState20 = _slicedToArray(_useState19, 2),
      orderBy = _useState20[0],
      setOrderBy = _useState20[1];

  var _useState21 = useState(''),
      _useState22 = _slicedToArray(_useState21, 2),
      openFilters = _useState22[0],
      setOpenFilters = _useState22[1];

  var _useState23 = useState('asc'),
      _useState24 = _slicedToArray(_useState23, 2),
      order = _useState24[0],
      setOrder = _useState24[1];

  var _useState25 = useState(props.fields),
      _useState26 = _slicedToArray(_useState25, 2),
      fields = _useState26[0],
      setFields = _useState26[1];

  var _useState27 = useState([]),
      _useState28 = _slicedToArray(_useState27, 2),
      fieldsDeleted = _useState28[0],
      setFieldsDeleted = _useState28[1];

  var forceUpdate = useForceUpdate();
  useEffect(function () {
    setFilterData(props.data);
    setEditData(props.data);
  }, [props]);
  useEffect(function () {
    prepareTableFields(props.fields);
  }, [props.fields]);
  useEffect(function () {
    if (props.selectedElements) setSelectedElements(props.selectedElements);
  }, [props.selectedElements]);
  useEffect(function () {
    if (props.page !== undefined) {
      setPage(props.page);
    }
  }, [props.page]);

  function prepareTableFields(fields) {
    if (fields[0].constructor === Array) {
      // 0: backend fields - 1: frontend fields
      fields = prepareFields(props.tableName, fields[0], fields[1]);
    } else {
      fields = prepareFields(props.tableName, fields, fields);
    } // restore the disabled after the api call


    if (!props.readOnly) {
      formSerialized.map(function (field) {
        field.disabled = false;
      });
    }

    setFormSerialized(initFormSerializedState(fields, {}));
  }

  function prepareFields(formName, fieldsFromBackend, frontPrepare) {
    var serialFields = frontPrepare.map(function (frontField) {
      var tmpKey = frontField.keyName ? frontField.keyName.split('.') : [frontField.keyName];
      var backField = fieldsFromBackend.filter(function (item) {
        return tmpKey[0] === item.key;
      })[0];

      var mergedField = _objectSpread2({}, backField, {}, frontField); // Prepare the structure {label:translate(field.key].[value]), value:value} for select/select_auto ...


      var key = frontField.filterElement ? "".concat(tmpKey[0], ".").concat(frontField.filterElement) : tmpKey.length > 1 ? "".concat(tmpKey[0], ".id") : tmpKey[0];
      mergedField = typeof mergedField.component === 'function' || mergedField.type === 'custom' || mergedField.component === 'image' || mergedField.component === 'date' ? {
        keyName: mergedField.keyName,
        columnName: mergedField.columnName,
        component: mergedField.component,
        filterOptions: {
          key: key,
          component: mergedField.type === 'number' ? 'number' : backField && backField.component ? backField.component : mergedField.component,
          values: mergedField.values ? mergedField.values : null
        }
      } : {
        keyName: mergedField.keyName,
        columnName: mergedField.columnName,
        filterOptions: {
          key: key,
          component: mergedField.type === 'number' ? 'number' : mergedField.component,
          values: mergedField.values ? mergedField.values : null
        }
      };
      mergedField = prepareValuesLabel(formName, mergedField);
      return mergedField;
    }); // transform backend properties in camelCase

    return arrayObjToCamelCase(serialFields);
  }

  function prepareValuesLabel(formName, originalField) {
    var field = originalField; // Select

    if (field.filterOptions.component === 'select') {
      if (field.filterOptions.values) {
        field.filterOptions.values = field.filterOptions.values.map(function (item) {
          return getValues(item);
        }); // if value is undefined set [] for multiple fields

        if (field.multiple && typeof field.value === 'undefined') field.value = [];
      }
    } // TODO : Autocomplete
    // TODO : Address


    if (field.filterOptions.component === 'address') {
      field.value = {
        label: field.value && field.value.address,
        value: field.value
      };
    }

    function getValues(item) {
      if (_typeof(item) !== 'object') {
        return {
          label: getLabel(field.keyName, item),
          value: item
        };
      }

      return item;
    }

    function getLabel(key, item) {
      // if formName props exist create the translation string as {formName}.{key}.{item}
      var label = formName ? "".concat(formName, ".").concat(key, ".").concat(item) : "".concat(key, ".").concat(item);
      var translation = translate(label);

      if (translation !== 'TRANSLATION_NOT_FOUND') {
        return translation;
      }

      return item;
    }

    return field;
  }

  function handleFiltersChange(value, key, type) {
    var operator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null; // set page to 0 to

    setPage(0); // Call the external props

    var index = -1;
    if (Array.isArray(key)) index = searchQuery.findIndex(function (o) {
      return key.includes(o.keyName);
    });else index = searchQuery.findIndex(function (o) {
      return o.keyName === key;
    });
    var tmpSearchQuery = searchQuery;

    if (index === -1) {
      if (Array.isArray(key)) {
        key.map(function (keyName) {
          return tmpSearchQuery = [].concat(_toConsumableArray(searchQuery), [{
            keyName: keyName,
            value: value
          }]);
        });
        setSearchQuery(tmpSearchQuery);
      } else {
        tmpSearchQuery = [].concat(_toConsumableArray(searchQuery), [{
          keyName: key,
          value: value
        }]);
        setSearchQuery(tmpSearchQuery);
      }
    } else {
      tmpSearchQuery.splice(index, 1);
      tmpSearchQuery[tmpSearchQuery.length] = {
        keyName: key,
        value: value
      };
      setSearchQuery(tmpSearchQuery);
    }

    if (props.onFiltersChange) {
      var filters = {};
      tmpSearchQuery.map(function (item) {
        return filters = _objectSpread2({}, filters, _defineProperty({}, item.keyName, {
          value: item.value,
          type: type,
          operator: operator
        }));
      });
      props.onFiltersChange(page, rowsPerPage * 2, filterData.length, filters);
    } else {
      filterTable(tmpSearchQuery);
    }
  }

  function filterTable(query) {
    var data = props.data;

    var filterData = _toConsumableArray(data);

    query.map(function (field) {
      return field.value !== '' ? filterData = filterData.filter(function (item) {
        if (item[field.keyName] !== undefined && item[field.keyName] !== null) {
          return JSON.stringify(item[field.keyName]).toLowerCase().includes(field.value.toLowerCase());
        }

        return false;
      }) : field;
    });
    setFilterData(filterData);
    setEditData(filterData);
  }

  function handleOnChangeCheckbox(element, e, idx) {
    var dataFilteredPerPage = _toConsumableArray(props.data);

    var index = selectedElements.findIndex(function (item) {
      return item.id === element.id;
    });

    var newSelectedElements = _toConsumableArray(selectedElements);

    if (index >= 0) newSelectedElements.splice(index, 1);else {
      if (e.shiftKey && lastChecked && !props.maxSelectableElements) {
        var start = dataFilteredPerPage.findIndex(function (item) {
          return item.id === lastChecked.id;
        });
        var end = dataFilteredPerPage.findIndex(function (item) {
          return item.id === element.id;
        });
        var shiftSelected = end > start + 1 ? dataFilteredPerPage.slice(start + 1, end) : dataFilteredPerPage.slice(end + 1, start);
        shiftSelected.map(function (element) {
          return newSelectedElements.push(element);
        });
      }

      newSelectedElements.push(element);
    } // Check the maxSelectableElements to define the selectedElements

    if (props.maxSelectableElements && newSelectedElements.length > props.maxSelectableElements) newSelectedElements.splice(0, 1);
    !index >= 0 && setLastChecked(element); // remove duplicates

    newSelectedElements = newSelectedElements.filter(function (thing, index, self) {
      return index === self.findIndex(function (t) {
        return t.id === thing.id;
      });
    });
    setSelectedElements(newSelectedElements);

    if (props.onChangeSelected) {
      props.onChangeSelected(newSelectedElements);
    }
  }

  function handleRequestSort(event, property) {
    var newOrderBy = property;
    var newOrder = 'desc';

    if (orderBy === property && order === 'desc') {
      newOrder = 'asc';
    }

    if (orderBy === property && order === 'asc') {
      newOrderBy = '';
    }

    setOrder(newOrder);
    setOrderBy(newOrderBy);
  }

  function createSortHandler(property, event) {
    handleRequestSort(event, property);
  }

  function handleChangePage(e, page, limit, offset) {
    setPage(page);

    if (props.onChangePage) {
      props.onChangePage(page, limit * 2, offset, searchQuery);
    }
  }

  function handleMoveArray(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    var tmpArr = arr;
    tmpArr.splice(fromIndex, 1);
    tmpArr.splice(toIndex, 0, element);
    setFormSerialized(tmpArr);
    forceUpdate();
  }

  function handleDeleteField(index) {
    var tmpArr = formSerialized;
    var tmpArrDeleted = fieldsDeleted;
    if (tmpArrDeleted.length > 0) tmpArrDeleted = [].concat(_toConsumableArray(tmpArrDeleted), _toConsumableArray(tmpArr.splice(index, 1)));else tmpArrDeleted = tmpArr.splice(index, 1);
    setFormSerialized(tmpArr);
    setFieldsDeleted(tmpArrDeleted);
    forceUpdate();
  }

  function handleAddField(item) {
    var tmpArr = formSerialized;
    tmpArr = [item].concat(_toConsumableArray(tmpArr));
    setFormSerialized(tmpArr);
    var tmpArrDeleted = fieldsDeleted;
    var idx = tmpArrDeleted.findIndex(function (field) {
      return field.columnName === item.columnName;
    });
    tmpArrDeleted.splice(idx, 1);
    setFieldsDeleted(tmpArrDeleted);
    forceUpdate();
  }

  function handleChangeRowsPerPage(e, rows) {
    setRowsPerPage(e.target.value);

    if (props.onChangeRows) {
      props.onChangeRows(rows.props.value);
    }

    handleChangePage(e, 0);
  }

  function collapseFields() {
    return dataFilteredPerPage.filter(function (item) {
      return Object.keys(item).includes('collapse');
    }).length > 0;
  }

  var style = props.style,
      tableProps = props.tableProps,
      _props$checkboxColumn = props.checkboxColumn,
      checkboxColumn = _props$checkboxColumn === void 0 ? true : _props$checkboxColumn,
      _props$searchColumnsF = props.searchColumnsFilter,
      searchColumnsFilter = _props$searchColumnsF === void 0 ? true : _props$searchColumnsF,
      _props$loader = props.loader,
      loader = _props$loader === void 0 ? false : _props$loader,
      _props$labelRowsPerPa = props.labelRowsPerPage,
      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Row per page' : _props$labelRowsPerPa,
      _props$labelNoResultF = props.labelNoResultFound,
      labelNoResultFound = _props$labelNoResultF === void 0 ? 'No result found' : _props$labelNoResultF,
      _props$labelLoader = props.labelLoader,
      labelLoader = _props$labelLoader === void 0 ? 'Loading table data...' : _props$labelLoader,
      data = props.data,
      _props$tableName = props.tableName,
      _props$hasPagination = props.hasPagination,
      hasPagination = _props$hasPagination === void 0 ? true : _props$hasPagination,
      count = props.count,
      _props$rowsPerPageOpt = props.rowsPerPageOptions,
      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? [5, 10, 25, 50, 100] : _props$rowsPerPageOpt,
      _props$filterIcon = props.filterIcon,
      filterIcon = _props$filterIcon === void 0 ? React.createElement(FilterList, null) : _props$filterIcon,
      rowFunctions = props.rowFunctions,
      _props$hasHeader = props.hasHeader,
      hasHeader = _props$hasHeader === void 0 ? true : _props$hasHeader,
      _props$onRowClick = props.onRowClick,
      disableCheckbox = props.disableCheckbox,
      _props$activeRowColor = props.activeRowColor,
      activeRowColor = _props$activeRowColor === void 0 ? 'transparent' : _props$activeRowColor,
      size = props.size,
      _props$customColumn = props.customColumn,
      customColumn = _props$customColumn === void 0 ? [] : _props$customColumn;
  var headerProps = {
    fields: formSerialized,
    searchColumnsFilter: searchColumnsFilter,
    checkboxColumn: checkboxColumn
  };
  var bodyProps = {
    checkboxColumn: checkboxColumn,
    searchColumnsFilter: searchColumnsFilter,
    fields: formSerialized,
    rowFunctions: rowFunctions,
    labelNoResultFound: labelNoResultFound,
    labelLoader: labelLoader,
    activeRowColor: activeRowColor,
    loader: loader
  };
  var footerProps = {
    labelRowsPerPage: labelRowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    rowsPerPage: rowsPerPage,
    page: page,
    count: count || data.length,
    activeRowColor: activeRowColor,
    loader: loader,
    offset: filterData.length
  };
  var colspan = formSerialized.length + 1;
  var dataFilteredPerPage = [];
  hasPagination ? dataFilteredPerPage = stableSort(filterData, getSorting(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : dataFilteredPerPage = stableSort(filterData, getSorting(order, orderBy));
  return React.createElement("div", {
    className: classes.root,
    style: style // TODO: fix with unique id
    ,
    id: "table-parent-id"
  }, React.createElement(TableSettings, {
    setOpenFilters: setOpenFilters,
    openFilters: openFilters,
    fields: formSerialized,
    filterIcon: filterIcon,
    onConfirm: props.onConfirm,
    OnSearch: props.OnSearch,
    moveArray: handleMoveArray,
    deleteField: handleDeleteField,
    fieldsDeleted: fieldsDeleted,
    handleAddField: handleAddField,
    hasSettings: props.hasSettings,
    hasFilters: props.hasFilters,
    hasSearch: props.hasSearch
  }), React.createElement("div", {
    style: {
      overflow: 'auto'
    }
  }, React.createElement(Table, _extends({
    className: classes.table
  }, tableProps), hasHeader && React.createElement(TableGeneratorHeader, _extends({
    orderBy: orderBy,
    openFilters: openFilters,
    order: order,
    createSortHandler: createSortHandler,
    collapseFields: collapseFields,
    handleFiltersChange: handleFiltersChange,
    customColumn: customColumn
  }, headerProps)), React.createElement(TableGeneratorBody, _extends({
    parentId: "table-parent-id",
    dataFilteredPerPage: dataFilteredPerPage,
    editData: editData,
    handleOnChangeCheckbox: handleOnChangeCheckbox,
    colspan: colspan + 1,
    selectedElements: selectedElements,
    tableName: props.tableName,
    fields: formSerialized,
    customColumn: customColumn,
    disableCheckbox: disableCheckbox,
    collapseFields: collapseFields,
    filterData: filterData,
    rowsPerPage: rowsPerPage
  }, bodyProps)), hasPagination && React.createElement(TableGeneratorFooter, _extends({
    handleChangePage: handleChangePage,
    handleChangeRowsPerPage: handleChangeRowsPerPage
  }, footerProps)))));
}

TableGenerator.propTypes = {
  /** Data displayed inside the table */
  data: propTypes.array.required,

  /** Fields and column names */
  fields: propTypes.array.required,

  /** Selected data inside the table */
  selectedElements: propTypes.array.required,

  /** Function to select data inside the table */
  handleOnChangeCheckbox: propTypes.func.required
};
TableGenerator.defaultProps = {
  handleOnChangeCheckbox: function handleOnChangeCheckbox(selected) {
    console.log(selected);
  },
  data: [],
  fields: [],
  selectedElements: []
};
/**
 * Function to prepare the api call with params filters
 * @param props
 * @param filters
 * @param page
 * @returns {{filter: *, offset: *, limit: *}}
 */

/**
 filter query method allow to generate automatically filter than cover all of SQLAlchemy columns comparator.
 To work this filter needs the similar structure in the request.args
 ...url ?filter=:'key':'operator';'value'/'value_list'&filter... etc

 api/filter=first_name:eq;manolo
 list of available option:
 eq          -->      Implement the == operator.
 le          -->      Implement the <= operator.
 lt          -->      Implement the < operator.
 gt          -->      Implement the > operator.
 ge          -->      Implement the >= operator.
 ne          -->      Implement the != operator.
 contains    -->      Implement the contain operator.
 icontains   -->      Implement the contain operator without consider the upper and lower case.
 startswith  -->      Implement the startswith operator.
 istartswith -->      Implement the startswith operator without consider the upper and lower case.
 endswith    -->      Implement the endswith operator.
 iendswith   -->      Implement the endswith operator without consider the upper and lower case.
 in          -->      Select the object contained in a list(separated by '','')
 between     -->      Produce the between clause given the lower and upper range(separated by '','').
 */

function prepareFilterOperator(type) {
  var operator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (operator) {
    return operator;
  } else switch (type) {
    case 'select':
      return 'eq';

    case 'date':
      return 'eq';

    case 'enum':
      return 'eq';

    case 'input':
      return 'icontains';

    default:
      return 'icontains';
  }
}

function prepareApiFilter(params) {
  var props = params.props,
      _params$limit = params.limit,
      limit = _params$limit === void 0 ? 40 : _params$limit;
  var filters = params.filters,
      search = params.search,
      _params$offset = params.offset,
      offset = _params$offset === void 0 ? 0 : _params$offset; // ex. api/filter=first_name:eq;manolo
  // { filter: ['first_name:icontains:manolo', 'last_name:icontains:battista']

  filters = _objectSpread2({}, props.filters, {}, filters);
  search = _objectSpread2({}, props.search, {}, search);

  if (typeof props.onAddQueryFilter === 'function') {
    props.onAddQueryFilter(filters);
  } else {
    console.error('PREPARE_API_FILTER', "prepareApiFilter needs to receive the action onAddQueryFilter, define it on mapActionToProps of your component page");
  }

  var prepareFilters = [];
  var prepareSearch = [];
  if (filters) prepareFilters = Object.keys(filters).map(function (key) {
    return filters[key] && Array.isArray(filters[key]) ? filters[key].map(function (item) {
      return "".concat(key, ";").concat(prepareFilterOperator(item.type, item.operator), ";").concat(item.value);
    }) : filters[key] && filters[key].value ? "".concat(key, ";").concat(prepareFilterOperator(filters[key].type, filters[key].operator), ";").concat(filters[key].value) : null;
  });
  if (search) prepareSearch = Object.keys(search).map(function (key) {
    return search[key] ? "".concat(key, ";icontains;").concat(search[key]) : null;
  });
  prepareFilters = prepareFilters.filter(function (item) {
    return item !== null;
  });
  prepareSearch = prepareSearch.filter(function (item) {
    return item !== null;
  }); // reset crud data

  if (prepareFilters.length > 0 || prepareSearch.length > 0) {
    if (typeof props.onResetData === 'function') {
      props.onResetData();
    } else {
      console.error('PREPARE_API_FILTER', "prepareApiFilter needs to receive the action onResetData, define it on mapActionToProps of your component page");
    }

    offset = 0;
  }

  return {
    filter: prepareFilters,
    search: prepareSearch.filter(function (item) {
      return item !== null;
    }),
    offset: offset,
    limit: limit
  };
}

function prepareApiFilterForPagination(params) {
  var props = params.props,
      _params$limit2 = params.limit,
      limit = _params$limit2 === void 0 ? 40 : _params$limit2;
  var filters = params.filters,
      search = params.search,
      _params$offset2 = params.offset,
      offset = _params$offset2 === void 0 ? 0 : _params$offset2; // ex. api/filter=first_name:eq;manolo
  // { filter: ['first_name:icontains:manolo', 'last_name:icontains:battista']

  filters = _objectSpread2({}, props.filters, {}, filters);
  search = _objectSpread2({}, props.search, {}, search);

  if (typeof props.onAddQueryFilter === 'function') {
    props.onAddQueryFilter(filters);
  } else {
    console.error('PREPARE_API_FILTER', "prepareApiFilter needs to receive the action onAddQueryFilter, define it on mapActionToProps of your component page");
  }

  var prepareFilters = [];
  var prepareSearch = [];
  if (filters) prepareFilters = Object.keys(filters).map(function (key) {
    return filters[key] && Array.isArray(filters[key]) ? filters[key].map(function (item) {
      return "".concat(key, ";").concat(prepareFilterOperator(item.type, item.operator), ";").concat(item.value);
    }) : filters[key] && filters[key].value ? "".concat(key, ";").concat(prepareFilterOperator(filters[key].type, filters[key].operator), ";").concat(filters[key].value) : null;
  });
  if (search) prepareSearch = Object.keys(search).map(function (key) {
    return search[key] ? "".concat(key, ";icontains;").concat(search[key]) : null;
  });
  prepareFilters = prepareFilters.filter(function (item) {
    return item !== null;
  });
  prepareSearch = prepareSearch.filter(function (item) {
    return item !== null;
  });
  return {
    filter: prepareFilters,
    search: prepareSearch.filter(function (item) {
      return item !== null;
    }),
    offset: offset,
    limit: limit
  };
}
/**
 * Gets GET actions and builds url with filters
 * @param action
 * @param props
 * @param limit
 * @param offset
 * @param filters
 */


function getDataFilter(action, params) {
  action(prepareApiFilter(params));
}

function getDataPagination(action, params) {
  action(prepareApiFilterForPagination(params));
}

export { ActualTime, AppBarSidebar$1 as AppBarSidebar, AppBarSidebarLayout$1 as AppBarSidebarLayout, ChangePassword$1 as ChangePassword, ConfirmDialog, DefaultLayout, Dropzone, FileInput$1 as FileInput, FormGenerator, FullScreenLoader$1 as FullScreenLoader, FunctionsToolbar, GdocViewer, ID, MessagesProvider$1 as MessagesProvider, PageProvider$1 as PageProvider, Search$1 as Search, SelectAutocomplete$1 as SelectAutocomplete, SeoProvider$1 as SeoProvider, TableGenerator, TitleSubtitleLayout, UserProvider$1 as UserProvider, actionCreatorGenerator, actionHandler, actionHandlerGenerator, addMessage, addQueryFilter$1 as addQueryFilter, apiReducer as api, apiCall, apiMessage, arrayObjToCamelCase, authReducer as auth, camelcase, checkStrength, colorLuminance, configReducer as config, consoleLogComponent, createCrud, crudActionsGenerator, crudReducerGenerator, deleteCrud, editCrud, environmentReducer as environment, findValueByKeyName, findValueByKeyNameArray, getAccessToken, getActualTime, getBreakpoints, getBrowserUserAgent, getCrud, getCrudInitialState, getDataFilter, getDataPagination, getDateISO, getDateTimeISO, getDeviceType, getFieldRefCondition, getRandomText, getTimeISO, getUnique, getUsernameShort, hexToRgbA, CBReactKitState as initSettings, initialReactKitState, isAuthenticated, isClassComponent, isCompositeTypeElement, isDOMTypeElement, isElement, isEmpty, isEmptyObject, isFunctionComponent, isReactComponent, loginSuccess, logout, messagesReducer as messages, prepareApiFilter, prepareApiFilterForPagination, prepareCrud, prepareFilterOperator, prepareTable, reducerGenerator, removeMessage, resetDataCrud$1 as resetDataCrud, resetPrepareCrud$1 as resetPrepareCrud, resetPrepareTable$1 as resetPrepareTable, resetSelectedCrud$1 as resetSelectedCrud, selectedCrud$1 as selectedCrud, setCrudDialog, setEnvironmentWithUserType, sortValues, typeGenerator };